<div class="row ss-top-menu">
  <div class="col-12">
    <span class="ss-link" style="vertical-align: -webkit-baseline-middle;" routerLink="/">Dashboard</span>
    <span style="vertical-align: -webkit-baseline-middle;"><i class="rightArrow fa fa-angle-right"></i> </span>

    <span class="ss-link" style="vertical-align: -webkit-baseline-middle;" routerLink="/community_manager/wip" *ngIf="role=='community_manager'">Wip</span>
    <span class="ss-link" style="vertical-align: -webkit-baseline-middle;" routerLink="/designer/wip" *ngIf="role=='designer'">Wip</span>
    <span style="vertical-align: -webkit-baseline-middle;"><i class="rightArrow fa fa-angle-right"></i> </span>

    <span class="ss-link" style="vertical-align: -webkit-baseline-middle;" [routerLink]="['/community_manager/leads']" [queryParams]="{lead_status: lead_details.lead_status}" *ngIf="lead_details && role=='community_manager'">Lead</span>
    <span class="ss-link" style="vertical-align: -webkit-baseline-middle;" [routerLink]="['/designer/leads']" [queryParams]="{customer_status: lead_details.lead_status}" *ngIf="role=='designer' && lead_details">Lead</span>
    <span style="vertical-align: -webkit-baseline-middle;"><i class="rightArrow fa fa-angle-right"></i> </span>

    <span class="ss-link capitalize" style="vertical-align: -webkit-baseline-middle;" *ngIf="lead_details && lead_details.project_details">{{lead_details.name}} - {{lead_details.project_details.name}}</span>
    <span style="vertical-align: -webkit-baseline-middle;"><i class="rightArrow fa fa-angle-right"></i> </span>

    <span class="ss-link" style="vertical-align: -webkit-baseline-middle;" (click) = "this.backClicked()">BOQ</span>
    <span style="vertical-align: -webkit-baseline-middle;"> <i class="rightArrow fa fa-angle-right"></i>  </span>

    <span class="ss-text-dark" style="vertical-align: -webkit-baseline-middle;" *ngIf="quotations">{{quotations.reference_number}}</span>
  </div>
</div>

<div class="rk-ui-notification" *ngIf="successalert">
  <span id="notificationMessageText">{{successMessage}}</span>
  <a class="close rk-linknotification" (click)="successalert=false">×</a>
</div>
<div class="rk-ui-notification err" *ngIf="erroralert">
  <span id="notificationMessageText">{{errorMessage}}</span>
  <a class="close rk-linknotification" (click)="erroralert=false">×</a>
</div>

<div class="row">
    
  <div class="col-12 mt-2 mb-1">
    <div class="pull-right">
      <ng-container *ngIf="quotations && quotations.status!='shared' && quotations.status!='paid' && quotations.copied != true && quotations.status != 'rejected'"><div class="iconBox addCursor mr-1" (click)="editButtonClick()" id="editPencilIcon" *ngIf="!editBtnFlag"> <i class="fa fa-pencil"></i></div></ng-container>
      <ng-container *ngIf="quotations && (quotations.status=='draft' || quotations.status=='pending') && quotations.parent_quotation_id==null"><div class="iconBox addCursor mr-1" (click)="deleteBoq(quotations.id)"> <i class="fa fa-trash"></i></div></ng-container>
      <button class="cartBtn pull-right addCursor" data-toggle="modal" data-target="#addsectionmodal" *ngIf="selectedSections && selectedSections.length<5 && editBtnFlag">Add Section</button>
      <button class="cartBtn pull-right addCursor mx-2" data-toggle="modal" data-target="#deletesectionmodal" *ngIf="selectedSections && selectedSections.length>0 && editBtnFlag">Delete Section</button>
      <button (click)="recalculateBoqAmt()" class="cartBtn mr-3 ml-3" *ngIf="!editBtnFlag">Recalculate Amount</button>
    </div>
  </div>
</div>

<div id="navcontainer">
  <ul class="nav nav-tabs tabs-chng" id="myTab" role="tablist" *ngIf="selectedSections">
    <li class="nav-item nav-items" *ngFor="let sec of selectedSections" >
      <a class="nav-link addCursor text-center mr-3" [ngClass]="{'active': selectedsectionName == sec}" (click)="changeSectionTab(sec)">{{sec | replaceChar | uppercase}}</a>
    </li>
  </ul>
</div>
<div class="container-fluid container-set mb-3" [ngClass]="(selectedSections && selectedSections.length>0)?'d-block':'d-none'">
  <div class="row rowContainer" style="padding: 16px;" id="globalVarRowForMW">
    <div class="col-md-12" *ngIf="quotations">
      <h6 class="mb-3 borderbottom pt-3 pb-3"><span class="mr-3">BOQ : {{quotations.reference_number}}</span><span class="pull-right">Total - &#8377; {{quotations.total_amount}}</span></h6>
      <div class="col-md-12 borderbottom pt-1 pb-2 mb-3 addCursor" id="selectedGlobalVarLink"   data-toggle="modal" data-target="#selectedGlobalVarModal" style="color: #8c031f;" *ngIf="globalVarArr && boqConfigMWVal!=undefined" (click)="getBoqConfig('wardrobe')">Selected Global Variable</div>
      <div class="col-md-12 my-3 text-center" *ngIf="globalVarArr && boqConfigMWVal==undefined && editBtnFlag">
        <button (click)="getGlobalPresets('wardrobe',1)" data-target="#listPresetModal" data-toggle="modal" class="rk-interalBtnColor addCursor">Choose Global Preset</button>
        <span class="mr-3 ml-3">OR</span>
        <button class="rk-interalBtnColor addCursor" data-target="#setGlobalConfigModal" data-toggle="modal">Create Global Variables</button>
      </div>
      <div class="col-md-12 borderbottom pt-3 pb-3" *ngIf="editBtnFlag && globalVarArr && boqConfigMWVal!=undefined">
        <div class="row" >
            <div class="col-md-3"><span>Enter Space</span></div>
            <div class="col-md-6">
                <form [formGroup]="addSpaceMWForm">
                    <select class="form-control" style="width: 70%; display: inline-block;" formControlName="space">
                        <option value="">Select</option>
                        <option *ngFor="let space of availableSpaces" value="{{space}}">{{space}}</option>
                    </select>
                    <img src="./assets/img/dashboard/submit.png" (click)="createSpace(addSpaceMWForm.value,'wardrobe')">
                </form>
            </div>
        </div>
      </div>
      <div id="accordion">
        <div class="card mb-2" *ngFor="let selSpace of quotations.spaces; let k=index; ">
          <div class="card-header" id="spaceCard{{k}}">
              <h5 class="mb-0">
                  <button class="btn btn-link addCursor" data-toggle="collapse" [attr.data-target]=" '#collapseSpaceCard'+k" aria-expanded="true" aria-controls="collapseOne">
                  {{selSpace}}
                  </button>
                  <ng-container *ngFor="let key1 of Object.keys(quotations.space_amounts_wardrobe); let n =index; "><span *ngIf="key1==selSpace" style="font-size: 14px;" class="pull-right">Total - &#8377; {{quotations.space_amounts_wardrobe[key1]}}</span></ng-container>
              </h5>
              <div class="pull-right col-md-12 text-right" *ngIf="editBtnFlag">
                <button (click)="openImportLayoutModal('wardrobe',selSpace)" class="addCursor">Import Layout</button>
                <ng-container *ngIf="Object.keys(quotations.modular_jobs_wardrobe).length>0 && 
                            Object.keys(quotations.modular_jobs_wardrobe).includes(selSpace) && 
                            quotations.modular_jobs_wardrobe[selSpace].length>0">
                  <button data-target="#saveMkwLayoutModal" data-toggle="modal" (click)="openMkwlayout(selSpace,'wardrobe')" class="addCursor">Save As Layout</button>
                </ng-container>
                <button [attr.data-target]=" '#collapseSpaceCard'+k" aria-expanded="true" aria-controls="collapseOne" (click)="displayAddModuleForm(k,'wardrobe')" class="addCursor">Add Module</button>
                <button (click)="spaceDelete(selSpace,'wardrobe')" class="addCursor">Delete Space</button>
              </div>
              <div class="pull-right col-md-12 text-right mt-2" *ngIf="editBtnFlag">
                <label class="text-left mr-2">Upload KDMax Excel</label>
                <input type="file" class="form-control" (change)="onChange($event)" name="attachment_file" ngModel #attachment_file="ngModel" style="display:inline-block;width: 30%;">
                <button (click)="uploadKdMaxExcel(selSpace,'wardrobe',k)" [disabled]="basefile==undefined" class="cartBtn">Upload</button>
                <div class="col-md-12 d-none mt-2 text-left" id="kdmax_errorblock{{k}}">
                    <div class="alert alert-danger" >
                        <a class="close rk-linknotification mr-3 mt-1" (click)="closeKdmax_errorblock(k)">×</a>
                        <ng-container *ngFor=" let err of this.quotations.errors">
                            <span><strong>Code - </strong> {{err.code}}</span><br>
                            <span><strong>Message - </strong> {{err.message}}</span><br>
                            <p style=" padding-top: 10px;border-bottom: 1px solid #f5c6cb;"></p>
                        </ng-container>
                    </div>
                </div>
              </div>
          </div>
          <div id="collapseSpaceCard{{k}}" class="collapse" [attr.aria-labelledby]="'spaceCard'+k" data-parent="#accordion">
            <div class="card-body">
              <div id="addModuleFormRow{{k}}" class="d-none hideFormRow">
                <h5 class="">Add Module</h5>
                <form [formGroup]="addModuleForm">
                    <div class="row">
                        <div class="col-md-3">
                          <ng-select formControlName="module_type" (change)="getModuleOfModuleType($event)">
                            <ng-option value="" >Choose Type</ng-option>
                            <ng-option *ngFor="let mt of moduletypesArr" value="{{mt | json}}">{{mt.name}}</ng-option>
                          </ng-select>
                        </div>
                        <div class="col-md-3">
                          <a (click)="openModuleModal(modulesArr,'wardrobe')" class="addCursor" style="color: blue;">Choose Module</a>
                          <span class="ml-2 rk-form-fontsize">{{addModuleForm.controls['module_code'].value}}</span>
                        </div>
                        <div class="col-md-3">
                          <input type="number" name="" class="form-control rk-form-fontsize" placeholder="Enter Quantity" formControlName="qty" min="0">
                        </div>
                        <ng-container *ngIf="customizable_dim_data_for_module_mw && customizable_dim_data_for_module_mw.dimensions=='WDH'">
                          <div class="col-md-3">
                            <input type="number" name="" class="form-control rk-form-fontsize" placeholder="Enter Width" formControlName="width" min="0" readonly>
                          </div>
                          <div class="col-md-3 mt-2">
                            <input type="number" name="" class="form-control rk-form-fontsize" placeholder="Enter Depth" formControlName="depth" min="0" readonly>
                          </div>
                          <div class="col-md-3 mt-2">
                            <input type="number" name="" class="form-control rk-form-fontsize" placeholder="Enter Height" formControlName="height" min="0" readonly>
                          </div>
                        </ng-container>
                        <ng-container *ngIf="customizable_dim_data_for_module_mw && customizable_dim_data_for_module_mw.dimensions=='LBT'">
                          <div class="col-md-3">
                            <ng-select formControlName="thickness">
                              <ng-option value="" disabled>Select Thickness</ng-option>
                              <ng-option *ngFor="let val of customizable_dim_data_for_module_mw.allowed_T" value="{{val}}">{{val}}</ng-option>
                            </ng-select>
                          </div>
                          <div class="col-md-3 mt-2">
                            <input type="number" name="" class="form-control rk-form-fontsize" placeholder="Enter Length" formControlName="length" min="0">
                          </div>
                          <div class="col-md-3 mt-2">
                            <input type="number" name="" class="form-control rk-form-fontsize" placeholder="Enter Breadth" formControlName="breadth" min="0">
                          </div>
                        </ng-container>
                    </div>
                    <div class="row mt-2">
                      <div class="col-md-12 text-right">
                        <button [disabled]="!addModuleForm.valid" (click)="addModule(addModuleForm.value,selSpace,'wardrobe',k)" class="rk-interalBtnColor addCursor" [ngClass]="{'cursor-notallowed':!addModuleForm.valid}">ADD</button>
                      </div>
                    </div>
                </form>
              </div>
              <ng-container *ngFor="let key of Object.keys(quotations.modular_jobs_wardrobe); let m =index; ">
                <div *ngIf="key==selSpace" class="tableDiv mt-3">
                  <button class="rk-interalBtnColor pull-right" (click)="setCombineModuleData(quotations.modular_jobs_wardrobe[key])" *ngIf="(quotations.modular_jobs_wardrobe[key].length>=2) && editBtnFlag" data-toggle="modal" data-target="#combinedmodulesModal">Combine Module</button>
                  <table class="table">
                      <thead class="thead-dark">
                          <tr>
                              <th class="firstTh">#</th>
                              <th>Type</th>
                              <th>Module</th>
                              <th>Quantity</th>
                              <th>Price</th>
                              <th>Dimensions(mm)</th>
                              <th>Image</th>
                              <th>Customization</th>
                              <th class="lastTh" *ngIf="editBtnFlag"></th>
                          </tr>
                      </thead>
                      <tbody>
                          <ng-container *ngFor="let mod of quotations.modular_jobs_wardrobe[key]; let k=index; ">
                              <tr *ngIf="!mod.combined">
                                  <td>{{k+1}}</td>
                                  <td>{{mod.module_type}}</td>
                                  <td>{{mod.code}}</td>
                                  <td>
                                      <span class="moduleLineItemSpan{{k}}">{{mod.quantity}}</span>
                                      <input type="number" name="" class="form-control d-none moduleLineItemInput{{k}}" [(ngModel)]="editModuleLineQty">
                                  </td>
                                  <td>{{mod.amount}}</td>
                                  <td class="minWidthForTd">
                                    <span class="moduleLineItemSpan{{k}}">
                                      {{mod.dimensions}}
                                      <!-- <ng-container *ngIf="mod.customizable_dimensions.dimensions=='LBT'">{{mod.length}} X {{mod.breadth}} X {{mod.thickness}} LBT</ng-container>
                                      <ng-container *ngIf="mod.customizable_dimensions.dimensions=='WDH'">{{mod.width}} X {{mod.depth}} X {{mod.height}} WDH</ng-container> -->
                                    </span>
                                    <ng-container *ngIf="mod.customizable_dimensions.dimensions=='WDH'">
                                      <div class="input-group d-none moduleLineItemInput{{k}} my-1">
                                        <span class="input-group-addon rk-form-fontsize">Width</span>
                                        <input type="number" name="" class="form-control rk-form-fontsize" [(ngModel)]="editModuleLineWidth" readonly>
                                      </div>
                                      <div class="input-group d-none moduleLineItemInput{{k}} my-1">
                                        <span class="input-group-addon rk-form-fontsize">Depth</span>
                                        <input type="number" name="" class="form-control rk-form-fontsize" [(ngModel)]="editModuleLineDepth" readonly>
                                      </div>
                                      <div class="input-group my-1 d-none moduleLineItemInput{{k}}">
                                        <span class="input-group-addon rk-form-fontsize">Height</span>
                                        <input type="number" name="" class="form-control rk-form-fontsize" [(ngModel)]="editModuleLineHeight" readonly>
                                      </div>
                                    </ng-container>
                                    <ng-container *ngIf="mod.customizable_dimensions.dimensions=='LBT'">
                                      <div class="input-group my-1 d-none moduleLineItemInput{{k}}">
                                        <span class="input-group-addon rk-form-fontsize">Length</span>
                                        <input type="number" name="" class="form-control  rk-form-fontsize" [(ngModel)]="editModuleLineLength">
                                      </div>
                                      <div class="input-group d-none moduleLineItemInput{{k}} my-1">
                                        <span class="input-group-addon rk-form-fontsize">Breadth</span>
                                        <input type="number" name="" class="form-control  rk-form-fontsize" [(ngModel)]="editModuleLineBreadth">
                                      </div>
                                      <div class="input-group d-none moduleLineItemInput{{k}} my-1">
                                        <ng-select [(ngModel)]="editModuleLineThickness" class="rk-form-fontsize" style="width: 100%">
                                          <ng-option value="" disabled>Select Thickness</ng-option>
                                          <ng-option *ngFor="let val of mod.customizable_dimensions.allowed_T" [value]="val">{{val}}</ng-option>
                                        </ng-select>
                                      </div>
                                    </ng-container>
                                  </td>
                                  <td>
                                      <img src="{{mod.module_image_url}}" *ngIf="mod.module_image_url" style="width: 100px;" onerror="this.src='./assets/img/no_image.svg';" alt="Missing Image">
                                  </td>
                                  <td>

                                      <img src="assets/v3/img/gear.svg" (click)="getCustomizationOfModule(mod.id)" data-toggle="modal" data-target="#customizationModal">
                                  </td>
                                  <td *ngIf="editBtnFlag">
                                      <button class="d-none moduleLineItemInput{{k}} rk-interalBtnColor mx-2 editRowButton addCursor mt-1" (click)="updateModule(k,mod,'wardrobe')">Update</button>
                                      <button class="d-none moduleLineItemInput{{k}} rk-btnCancel addCursor mx-2 mt-1" (click)="cancelModuleLineItem(k,mod)">Cancel</button>
                                      <i class="ion-android-more-vertical  ss-3-dot-drop moduleLineItemSpan{{k}}" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false"></i>
                                      <div class="dropdown-menu pt-2 pb-2" style="font-size: 14px;">
                                          <a class="dropdown-item addCursor" (click)="editmoduleLineItem(k,mod)">Edit</a>
                                          <a class="dropdown-item addCursor" (click)="moduleDelete(mod.id,mod.space,mod.category)">Delete</a>
                                      </div>
                                  </td>
                              </tr>
                              <tr id="package{{k}}" class="accordion-toggle addCursor" data-toggle="collapse" data-parent="#OrderPackages" [attr.data-target]="'.packageDetails'+k" *ngIf="mod.combined" (click)="showAccordion(k)" style="font-weight: normal;">
                                  <td>{{k+1}}</td>
                                  <td>Combined</td>
                                  <td>{{mod.name}}</td>
                                  <td>{{mod.quantity}}</td>
                                  <td>{{mod.amount}}</td>
                                  <td></td>
                                  <td>
                                      <img src="{{mod.module_image_url}}" *ngIf="mod.module_image_url" style="width: 100px;" onerror="this.src='./assets/img/no_image.svg';" alt="Missing Image">
                                  </td>
                                  <td></td>
                                  <td *ngIf="editBtnFlag">
                                      <i class="ion-android-more-vertical  ss-3-dot-drop moduleLineItemSpan{{k}}" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false"></i>
                                      <i class="fa fa-angle-up pull-right"></i>
                                      <div class="dropdown-menu pt-2 pb-2" style="font-size: 14px;">
                                          <a class="dropdown-item addCursor" (click)="show_EditCombModModal(k,mod); setCombineModuleData(quotations.modular_jobs_wardrobe[key])" data-toggle="modal" data-target="#editCombineModuleModal">Edit</a>
                                          <a class="dropdown-item addCursor" (click)="moduleDelete(mod.id,mod.space,mod.category,true)">Remove Combination</a>
                                      </div>
                                  </td>
                              </tr>
                              <tr class="d-none combmoduleAccordionRow{{k}}" id="combmoduleAccordionRow{{k}}" *ngIf="mod.combined">
                                  <td colspan="9" class="hiddenRow" style="border: 1px solid #eceaea;border-radius: 5px;">
                                      <div class="accordion-body collapse packageDetails{{k}}" id="accordion_{{k}}">
                                          <table class="table">
                                              <tr *ngFor="let cmod of mod.included_modules; let m=index; ">
                                                  <td>{{m+1}}</td>
                                                  <td>{{cmod.module_type}}</td>
                                                  <td>{{cmod.code}}</td>
                                                  <td>
                                                      <span class="moduleLineItemSpan{{k}}{{m}}">{{cmod.quantity}}</span>
                                                      <input type="number" name="" class="form-control d-none moduleLineItemInput{{k}}{{m}}" [(ngModel)]="editModuleLineQty">
                                                  </td>
                                                  <td>{{cmod.amount}}</td>
                                                  <td class="minWidthForTd">
                                                    <span class="moduleLineItemSpan{{k}}{{m}}">
                                                      {{cmod.dimensions}}
                                                      <!-- <ng-container *ngIf="cmod.customizable_dimensions.dimensions=='LBT'">{{cmod.length}} X {{cmod.breadth}} X {{cmod.thickness}} (LBT)</ng-container>
                                                      <ng-container *ngIf="cmod.customizable_dimensions.dimensions=='WDH'">{{cmod.width}} X {{cmod.depth}} X {{cmod.height}} (WDH)</ng-container> -->
                                                    </span>
                                                    <ng-container *ngIf="cmod.customizable_dimensions.dimensions=='WDH'">
                                                      <div class="input-group d-none moduleLineItemInput{{k}}{{m}} my-1">
                                                        <span class="input-group-addon rk-form-fontsize">Width</span>
                                                        <input type="number" name="" class="form-control rk-form-fontsize" [(ngModel)]="editModuleLineWidth" readonly>
                                                      </div>
                                                      <div class="input-group d-none moduleLineItemInput{{k}}{{m}} my-1">
                                                        <span class="input-group-addon rk-form-fontsize">Depth</span>
                                                        <input type="number" name="" class="form-control rk-form-fontsize" [(ngModel)]="editModuleLineDepth" readonly>
                                                      </div>
                                                      <div class="input-group my-1 d-none moduleLineItemInput{{k}}{{m}}">
                                                        <span class="input-group-addon rk-form-fontsize">Height</span>
                                                        <input type="number" name="" class="form-control rk-form-fontsize" [(ngModel)]="editModuleLineHeight" readonly>
                                                      </div>
                                                    </ng-container>
                                                    <ng-container *ngIf="cmod.customizable_dimensions.dimensions=='LBT'">
                                                      <div class="input-group my-1 d-none moduleLineItemInput{{k}}{{m}}">
                                                        <span class="input-group-addon rk-form-fontsize">Length</span>
                                                        <input type="number" name="" class="form-control  rk-form-fontsize" [(ngModel)]="editModuleLineLength">
                                                      </div>
                                                      <div class="input-group d-none moduleLineItemInput{{k}}{{m}} my-1">
                                                        <span class="input-group-addon rk-form-fontsize">Breadth</span>
                                                        <input type="number" name="" class="form-control  rk-form-fontsize" [(ngModel)]="editModuleLineBreadth">
                                                      </div>
                                                      <div class="input-group d-none moduleLineItemInput{{k}}{{m}} my-1">
                                                        <ng-select [(ngModel)]="editModuleLineThickness" class="rk-form-fontsize" style="width: 100%">
                                                          <ng-option value="" disabled>Select Thickness</ng-option>
                                                          <ng-option *ngFor="let val of cmod.customizable_dimensions.allowed_T" [value]="val">{{val}}</ng-option>
                                                        </ng-select>
                                                      </div>
                                                    </ng-container>
                                                  </td>
                                                  <td>
                                                      <img src="{{cmod.module_image_url}}" *ngIf="cmod.module_image_url" style="width: 100px;" onerror="this.src='./assets/img/no_image.svg';" alt="Missing Image">
                                                  </td>
                                                  <td>
                                                    <!-- <p>{{ cmod.id }}</p> -->
                                                    <img src="assets/v3/img/gear.svg" (click)="getCustomizationOfModule(cmod.id)" data-toggle="modal" data-target="#customizationModal">
                                                  </td>
                                                  <td *ngIf="editBtnFlag">
                                                      <button class="d-none moduleLineItemInput{{k}}{{m}} rk-interalBtnColor mx-2 editRowButton addCursor mt-1" (click)="updateModule(k,cmod,'wardrobe')">Update</button>
                                                      <button class="d-none moduleLineItemInput{{k}}{{m}} rk-btnCancel addCursor mx-2 mt-1" (click)="cancelCombineModuleLineItem(k,mod,m)">Cancel</button>
                                                      <i class="ion-android-more-vertical  ss-3-dot-drop moduleLineItemSpan{{k}}{{m}}" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false"></i>
                                                      <div class="dropdown-menu pt-2 pb-2" style="font-size: 14px;">
                                                          <a class="dropdown-item addCursor" (click)="editCombinemoduleLineItem(k,cmod,m)">Edit</a>
                                                          <a class="dropdown-item addCursor" (click)="moduleDelete(cmod.id,cmod.space,cmod.category)">Delete</a>
                                                      </div>
                                                  </td>
                                              </tr>

                                          </table>
                                      </div>
                                  </td>
                              </tr>
                          </ng-container>
                      </tbody>
                  </table>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12 pt-3 pb-3 text-right" *ngIf="editBtnFlag">
        <button class="mr-1 addCursor cartBtn" (click)="updateQuotation()">Update Quotation </button>
    </div>
  </div>
  <!--Kitchen starts-->
  <div class="row d-none rowContainer" style="padding: 16px;" id="globalVarRowForMK">
    <div class="col-md-12" *ngIf="quotations">
      <h6 class="mb-3 borderbottom pt-3 pb-3"><span class="mr-3">BOQ : {{quotations.reference_number}}</span><span class="pull-right">Total - &#8377; {{quotations.total_amount}}</span></h6>
      <div class="col-md-12 borderbottom pt-1 pb-2 mb-3 addCursor" id="selectedGlobalVarLink"   data-toggle="modal" data-target="#selectedGlobalVarModalMK" style="color: #8c031f;" *ngIf="globalVarArr && boqConfigMKVal!=undefined " (click)="getBoqConfig('kitchen')">Selected Global Variable</div>
        <div class="col-md-12 my-3 text-center" *ngIf="globalVarArr && boqConfigMKVal==undefined && editBtnFlag">
            <button (click)="getGlobalPresets('kitchen',1)" data-target="#listPresetModal" data-toggle="modal" class="rk-interalBtnColor addCursor">Choose Global Preset</button>
            <span class="mr-3 ml-3">OR</span>
            <button class="rk-interalBtnColor addCursor" data-target="#setGlobalConfigModal" data-toggle="modal">Create Global Variables</button>
        </div>
        <div class="col-md-12 borderbottom pt-3 pb-3"  *ngIf="quotations && quotations.countertop_cost!=0 && quotations.countertop_cost!=null">
          <span class="addCursor" style="color: #8c031f;">Countertop -</span> <span class="capitalize" style="font-size: 14px;">{{quotations.countertop_details.countertop | replaceChar}} - &#8377; {{quotations.countertop_details.price}}</span>
          <span class="addCursor ml-4" style="color: #8c031f;" *ngIf="quotations.countertop_details.countertop_width">Countertop Length - </span><span style="font-size: 14px;" *ngIf="quotations.countertop_details.countertop_width">{{quotations.countertop_details.countertop_width}} mm</span>
            <button style="padding: 2px 6px;" (click)="showCountertopLengthForm()" class="rk-interalBtnColor addCursor ml-3" id="countertopLenChangeBtn" *ngIf="editBtnFlag">Change Length</button>
            <form class="d-none mt-4" id="countertopLengthForm">
                <h6>Change Counter Top Length</h6>
                <input type="number" name="countertoplength" [(ngModel)]="countertop_width_globalVar_MK" placeholder="Enter Length" class="form-control d-inline" style="width: 25%" min="0">
                <button class="cartBtn" (click)="changeCountertopLenSubmit(countertop_width_globalVar_MK)" [disabled]="countertop_width_globalVar_MK==undefined || countertop_width_globalVar_MK==''">Change</button>
                <button class="rk-btnCancel" (click)="hideCountertopLengthForm()">Cancel</button>
            </form>
        </div>
        <div class="col-md-12 borderbottom pt-3 pb-3" *ngIf="editBtnFlag && globalVarArr && boqConfigMKVal!=undefined">
            <div class="row" >
                <div class="col-md-3"><span>Enter Space</span></div>
                <div class="col-md-6">
                    <form [formGroup]="addSpaceMWForm">
                        <select class="form-control" style="width: 70%; display: inline-block;" formControlName="space">
                            <option value="">Select</option>
                            <option *ngFor="let space of availableSpaces" value="{{space}}">{{space}}</option>
                        </select>
                        <img src="./assets/img/dashboard/submit.png" (click)="createSpace(addSpaceMWForm.value,'kitchen')">
                    </form>
                </div>
            </div>
        </div>
        <div id="accordion">
            <div class="card mb-2" *ngFor="let selSpaceMk of quotations.spaces_kitchen; let k1=index; ">
              <div class="card-header" id="spaceCardMk{{k1}}">
                  <h5 class="mb-0">
                      <button class="btn btn-link addCursor" data-toggle="collapse" [attr.data-target]=" '#collapseSpaceCardMk'+k1" aria-expanded="true" aria-controls="collapsetwo">
                      {{selSpaceMk}}
                      </button>
                      <ng-container *ngFor="let key2 of Object.keys(quotations.space_amounts_kitchen); let n =index; "><span *ngIf="key2==selSpaceMk" style="font-size: 14px;" class="pull-right">Total - &#8377; {{quotations.space_amounts_kitchen[key2]}}</span></ng-container>
                  </h5>
                  <div class="pull-right col-md-12 text-right" *ngIf="editBtnFlag">
                    <button (click)="openImportLayoutModal('kitchen',selSpaceMk)" class="addCursor">Import Layout</button>
                    <ng-container *ngIf="(Object.keys(quotations.modular_jobs_kitchen).length>0 && Object.keys(quotations.modular_jobs_kitchen).includes(selSpaceMk) && 
                    quotations.modular_jobs_kitchen[selSpaceMk].length>0) || (Object.keys(quotations.appliance_jobs).length>0 && 
                    Object.keys(quotations.appliance_jobs).includes(selSpaceMk) && 
                    quotations.appliance_jobs[selSpaceMk].length>0) || Object.keys(quotations.extra_jobs).length>0 && 
                    Object.keys(quotations.extra_jobs).includes(selSpaceMk) && 
                    quotations.extra_jobs[selSpaceMk].length>0">
                      <button data-target="#saveMkwLayoutModal" data-toggle="modal" (click)="openMkwlayout(selSpaceMk,'kitchen')" class="addCursor">Save As Layout</button>
                    </ng-container>
                    <button [attr.data-target]=" '#collapseSpaceCardMk'+k1" aria-expanded="true" aria-controls="collapseOne" (click)="displayAddModuleForm(k1,'kitchen')" class="addCursor">Add Module</button>
                    <button [attr.data-target]=" '#collapseSpaceCardMk'+k1" aria-expanded="true" aria-controls="collapseOne" (click)="displayAddApplianceForm(k1,'kitchen')" class="addCursor">Add Appliance</button>
                    <button [attr.data-target]=" '#collapseSpaceCardMk'+k1" aria-expanded="true" aria-controls="collapseOne" (click)="getKitchenExtras();setSpaceForExtra(selSpaceMk)" class="addCursor"><span data-toggle="modal" data-target="#addExtrasModal">Add Extra</span></button>
                    <button (click)="spaceDelete(selSpaceMk,'kitchen')" class="addCursor">Delete Space</button>
                  </div>
                  <div class="pull-right col-md-12 text-right mt-2" *ngIf="editBtnFlag">
                    <label class="text-left mr-2">Upload KDMax Excel</label>
                    <input type="file" class="form-control" (change)="onChange($event)" name="attachment_file" ngModel #attachment_file="ngModel" style="display:inline-block;width: 30%;">
                    <button (click)="uploadKdMaxExcel(selSpaceMk,'kitchen',k1)" [disabled]="basefile==undefined" class="cartBtn">Upload</button>
                    <div class="col-md-12 d-none mt-2 text-left" id="kdmax_errorblock{{k1}}">
                        <div class="alert alert-danger" >
                            <a class="close rk-linknotification mr-3 mt-1" (click)="closeKdmax_errorblock(k1)">×</a>
                            <ng-container *ngFor=" let err of this.quotations.errors">
                                <span><strong>Code - </strong> {{err.code}}</span><br>
                                <span><strong>Message - </strong> {{err.message}}</span><br>
                                <p style=" padding-top: 10px;border-bottom: 1px solid #f5c6cb;"></p>
                            </ng-container>
                        </div>
                    </div>
                  </div>
              </div>
              <div id="collapseSpaceCardMk{{k1}}" class="collapse" [attr.aria-labelledby]="'spaceCardMk'+k1" data-parent="#accordionMk">
                <div class="card-body">
                  <div id="addModuleFormRowMk{{k1}}" class="d-none hideFormRow">
                    <h5 class="">Add Module</h5>
                    <form [formGroup]="addModuleFormMk">
                        <div class="row">
                            <div class="col-md-3">
                                <ng-select formControlName="kitchen_category" (change)="getModuletypeOfKitchenCat($event)">
                                  <ng-option value="" >Choose Kitchen Category</ng-option>
                                  <ng-option *ngFor="let kc of kitchenCatArr" value="{{kc | json}}">{{kc.name}}</ng-option>
                                </ng-select>
                            </div>
                            <div class="col-md-3">
                                <ng-select formControlName="module_type" (change)="getModuleOfModuleType($event)">
                                  <ng-option value="" >Choose Type</ng-option>
                                  <ng-option *ngFor="let mt of moduletypesArr" value="{{mt | json}}">{{mt.name}}</ng-option>
                                </ng-select>
                            </div>
                            <div class="col-md-3">
                                <a (click)="openModuleModal(modulesArr,'kitchen')"  class="addCursor" style="color: blue;">Choose Module</a>
                                <span class="ml-2 rk-form-fontsize">{{addModuleFormMk.controls['module_code'].value}}</span>
                            </div>
                            <div class="col-md-3">
                                <input type="number" name="" class="form-control rk-form-fontsize" placeholder="Enter Quantity" formControlName="qty" min="0">
                            </div>
                            <ng-container *ngIf="customizable_dim_data_for_module_mk && customizable_dim_data_for_module_mk.dimensions=='WDH'">
                              <div class="col-md-3 mt-2">
                                <input type="number" name="" class="form-control rk-form-fontsize" placeholder="Enter Width in mm" formControlName="width" min="0" readonly>
                              </div>
                              <div class="col-md-3 mt-2">
                                <input type="number" name="" class="form-control rk-form-fontsize" placeholder="Enter Depth in mm" formControlName="depth" min="0" readonly>
                              </div>
                              <div class="col-md-3 mt-2">
                                <input type="number" name="" class="form-control rk-form-fontsize" placeholder="Enter Height in mm" formControlName="height" min="0" readonly> 
                              </div>
                            </ng-container>
                            <ng-container *ngIf="customizable_dim_data_for_module_mk && customizable_dim_data_for_module_mk.dimensions=='LBT'">
                              <div class="col-md-3 mt-2">
                                <ng-select formControlName="thickness">
                                  <ng-option value="" disabled>Select Thickness</ng-option>
                                  <ng-option *ngFor="let val of customizable_dim_data_for_module_mk.allowed_T" value="{{val}}">{{val}}</ng-option>
                                </ng-select>
                              </div>
                              <div class="col-md-3 mt-2">
                                <input type="number" name="" class="form-control rk-form-fontsize" placeholder="Enter Length in mm" formControlName="length" min="0">
                              </div>
                              <div class="col-md-3 mt-2">
                                <input type="number" name="" class="form-control rk-form-fontsize" placeholder="Enter Breadth in mm" formControlName="breadth" min="0">
                              </div>
                            </ng-container>
                        </div>
                        <div class="row mt-2">
                          <div class="col-md-12 text-right">
                            <button [disabled]="!addModuleFormMk.valid" (click)="addModule(addModuleFormMk.value,selSpaceMk,'kitchen',k1)" class="rk-interalBtnColor addCursor" [ngClass]="{'cursor-notallowed':!addModuleFormMk.valid}">ADD</button>
                          </div>
                        </div>
                    </form>
                  </div>
                  <div id="addApplianceFormRowMk{{k1}}" class="d-none hideFormRow">
                    <h5 class="">Add Appliance</h5>
                    <form [formGroup]="addApplianceFormMk">
                      <div class="row">
                        <div class="col-md-3">
                            <select class="form-control" (change)="getApplianceOfModuleType($event.target.value)" formControlName="module_type_id">
                               <option value="">Choose Appliance Type</option>
                               <option *ngFor="let kat of kitchenApplianceTypesArr" value="{{kat.id}}">{{kat.name}}</option>
                            </select>
                        </div>
                        <div class="col-md-2">
                            <select class="form-control" formControlName="id">
                               <option value="">Choose Appliance</option>
                               <option *ngFor="let app of appliancesArr" value="{{app.id}}">{{app.name}}</option>
                            </select>
                        </div>
                        <div class="col-md-2">
                            <input type="number" name="" class="form-control rk-form-fontsize" placeholder="Enter Quantity" formControlName="qty" min="0">
                        </div>
                        <div class="col-md-2">
                            <button [disabled]="!addApplianceFormMk.valid" (click)="addAppliance(addApplianceFormMk.value,selSpaceMk,'kitchen',k1)" class="rk-interalBtnColor">ADD</button>
                        </div>
                      </div>
                    </form>
                  </div><br>
                  <div id="addExtraFormRowMk{{k1}}" class="d-none hideFormRow">
                    <h5 class="">Add Extra</h5>
                    <form [formGroup]="addExtraFormMk">
                        <div class="row">
                            <div class="col-md-3">
                                <select class="form-control" formControlName="id">
                                   <option value="">Choose Extra</option>
                                   <option *ngFor="let ext of kitchenExtras" value="{{ext.id}}">{{ext.name}}</option>
                                </select>
                            </div>
                            <div class="col-md-3">
                                <input type="number" name="" class="form-control rk-form-fontsize" placeholder="Enter Quantity" formControlName="qty" min="0">
                            </div>
                            <div class="col-md-2">
                                <button [disabled]="!addExtraFormMk.valid" (click)="addExtra(addExtraFormMk.value,selSpaceMk,k1)" class="rk-interalBtnColor">ADD</button>
                            </div>
                        </div>
                    </form>
                  </div><br>
                  <p *ngIf="Object.keys(quotations.modular_jobs_kitchen).length>0">Added Modules :</p>
                  <ng-container *ngFor="let key of Object.keys(quotations.modular_jobs_kitchen); let m1 =index; ">
                    <div *ngIf="key==selSpaceMk" class="tableDiv mt-3">
                      <table class="table">
                          <thead class="thead-dark">
                              <tr>
                                  <th class="firstTh">#</th>
                                  <th>Kitchen Category</th>
                                  <th>Type</th>
                                  <th>Module</th>
                                  <th>Quantity</th>
                                  <th>Price</th>
                                  <th>Dimensions(mm)</th>
                                  <th>Image</th>
                                  <th>Customization</th>
                                  <th class="lastTh" *ngIf="editBtnFlag"></th>
                                  <!-- <th class="lastTh">Global Configuration</th> -->
                              </tr>
                          </thead>
                          <tbody>
                              <tr *ngFor="let mod of quotations.modular_jobs_kitchen[key]; let k=index; ">
                                  <td>{{k+1}}</td>
                                  <td>{{mod.kitchen_category_name}}</td>
                                  <td>{{mod.module_type}}</td>
                                  <td>{{mod.code}}</td>
                                  <td>
                                      <span class="moduleLineItemSpan{{k}}">{{mod.quantity}}</span>
                                      <input type="number" name="" class="form-control d-none moduleLineItemInput{{k}}" [(ngModel)]="editModuleLineQty">
                                  </td>
                                  <td>{{mod.amount}}</td>
                                  <td class="minWidthForTd">
                                    <span class="moduleLineItemSpan{{k}}">
                                      {{mod.dimensions}}
                                     <!--  <ng-container *ngIf="mod.customizable_dimensions.dimensions=='LBT'">{{mod.length}} X {{mod.breadth}} X {{mod.thickness}} (LBT)</ng-container>
                                      <ng-container *ngIf="mod.customizable_dimensions.dimensions=='WDH'">{{mod.width}} X {{mod.depth}} X {{mod.height}} (WDH)</ng-container> -->
                                    </span>
                                    <ng-container *ngIf="mod.customizable_dimensions.dimensions=='WDH'">
                                      <div class="input-group d-none moduleLineItemInput{{k}} my-1">
                                        <span class="input-group-addon rk-form-fontsize">Width</span>
                                        <input type="number" name="" class="form-control rk-form-fontsize" [(ngModel)]="editModuleLineWidth" readonly>
                                      </div>
                                      <div class="input-group d-none moduleLineItemInput{{k}} my-1">
                                        <span class="input-group-addon rk-form-fontsize">Depth</span>
                                        <input type="number" name="" class="form-control rk-form-fontsize" [(ngModel)]="editModuleLineDepth" readonly>
                                      </div>
                                      <div class="input-group my-1 d-none moduleLineItemInput{{k}}">
                                        <span class="input-group-addon rk-form-fontsize">Height</span>
                                        <input type="number" name="" class="form-control rk-form-fontsize" [(ngModel)]="editModuleLineHeight" readonly>
                                      </div>
                                    </ng-container>
                                    <ng-container *ngIf="mod.customizable_dimensions.dimensions=='LBT'">
                                      <div class="input-group my-1 d-none moduleLineItemInput{{k}}">
                                        <span class="input-group-addon rk-form-fontsize">Length</span>
                                        <input type="number" name="" class="form-control  rk-form-fontsize" [(ngModel)]="editModuleLineLength">
                                      </div>
                                      <div class="input-group d-none moduleLineItemInput{{k}} my-1">
                                        <span class="input-group-addon rk-form-fontsize">Breadth</span>
                                        <input type="number" name="" class="form-control  rk-form-fontsize" [(ngModel)]="editModuleLineBreadth">
                                      </div>
                                      <div class="input-group d-none moduleLineItemInput{{k}} my-1">
                                        <ng-select [(ngModel)]="editModuleLineThickness" class="rk-form-fontsize" style="width: 100%">
                                          <ng-option value="" disabled>Select Thickness</ng-option>
                                          <ng-option *ngFor="let val of mod.customizable_dimensions.allowed_T" [value]="val">{{val}}</ng-option>
                                        </ng-select>
                                      </div>
                                    </ng-container>
                                  </td>
                                  <td>
                                      <img src="{{mod.module_image_url}}" *ngIf="mod.module_image_url" style="width: 100px;" onerror="this.src='./assets/img/no_image.svg';" alt="Missing Image">
                                  </td>
                                  <td>
                                    <img src="assets/v3/img/gear.svg" (click)="getCustomizationOfModule(mod.id)" data-toggle="modal" data-target="#customizationModalMk" class="addCursor">
                                  </td>
                                  <td *ngIf="editBtnFlag">
                                    <button class="d-none moduleLineItemInput{{k}} rk-interalBtnColor mx-2 editRowButton addCursor mt-1" (click)="updateModule(k,mod,'kitchen')">Update</button>
                                    <button class="d-none moduleLineItemInput{{k}} rk-btnCancel addCursor mx-2 mt-1" (click)="cancelModuleLineItem(k,mod)">Cancel</button>
                                    <i class="ion-android-more-vertical  ss-3-dot-drop moduleLineItemSpan{{k}}" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false"></i>
                                    <div class="dropdown-menu pt-2 pb-2" style="font-size: 14px;">
                                        <a class="dropdown-item addCursor" (click)="editmoduleLineItem(k,mod)">Edit</a>
                                        <a class="dropdown-item addCursor" (click)="moduleDelete(mod.id,mod.space,mod.category)">Delete</a>
                                    </div>
                                </td>
                              </tr>
                          </tbody>
                      </table>
                    </div>
                  </ng-container>
                  <p *ngIf="Object.keys(quotations.appliance_jobs).length>0">Added Appliances :</p>
                  <ng-container *ngFor="let key6 of Object.keys(quotations.appliance_jobs); let m6 =index; ">
                    <div *ngIf="key6==selSpaceMk" class="tableDiv mt-3">
                        <table class="table">
                          <thead class="thead-dark">
                              <tr>
                                  <th class="firstTh">#</th>
                                  <th>Appliance Type</th>
                                  <th>Appliance</th>
                                  <th>Make</th>
                                  <th>Vendor Sku</th>
                                  <th>Quantity</th>
                                  <th>Price</th>
                                  <th>Image</th>
                                  <th class="lastTh" *ngIf="editBtnFlag"></th>
                              </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let appjob of quotations.appliance_jobs[key6]; let k=index; ">
                              <td>{{k+1}}</td>
                              <td>{{appjob.subcategory}}</td>
                              <td>{{appjob.name}}</td>
                              <td>{{appjob.make}}</td>
                              <td>{{appjob.vendor_sku}}</td>
                              <td>
                                  <span class="applianceLineItemSpan{{k}}">{{appjob.quantity}}</span>
                                  <input type="number" name="" class="form-control d-none applianceLineItemInput{{k}}" [(ngModel)]="editApplianceLineQty">
                              </td>
                              <td>{{appjob.amount}}</td>
                              <td>
                                  <img src="{{appjob.image_url}}" *ngIf="appjob.image_url" style="width: 100px;" onerror="this.src='./assets/img/no_image.svg';" alt="Missing Image">
                              </td>
                              <td *ngIf="editBtnFlag">
                                  <button class="d-none applianceLineItemInput{{k}} rk-interalBtnColor mx-2 editRowButton mt-1" (click)="updateAppliance(k,appjob,'kitchen')">Update</button>
                                  <button class="d-none applianceLineItemInput{{k}} rk-btnCancel addCursor mx-2 mt-1" (click)="cancelApplianceLineItem(k,appjob)">Cancel</button>
                                  <i class="ion-android-more-vertical  ss-3-dot-drop applianceLineItemSpan{{k}}" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false"></i>
                                  <div class="dropdown-menu pt-2 pb-2" style="font-size: 14px;">
                                      <a class="dropdown-item addCursor" (click)="editApplianceLineItem(k,appjob)">Edit</a>
                                      <a class="dropdown-item addCursor" (click)="applianceDelete(appjob.id,appjob.space)">Delete</a>
                                  </div>
                              </td>
                            </tr>
                          </tbody>
                      </table>
                    </div>
                  </ng-container>
                  <p *ngIf="Object.keys(quotations.extra_jobs).length>0">Added Extras :</p>
                  <ng-container *ngFor="let key7 of Object.keys(quotations.extra_jobs); let m7 =index; ">
                    <div *ngIf="key7==selSpaceMk" class="tableDiv mt-3">
                        <table class="table">
                            <thead class="thead-dark">
                                <tr>
                                    <th class="firstTh">#</th>
                                    <th> Name</th>
                                    <th>Vendor Sku</th>
                                    <th>Make</th>
                                    <th>Specification</th>
                                    <th>Quantity</th>
                                    <th>Price</th>
                                    <th>Image</th>
                                    <th class="lastTh" *ngIf="editBtnFlag"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let extrajob of quotations.extra_jobs[key7]; let k=index; ">
                                    <td>{{k+1}}</td>
                                    <td>{{extrajob.name}}</td>
                                    <td>{{extrajob.vendor_sku}}</td>
                                    <td>{{extrajob.make}}</td>
                                    <td>{{extrajob.specifications}}</td>
                                    <td>
                                        <span class="extraLineItemSpan{{k}}">{{extrajob.quantity}}</span>
                                        <input type="number" name="" class="form-control d-none extraLineItemInput{{k}}" [(ngModel)]="editExtraLineQty">
                                    </td>
                                    <td>{{extrajob.amount}}</td>
                                    <td>
                                        <img src="{{extrajob.image_url}}" *ngIf="extrajob.image_url" style="width: 100px;" onerror="this.src='./assets/img/no_image.svg';" alt="Missing Image">
                                    </td>
                                    <td *ngIf="editBtnFlag">
                                        <button class="d-none extraLineItemInput{{k}} rk-interalBtnColor mx-2 editRowButton mt-1" (click)="updateExtra(k,extrajob,'kitchen')">Update</button>
                                        <button class="d-none extraLineItemInput{{k}} rk-btnCancel addCursor mx-2 mt-1" (click)="cancelExtraLineItem(k,extrajob)">Cancel</button>
                                        <i class="ion-android-more-vertical  ss-3-dot-drop extraLineItemSpan{{k}}" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false"></i>
                                        <div class="dropdown-menu pt-2 pb-2" style="font-size: 14px;">
                                            <a class="dropdown-item addCursor" (click)="editExtraLineItem(k,extrajob)">Edit</a>
                                            <a class="dropdown-item addCursor" (click)="extraDelete(extrajob.id,extrajob.space)">Delete</a>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
        </div>
    </div>
    <div class="col-md-12 pt-3 pb-3 text-right" *ngIf="editBtnFlag">
        <button class="mr-1 addCursor cartBtn" (click)="updateQuotation()">Update Quotation </button>
    </div>
  </div>
  <!--Kitchen ends-->

  <!--Loose furniture start-->
  <div class="row d-none rowContainer" style="padding: 16px" id="globalVarRowForLF">
    <div class="col-md-12">
      <h6 class="mb-3 borderbottom pt-3 pb-3" *ngIf="quotations"><span class="mr-3">BOQ : {{quotations.reference_number}}</span><span class="pull-right">Total - &#8377; {{quotations.total_amount}}</span></h6>
    </div>
    <div class="col-md-12 borderbottom pt-3 pb-3" *ngIf="editBtnFlag">
        <div class="row">
            <div class="col-md-3"><span>Enter Space</span></div>
            <div class="col-md-6">
                <form [formGroup]="addSpaceMWForm">
                    <select class="form-control" style="width: 70%; display: inline-block;" formControlName="space">
                        <option value="">Select</option>
                        <option *ngFor="let space of availableSpaces" value="{{space}}">{{space}}</option>
                    </select>
                    <img src="./assets/img/dashboard/submit.png" (click)="createSpace(addSpaceMWForm.value,'loose_furniture')">
                </form>
            </div>
        </div>
    </div>
    <div class="col-md-12 pt-3 pb-3" *ngIf="selectedSpacesArrLf && selectedSpacesArrLf.length>0">
        <div id="accordionLf">
            <div class="card mb-2" *ngFor="let selSpaceLf of selectedSpacesArrLf; let k2=index; ">
                <div class="card-header" id="spaceCardLf{{k2}}">
                    <h5 class="mb-0">
                        <button class="btn btn-link fontsize1 addCursor" data-toggle="collapse" [attr.data-target]=" '#collapseSpaceCardLf'+k2" aria-expanded="true" aria-controls="collapseOne" >
                        {{selSpaceLf}}
                        </button>
                        <ng-container *ngFor="let key2 of Object.keys(quotations.space_amounts_loose); let n =index; "><span *ngIf="key2==selSpaceLf" style="font-size: 14px;" class="pull-right">Total - &#8377; {{quotations.space_amounts_loose[key2]}}</span></ng-container>
                        <!-- <ng-container><span style="font-size: 14px;" class="pull-right">Total - &#8377; <span id="spacesLfTotal{{k2}}">{{getTotalOfLfSpaces(selSpaceLf,k2)}}</span></span></ng-container> -->
                    </h5>

                    <div class=" col-md-12 text-right" *ngIf="editBtnFlag">
                        <button class="addCursor" (click)="openSmartBoqModal(selSpaceLf)">Generate Smart BOQ</button>
                        <button [attr.data-target]=" '#collapseSpaceCardLf'+k2" aria-expanded="true" aria-controls="collapseOne" (click)="openProductModal(selSpaceLf)"><span data-toggle="modal" data-target="#addProductModal" class="addCursor">Add Product</span></button>
                        <button (click)="spaceDelete(selSpaceLf,'loose_furniture')" class="addCursor">Delete Space</button>
                    </div>
                </div>

                <div id="collapseSpaceCardLf{{k2}}" class="collapse" [attr.aria-labelledby]="'spaceCardLf'+k2" data-parent="#accordionLf">
                    <div class="card-body">
                      <div class="">
                        <ng-container *ngFor="let keylf of Object.keys(quotations.boqjobs); let m5 =index;">
                          <div *ngIf="keylf==selSpaceLf" class="tableDiv mt-3">
                            <table class="table">
                              <thead class="thead-dark">
                                  <tr>
                                      <th class="firstTh">#</th>
                                      <th>NAME</th>
                                      <th>FINISH</th>
                                      <th>PRICE</th>
                                      <th>QTY</th>
                                      <th>TOTAL AMOUNT</th>
                                      <th>Image</th>
                                      <th class="lastTh"></th>
                                  </tr>
                              </thead>
                              <tbody>
                                <ng-container *ngFor="let addedproduct of quotations.boqjobs[keylf]; let k7=index; ">
                                  <tr>
                                    <td>{{k7+1}}</td>
                                    <td>{{addedproduct.name}}</td>
                                    <td>{{addedproduct.finish}}</td>
                                    <td>{{addedproduct.rate}}</td>
                                    <td>
                                        <span class="loosefurLineItemSpan{{k7}}">{{addedproduct.quantity}}</span>
                                        <input type="number" name="" class="form-control d-none loosefurLineItemInput{{k7}}" [(ngModel)]="editProductLineItemQty">
                                    </td>
                                    <td>{{addedproduct.amount}}</td>
                                    <td>
                                        <img class="" src="{{addedproduct.image_urls[0]}}" alt="No Image" height="100px" width="100px" *ngIf="addedproduct.image_urls[0]" onerror="this.src='./assets/img/no_image.svg'">
                                    </td>
                                    <td>
                                        <button class="d-none loosefurLineItemInput{{k7}} rk-interalBtnColor mx-2 editRowButton addCursor mt-1" (click)="updateProduct(k7,addedproduct)">Update</button>
                                        <button class="d-none loosefurLineItemInput{{k7}} rk-btnCancel addCursor mx-2 mt-1" (click)="cancelProductLineItem(k7,addedproduct)">Cancel</button>
                                        <i class="ion-android-more-vertical  ss-3-dot-drop loosefurLineItemSpan{{k7}}" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false"></i>
                                        <div class="dropdown-menu pt-2 pb-2" style="font-size: 14px;">
                                            <a class="dropdown-item addCursor" (click)="editProductLineItem(k7,addedproduct)">Edit</a>
                                            <a class="dropdown-item addCursor" (click)="removeProductToBoqs(addedproduct.id,addedproduct.name,selSpaceLf)">Delete</a>
                                        </div>
                                    </td>
                                  </tr>
                                </ng-container>
                              </tbody>
                            </table>
                          </div>
                        </ng-container>
                      </div>
                        <!-- <div class="" *ngIf="boqProducts && boqProducts.length>0">
                            <div class="tableDiv ">
                                <div class="">
                                  <table class="table ">
                                    <thead class="thead-dark">
                                      <tr>
                                        <th scope="col" class="firstTh">#</th>
                                        <th scope="col">NAME</th>
                                        <th scope="col">PRICE</th>
                                        <th scope="col">QTY</th>
                                        <th scope="col">TOTAL AMOUNT</th>
                                        <th scope="col">Product Image</th>
                                        <th class="lastTh" *ngIf="editBtnFlag"></th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                        <ng-container *ngFor="let addedproduct of boqProducts; let i = index; " [attr.data-index]="i">
                                            <tr class="box-list" *ngIf="addedproduct.space==selSpaceLf">
                                                <td>{{ i +1 }}</td>
                                                <td>{{addedproduct.name}}</td>
                                                <td><i class="fa fa-inr mr-1"></i>{{addedproduct.rate}}</td>
                                                <td>
                                                  <input type="number" name="quantity{{i}}" min="1" class="quantityInput form-control" id="product_{{addedproduct.id}}" value="{{ addedproduct.quantity }}" (input)="onInputQuantity($event.target.id,addedproduct)" *ngIf="editBtnFlag">
                                                  <span *ngIf="!editBtnFlag">{{ addedproduct.quantity }}</span>
                                                </td>
                                                <td><i class="fa fa-inr mr-1"></i>{{ addedproduct.quantity * addedproduct.rate}}</td>
                                                <td class="text-left">
                                                <img class="" src="{{addedproduct.image_urls[0]}}" alt="No Image" height="100px" width="100px" *ngIf="addedproduct.image_urls[0]" onerror="this.src='./assets/img/no_image.svg'">
                                                </td>
                                                <td *ngIf="editBtnFlag">
                                                  <i class="fa fa-trash deleteRow addCursor" id="delete_row{{i}}" (click)="removeProductToBoqs(addedproduct.product_id,addedproduct.name)"></i>
                                                </td>
                                            </tr>
                                       </ng-container>
                                    </tbody>
                                  </table>
                                </div>
                            </div>
                        </div> -->

                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-12 pt-3 pb-3 text-right" *ngIf="editBtnFlag">
        <button class="mr-1 addCursor cartBtn" (click)="updateQuotation()">Update Quotation </button>
    </div>
  </div>
  <!--Loose furniture ends-->

  <!--Services start-->
  <div class="row d-none rowContainer" style="padding: 16px" id="globalVarRowForSERV">
    <div class="col-md-12">
      <h6 class="mb-3 borderbottom pt-3 pb-3" *ngIf="quotations"><span class="mr-3">BOQ : {{quotations.reference_number}}</span><span class="pull-right">Total - &#8377; {{quotations.total_amount}}</span></h6>
    </div>
    <div class="col-md-12 borderbottom pt-3 pb-3" *ngIf="editBtnFlag">
        <div class="row">
            <div class="col-md-3"><span>Enter Space</span></div>
            <div class="col-md-6">
                <form [formGroup]="addSpaceMWForm">
                    <select class="form-control" style="width: 70%; display: inline-block;" formControlName="space">
                        <option value="">Select</option>
                        <option *ngFor="let space of availableSpaces" value="{{space}}">{{space}}</option>
                    </select>
                    <img src="./assets/img/dashboard/submit.png" (click)="createSpace(addSpaceMWForm.value,'services')">
                </form>
            </div>
        </div>
    </div>
    <div class="col-md-12 pt-3 pb-3" *ngIf="selectedSpacesArrSERV && selectedSpacesArrSERV.length>0">
        <div id="accordionSERV">
            <div class="card mb-2" *ngFor="let selSpaceSERV of selectedSpacesArrSERV; let k2=index; ">
                <div class="card-header" id="spaceCardSERV{{k2}}">
                    <h5 class="mb-0">
                        <button class="btn btn-link fontsize1 addCursor" data-toggle="collapse" [attr.data-target]=" '#collapseSpaceCardSERV'+k2" aria-expanded="true" aria-controls="collapseOne" >
                        {{selSpaceSERV}}
                        </button>
                    </h5>

                    <div class=" col-md-12 text-right" *ngIf="editBtnFlag">
                        <button [attr.data-target]=" '#collapseSpaceCardSERV'+k2" aria-expanded="true" aria-controls="collapseOne" (click)="getServiceCategories(k2)"><span>Add Service</span></button>
                        <button (click)="spaceDelete(selSpaceSERV,'services')">Delete Space</button>
                    </div>
                </div>

                <div id="collapseSpaceCardSERV{{k2}}" class="collapse" [attr.aria-labelledby]="'spaceCardSERV'+k2" data-parent="#accordionSERV">
                    <div class="card-body">
                        <div class="col-md-12 mt-2 text-center"  *ngIf="editBtnFlag && boqServices_all && boqServices_all.length==0 ">
                          No product has been added.
                        </div>
                        <div id="addServiceFormRowSERV{{k2}}" class="d-none">
                            <h5 class="">Add Service</h5>
                            <form [formGroup]="addServiceFormSERV">
                                <br>
                                <div class="row">
                                    <div class="col-md-4">
                                        <ng-select (change)="getServiceSubCategory($event)" formControlName="category">
                                           <ng-option value="">Choose Service Category</ng-option>
                                           <ng-option *ngFor="let sc of service_category" value="{{sc.id}}">{{sc.name}}</ng-option>
                                        </ng-select>
                                    </div>

                                    <div class="col-md-4">
                                        <ng-select (change)="getServiceActivity($event)" formControlName="sub_category">
                                           <ng-option value="">Choose Service SubCategory</ng-option>
                                           <ng-option *ngFor="let ssc of service_subcategory" value="{{ssc.id}}">{{ssc.name}}</ng-option>
                                        </ng-select>
                                    </div>
                                </div>
                                <br>
                                 <div class="row">
                                    <div class="col-md-5">
                                        <ng-select formControlName="activity" (change) = "chooseActivity($event)" >
                                           <ng-option value="">Choose Service Activity</ng-option>
                                           <ng-option *ngFor="let sa of service_activity" value="{{sa.id}}" >{{sa.name}}</ng-option>
                                        </ng-select>
                                    </div>

                                    <div class="col-md-2">
                                        <input type="text" name="" class="form-control" formControlName="quantity" placeholder="Quantity">
                                    </div>
                                    
                                    <div class="col-md-2">
                                        <input type="text" name="" class="form-control base_amt" formControlName="base_rate" placeholder="Base Amount">
                                    </div>
                                    
                                    <div class="col-md-2">
                                        <button [disabled]="!addServiceFormSERV.valid" (click)="addService(addServiceFormSERV.value,selSpaceSERV,k2)" class="rk-interalBtnColor">ADD</button>
                                    </div>  
                                </div>
                            </form>
                            <br>
                        </div>

                        <div class="" *ngIf="boqServices_all && boqServices_all.length>0">
                            <div class="tableDiv ">
                                <div class="">
                                  <table class="table ">
                                    <thead class="thead-dark">
                                      <tr>
                                        <th scope="col" class="firstTh">#</th>
                                        <th scope="col">ACTIVITY</th>
                                        <th scope="col">BASE RATE</th>
                                        <th scope="col">QTY</th>
                                        <th scope="col">UNIT</th>
                                        <th scope="col">AMOUNT</th>
                                        <th class="lastTh"></th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                        <ng-container *ngFor="let addedservice of boqServices_all; let i = index; " [attr.data-index]="i">
                                            <tr class="box-list" *ngIf="addedservice.space==selSpaceSERV">
                                                <td>{{ i+1 }}</td>
                                                <td>{{addedservice.service_activity}}</td>
                                                <td>
                                                  <span class="service-edit-mode-off service-edit-mode-off-{{i}}">{{addedservice.base_rate}}</span>
                                                  <span class="service-edit-mode-on service-edit-mode-on-{{i}}">
                                                    <input type="number" name="" [attr.value] = 'addedservice.base_rate' class="form-control" (change) = "onBasePriceChange(i,$event)" >
                                                  </span>
                                                </td>

                                                <td>
                                                  <span class="service-edit-mode-off service-edit-mode-off-{{i}}">{{addedservice.quantity}}</span>
                                                  <span class="service-edit-mode-on service-edit-mode-on-{{i}}">
                                                     <input type="number" name="" [attr.value] = 'addedservice.quantity' class="form-control" (change) = "onQtyChange(i,$event)">
                                                  </span>
                                                </td>
                                                <td>{{addedservice.unit}}</td>
                                                <td>{{addedservice.amount}}</td>
                                                <td *ngIf="editBtnFlag">
                                                  <img _ngcontent-c8="" src="./assets/img/dashboard/submit.png" (click)="updateService(i)" class="service-edit-mode-on service-edit-mode-on-{{i}} addCursor">

                                                  <i class="fa fa-pencil addCursor service-edit-mode-off service-edit-mode-off-{{i}}" id="edit_row{{i}}" (click)="editService(i)"></i>
                                                  <i class="fa fa-close addCursor service-edit-mode-on service-edit-mode-on-{{i}}" id="edit_row{{i}}" (click)="cancelEditService(i)"></i>

                                                  <i class="fa fa-trash deleteRow addCursor" id="delete_row{{i}}" (click)="servicejobDelete(addedservice.id)"></i>
                                                </td>
                                            </tr>
                                       </ng-container>
                                    </tbody>
                                  </table>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-12 pt-3 pb-3 text-right" *ngIf="editBtnFlag">
        <button class="mr-1 addCursor cartBtn" (click)="updateQuotation()">Update Quotation </button>
    </div>
  </div>
  <!--Services ends-->
  <!--Custom Elements-->
  <div class="row d-none rowContainer" style="padding: 16px" id="globalVarRowForCustomElem">
    <div class="col-md-12">
      <h6 class="mb-3 borderbottom pt-3 pb-3" *ngIf="quotations"><span class="mr-3">BOQ : {{quotations.reference_number}}</span><span class="pull-right">Total - &#8377; {{quotations.total_amount}}</span></h6>
    </div>
      <div class="col-md-12 borderbottom pt-3 pb-3" *ngIf="editBtnFlag">
          <div class="row">
              <div class="col-md-3"><span>Enter Space</span></div>
              <div class="col-md-6">
                  <form [formGroup]="addSpaceMWForm">
                      <select class="form-control" style="width: 70%; display: inline-block;" formControlName="space">
                          <option value="">Select</option>
                          <option *ngFor="let space of availableSpaces" value="{{space}}">{{space}}</option>
                      </select>
                      <img src="./assets/img/dashboard/submit.png" (click)="createSpace(addSpaceMWForm.value,'custom_elements')">
                  </form>
              </div>
          </div>
      </div>
      <div class="col-md-12 pt-3 pb-3" *ngIf=" selectedSpacesArrCustomEle && selectedSpacesArrCustomEle.length>0">
          <div id="accordionCE">
              <div class="card mb-2" *ngFor="let selSpaceCE of selectedSpacesArrCustomEle; let k8=index; ">
                  <div class="card-header" id="spaceCardCE{{k8}}">
                      <h5 class="mb-0">
                          <button class="btn btn-link fontsize1 addCursor" data-toggle="collapse" [attr.data-target]=" '#collapseSpaceCardCE'+k8" aria-expanded="true" aria-controls="collapsetwo">
                          {{selSpaceCE}}
                          </button>
                          <ng-container *ngFor="let key4 of Object.keys(quotations.space_amounts_custom); let n1 =index; "><span *ngIf="key4==selSpaceCE" style="font-size: 14px;" class="pull-right">Total - &#8377; {{quotations.space_amounts_custom[key4]}}</span></ng-container>
                      </h5>

                      <div class="pull-right col-md-12 text-right" *ngIf="editBtnFlag">
                          <button [attr.data-target]=" '#collapseSpaceCardCE'+k8" aria-expanded="true" aria-controls="collapsetwo" (click)="displayAddCustomElemForm(k8,'custom_elements')">Add Custom Element</button>
                          <button (click)="spaceDelete(selSpaceCE,'custom_elements')">Delete Space</button>
                      </div>
                  </div>

                  <div id="collapseSpaceCardCE{{k8}}" class="collapse" [attr.aria-labelledby]="'spaceCardCE'+k8" data-parent="#accordionCE">
                      <div class="card-body">
                          <div id="addModuleFormRowCE{{k8}}" class="d-none" *ngIf="editBtnFlag">
                              <h5 class="">Add Custom Elements</h5>
                              <form [formGroup]="addCustomElemForm">
                                  <div class="row">
                                      <div class="col-md-3">
                                          <select class="form-control capitalize" formControlName="id" (change)="changeCustomElemImage($event.target.value)">
                                             <option value="">Choose Custom Element</option>
                                             <option *ngFor="let pce of pricedCustomElemArr" value="{{pce | json}}">{{pce.name}}</option>
                                          </select>
                                      </div>
                                      <div class="col-md-3">
                                          <input type="number" name="" class="form-control" placeholder="Enter Quantity" formControlName="qty" min="0">
                                      </div>
                                      <div class="col-md-3">
                                          <img src="http://{{addCustomElemForm.controls['image'].value}}" height="100px" width="100px" onerror="this.src='./assets/img/no_image.svg'" style="display: block;" *ngIf="addCustomElemForm.controls['image'].value!=''">
                                      </div>
                                      <div class="col-md-2">
                                          <button [disabled]="!addCustomElemForm.valid" (click)="addCustomElem(addCustomElemForm.value,selSpaceCE,'custom_elements',k8)" class="rk-interalBtnColor">ADD</button>
                                      </div>
                                  </div>
                              </form>
                          </div>
                          <ng-container *ngFor="let key of Object.keys(quotations.custom_jobs); let m1 =index; ">
                              <div *ngIf="key==selSpaceCE" class="tableDiv mt-3">
                                  <table class="table">
                                      <thead class="thead-dark">
                                          <tr>
                                              <th class="firstTh">#</th>
                                              <th>Name</th>
                                              <th>Dimension</th>
                                              <th>Core Material</th>
                                              <th>Shutter Finish</th>
                                              <th>Quantity</th>
                                              <th>Price</th>
                                              <th>Image</th>
                                              <th class="lastTh" *ngIf="editBtnFlag"></th>
                                          </tr>
                                      </thead>
                                      <tbody>
                                          <tr *ngFor="let cj of quotations.custom_jobs[key]; let k=index; ">
                                              <td>{{k+1}}</td>
                                              <td>{{cj.name}}</td>
                                              <td>{{cj.dimension}}</td>
                                              <td>{{cj.core_material}} </td>
                                              <td>{{cj.shutter_finish}} </td>
                                              <td>
                                                  <span class="customelemLineItemSpan{{k}}">{{cj.quantity}}</span>
                                                  <input type="number" name="" class="form-control d-none customelemLineItemInput{{k}}" [(ngModel)]="editCustomElemLineQty" min="1">
                                              </td>
                                              <td>{{cj.amount}}</td>
                                              <td>
                                                  <img src="{{cj.photo}}" height="100px" width="100px" onerror="this.src='./assets/img/no_image.svg'" style="display: block;" *ngIf="cj.photo">
                                              </td>
                                              <td *ngIf="editBtnFlag">
                                                  <button class="d-none customelemLineItemInput{{k}} rk-interalBtnColor mx-2 editRowButton mt-1" (click)="updateCustomElem(k,cj,'custom_elements')">Update</button>
                                                  <button class="d-none customelemLineItemInput{{k}} rk-btnCancel addCursor mx-2 mt-1" (click)="cancelCustomElemLineItem(k,cj)">Cancel</button>
                                                  <i class="ion-android-more-vertical  ss-3-dot-drop customelemLineItemSpan{{k}}" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false"></i>
                                                  <div class="dropdown-menu pt-2 pb-2" style="font-size: 14px;">
                                                      <a class="dropdown-item addCursor" (click)="editcustomelementLineItem(k,cj)">Edit</a>
                                                      <a class="dropdown-item addCursor" (click)="customelementDelete(cj.id,cj.space)">Delete</a>
                                                  </div>
                                              </td>
                                          </tr>
                                      </tbody>
                                  </table>
                              </div>
                          </ng-container>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <div class="col-md-12 pt-3 pb-3 text-right" *ngIf="editBtnFlag">
        <button class="mr-1 addCursor cartBtn" (click)="updateQuotation()">Update Quotation </button>
      </div>
  </div>
  <!--Custom Elements Ends-->
</div>


<!-- Modal -->
<div class="modal fade" id="customizationModal" tabindex="-1" role="dialog" aria-labelledby="customizationModalLable" aria-hidden="true" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title modalTitle" id="exampleModalLabel">Customize Elements</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" *ngIf="customizationModule_MW_details">
        <form [formGroup]="customizationModule_MW_Form">
            <div class="row">
                <div class="col-md-6 mt-2" [ngClass]="{'d-none':customizationModule_MW_details.attributes_not_for_customization.includes('core_material')}">
                    <label>Core Material</label>
                    <input type="text" name="" class="form-control" formControlName="core_material" readonly *ngIf="!editBtnFlag">
                    <select class="form-control" formControlName="core_material" *ngIf="editBtnFlag">
                        <option value="">Select</option>
                        <option *ngFor="let coremat of globalVarArr.core_material" value="{{coremat.name}}">{{coremat.name}}</option>
                    </select>
                </div>
                <div class="col-md-6 mt-2" [ngClass]="{'d-none':customizationModule_MW_details.attributes_not_for_customization.includes('shutter_material')}">
                    <label>Shutter Material</label>
                    <input type="text" name="" class="form-control" formControlName="shutter_material" readonly *ngIf="!editBtnFlag">
                    <select class="form-control" formControlName="shutter_material" *ngIf="editBtnFlag" (change)="listofShutterFinishes($event.target.value)">
                        <option value="">Select</option>
                        <option *ngFor="let shuttermat of globalVarArr.shutter_material" value="{{shuttermat.name}}">{{shuttermat.name}}</option>
                    </select>
                </div>
                <div class="col-md-6 mt-2" [ngClass]="{'d-none':customizationModule_MW_details.attributes_not_for_customization.includes('shutter_finish')}">
                    <label>Shutter Finish</label>
                    <input type="text" name="" class="form-control" formControlName="shutter_finish" readonly *ngIf="!editBtnFlag">
                    <select class="form-control" formControlName="shutter_finish" *ngIf="editBtnFlag" (change)="listofShutterFinishShades($event.target.value)">
                        <option value="">Select</option>
                        <option *ngFor="let shutterfinish of globalVarArr.shutter_finish" value="{{shutterfinish.name}}">{{shutterfinish.name}}</option>
                    </select>
                </div>
                <div class="col-md-6 mt-2" [ngClass]="{'d-none':customizationModule_MW_details.attributes_not_for_customization.includes('shutter_shade_code')}">
                    <label>Shutter Shade Code</label>
                    <input type="text" name="" class="form-control" formControlName="shutter_shade_code" readonly *ngIf="!editBtnFlag">
                    <select class="form-control" formControlName="shutter_shade_code" *ngIf="editBtnFlag" (change)="onchangeOfCustomizationShade($event.target.value,'shade','wardrobe')">
                        <option value="">Select</option>
                        <option value="customshadecode">Custom shade code</option>
                        <option *ngFor="let shuttershadecode of globalVarArr.shutter_shade_code" value="{{shuttershadecode.code}}">{{shuttershadecode.code}}</option>
                    </select>
                    <input type="text" name="" class="form-control my-1" formControlName="cust_shutter_shade_code" placeholder="Enter custom shade code" readonly *ngIf="!editBtnFlag">
                    <input type="text" name="" class="form-control my-1" formControlName="cust_shutter_shade_code" placeholder="Enter custom shade code"  *ngIf="editBtnFlag">
                </div>
                <div class="col-md-6 mt-2" [ngClass]="{'d-none':customizationModule_MW_details.attributes_not_for_customization.includes('edge_banding_shade_code')}">
                    <label>Edge Banding Shade Code</label>
                    <input type="text" name="" class="form-control" formControlName="edge_banding_shade_code" readonly *ngIf="!editBtnFlag">
                    <select class="form-control" formControlName="edge_banding_shade_code" *ngIf="editBtnFlag" (change)="onchangeOfCustomizationShade($event.target.value,'edgeband','wardrobe')">
                        <option value="">Select</option>
                        <option value="customedgebanshadecode">Custom edge banding shade code</option>
                        <option *ngFor="let ebsc of globalVarArr.edge_banding_shade_code" value="{{ebsc.code}}">{{ebsc.code}}</option>
                    </select>
                    <input type="text" name="" class="form-control my-1" formControlName="cust_edge_banding_shade_code" placeholder="Enter custom edge banding shade code" readonly *ngIf="!editBtnFlag">
                    <input type="text" name="" class="form-control my-1" formControlName="cust_edge_banding_shade_code" placeholder="Enter custom edge banding shade code" *ngIf="editBtnFlag">
                </div>
                <div class="col-md-6 mt-2" [ngClass]="{'d-none':customizationModule_MW_details.attributes_not_for_customization.includes('shutter_handle_code')}">
                    <label>Shutter Handle Code</label>
                    <input type="text" name="" class="form-control" formControlName="shutter_handle_code" readonly>
                    <ng-container *ngIf="editBtnFlag"><a data-toggle="modal" data-target="#customizationHandleCodeModal" class="addCursor" style="color: blue;" (click)="openCustomizationHandleModal(globalVarArr.shutter_handle_code,'wardrobe','shutter_handle_code')">Choose Shutter Handle Code</a></ng-container>
                </div>
                <div class="col-md-6 mt-2" [ngClass]="{'d-none':customizationModule_MW_details.attributes_not_for_customization.includes('door_handle_code')}">
                    <label>Drawer Handle Code</label>
                    <input type="text" name="" class="form-control" formControlName="door_handle_code" readonly>
                    <ng-container *ngIf="editBtnFlag"><a data-toggle="modal" data-target="#customizationHandleCodeModal" class="addCursor" style="color: blue;" (click)="openCustomizationHandleModal(globalVarArr.door_handle_code,'wardrobe','door_handle_code')">Choose Drawer Handle Code</a></ng-container>
                </div>
                <div class="col-md-6 mt-2" [ngClass]="{'d-none':customizationModule_MW_details.attributes_not_for_customization.includes('hinge_type')}">
                    <label>Hinge Type</label>
                    <input type="text" name="" class="form-control" formControlName="hinge_type" readonly *ngIf="!editBtnFlag">
                    <select class="form-control" formControlName="hinge_type" *ngIf="editBtnFlag">
                        <option value="">Select</option>
                        <option *ngFor="let ht of globalVarArr.hinge_type" value="{{ht}}">{{ht | uppercase}} <span *ngIf="ht=='soft'"> - CLOSE</span></option>
                    </select>
                </div>
                <div class="col-md-6 mt-2" [ngClass]="{'d-none':customizationModule_MW_details.attributes_not_for_customization.includes('channel_type')}">
                    <label>Channel Type</label>
                    <input type="text" name="" class="form-control" formControlName="channel_type" readonly *ngIf="!editBtnFlag">
                    <select class="form-control" formControlName="channel_type" *ngIf="editBtnFlag">
                        <option value="">Select</option>
                        <option *ngFor="let ct of globalVarArr.channel_type" value="{{ct}}">{{ct | uppercase}} <span *ngIf="ct=='soft'"> - CLOSE</span></option>
                    </select>
                </div>
                <div class="col-md-6 mt-2" [ngClass]="{'d-none':customizationModule_MW_details.attributes_not_for_customization.includes('hardware_brand_id')}">
                    <label>Hardware Brand</label>
                    <input type="text" name="" class="form-control" formControlName="hardware_brand" readonly *ngIf="!editBtnFlag">
                    <select class="form-control" formControlName="hardware_brand" *ngIf="editBtnFlag">
                        <option value="">Select</option>
                        <option *ngFor="let hb of globalVarArr.hardware_brand" value="{{hb.id}}">{{hb.name}}</option>
                    </select>
                </div>
                <div class="col-md-6 mt-2" [ngClass]="{'d-none':customizationModule_MW_details.attributes_not_for_customization.includes('number_exposed_sites')}">
                    <label>Number Exposed Sites</label>
                    <input type="number" name="" formControlName="number_exposed_sites" class="form-control" readonly *ngIf="!editBtnFlag">
                    <select class="form-control" formControlName="number_exposed_sites" *ngIf="editBtnFlag">
                        <option>Select</option>
                        <option *ngFor="let item3 of customizationModule_MW_details.allowed_number_exposed_sites" value="{{item3}}">{{item3}}</option>
                    </select>
                </div>
                <div class="col-md-12 mt-2">
                  <fieldset formArrayName="addons">
                      <div class="form-group row"
                           *ngFor = "let item of customizationModule_MW_Form.get('addons')['controls']; let i=index "
                           [formGroup]="item">
                        <div class="col-sm-4">
                          <label [attr.for]="'addon'+i">Addon </label>
                          <select class="form-control" [attr.id]="'addon'+i" formControlName="id" *ngIf="!editBtnFlag" disabled readonly>
                              <option>Select</option>
                              <option *ngFor="let item_1 of customizationModule_MW_details.allowed_addons" value="{{item_1.id}}">{{item_1.name}} - {{item_1.code}}</option>
                          </select>
                          <select class="form-control" [attr.id]="'addon'+i" formControlName="id" *ngIf="editBtnFlag" (change)="customization_addon_dropdownChange($event.target.value,i,'MW')">
                              <option>Select</option>
                              <option *ngFor="let item of customizationModule_MW_details.allowed_addons" value="{{item.id}}">{{item.name}} - {{item.code}}</option>
                          </select>
                        </div>
                        <div class="col-sm-4">
                          <label [attr.for]="'addon-quantity'+i">Quantity</label>
                          <input type="number" class="form-control"
                                 [attr.id]="'addon-quantity'+i" formControlName="quantity" readonly *ngIf="!editBtnFlag">
                          <input type="number" class="form-control"
                                 [attr.id]="'addon-quantity'+i" formControlName="quantity"  *ngIf="editBtnFlag">
                        </div>
                        <div class="col-sm-3">
                            <label [attr.for]="'addon-image'+i">Image</label>
                            <img src="http://{{getformArray(customizationModule_MW_Form,'addons').controls[i]['controls'].image.value}}" height="100px" width="100px" onerror="this.src='./assets/img/no_image.svg'" style="display: block;" *ngIf="getformArray(customizationModule_MW_Form,'addons').controls[i]['controls'].image.value!=''">
                        </div>
                        <div class="col-sm-1 py-1">
                            <i class="fa fa-minus nestedRemoveBtn" (click)="customizationModule_MW_Form.get('addons').removeAt(i)" *ngIf="editBtnFlag"></i>
                        </div>
                      </div>
                  </fieldset>
                  <a (click)="getAddonTags(); getOptionalAddons('wardrobe');" class="mb-2 addCursor" style="color: blue;" *ngIf="editBtnFlag" data-toggle="modal" data-target="#addoptionalAddonModal"><i class="fa fa-plus"> </i> Add Addons</a>
                </div>
                <div class="col-md-12">
                    <button (click)="updateCustomization(customizationModule_MW_Form.value,'wardrobe')" class="cartBtn pull-right" *ngIf="editBtnFlag">Update</button>
                </div>
            </div>
        </form>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="customizationModalMk" tabindex="-1" role="dialog" aria-labelledby="customizationModalMkLabel" aria-hidden="true" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title modalTitle" id="exampleModalLabel">Customize Elements</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" *ngIf="globalVarArr && customizationModule_MK_details">
        <form [formGroup]="customizationModule_MK_Form">
            <div class="row">
                <div class="col-md-6 mt-2" [ngClass]="{'d-none':customizationModule_MK_details.attributes_not_for_customization.includes('core_material')}">
                    <label>Core Material</label>
                    <input type="text" name="" class="form-control" formControlName="core_material" readonly *ngIf="!editBtnFlag">
                    <select class="form-control" formControlName="core_material" *ngIf="editBtnFlag">
                        <option value="">Select</option>
                        <option *ngFor="let coremat of globalVarArr.core_material" value="{{coremat.name}}">{{coremat.name}}</option>
                    </select>
                </div>
                <div class="col-md-6 mt-2" [ngClass]="{'d-none':customizationModule_MK_details.attributes_not_for_customization.includes('shutter_material')}">
                    <label>Shutter Material</label>
                    <input type="text" name="" class="form-control" formControlName="shutter_material" readonly *ngIf="!editBtnFlag">
                    <select class="form-control" formControlName="shutter_material" (change)="listofShutterFinishes($event.target.value)" *ngIf="editBtnFlag">
                        <option value="">Select</option>
                        <option *ngFor="let shuttermat of globalVarArr.shutter_material" value="{{shuttermat.name}}">{{shuttermat.name}}</option>
                    </select>
                </div>
                <div class="col-md-6 mt-2" [ngClass]="{'d-none':customizationModule_MK_details.attributes_not_for_customization.includes('shutter_finish')}">
                    <label>Shutter Finish</label>
                    <input type="text" name="" class="form-control" formControlName="shutter_finish" readonly *ngIf="!editBtnFlag">
                    <select class="form-control" formControlName="shutter_finish" (change)="listofShutterFinishShades($event.target.value); getHandleList($event.target.value,this.customizationModule_MK_details.product_module_id)" *ngIf="editBtnFlag">
                        <option value="">Select</option>
                        <option *ngFor="let shutterfinish of globalVarArr.shutter_finish" value="{{shutterfinish.name}}">{{shutterfinish.name}}</option>
                    </select>
                </div>
                <div class="col-md-6 mt-2" [ngClass]="{'d-none':customizationModule_MK_details.attributes_not_for_customization.includes('shutter_shade_code')}">
                    <label>Shutter Shade Code</label>
                    <input type="text" name="" class="form-control" formControlName="shutter_shade_code" readonly *ngIf="!editBtnFlag">
                    <select class="form-control" formControlName="shutter_shade_code" *ngIf="editBtnFlag" (change)="onchangeOfCustomizationShade($event.target.value,'shade','kitchen')">
                        <option value="">Select</option>
                        <option value="customshadecode">Custom shade code</option>
                        <option *ngFor="let shuttershadecode of globalVarArr.shutter_shade_code" value="{{shuttershadecode.code}}">{{shuttershadecode.code}}</option>
                    </select>
                    <input type="text" name="" class="form-control my-1" formControlName="cust_shutter_shade_code" placeholder="Enter custom shade code" readonly *ngIf="!editBtnFlag">
                    <input type="text" name="" class="form-control my-1" formControlName="cust_shutter_shade_code" placeholder="Enter custom shade code" *ngIf="editBtnFlag">
                </div>
                <div class="col-md-6 mt-2" [ngClass]="{'d-none':customizationModule_MK_details.attributes_not_for_customization.includes('edge_banding_shade_code')}">
                    <label>Edge Banding Shade Code</label>
                    <input type="text" name="" class="form-control" formControlName="edge_banding_shade_code" readonly *ngIf="!editBtnFlag">
                    <select class="form-control" formControlName="edge_banding_shade_code" *ngIf="editBtnFlag" (change)="onchangeOfCustomizationShade($event.target.value,'edgeband','kitchen')">
                        <option value="">Select</option>
                        <option value="customedgebanshadecode">Custom edge banding shade code</option>
                        <option *ngFor="let ebsc of globalVarArr.edge_banding_shade_code" value="{{ebsc.code}}">{{ebsc.code}}</option>
                    </select>
                    <input type="text" name="" class="form-control my-1" formControlName="cust_edge_banding_shade_code" placeholder="Enter custom edge banding shade code" readonly *ngIf="!editBtnFlag">
                    <input type="text" name="" class="form-control my-1" formControlName="cust_edge_banding_shade_code" placeholder="Enter custom edge banding shade code" *ngIf="editBtnFlag">
                </div>
                <div class="col-md-6 mt-2" [ngClass]="{'d-none':customizationModule_MK_details.attributes_not_for_customization.includes('door_handle_code')}">
                    <label>Handle Code</label>
                    <input type="text" name="" class="form-control" formControlName="door_handle_code" readonly>
                    <ng-container *ngIf="editBtnFlag"><a data-toggle="modal" data-target="#customizationHandleCodeModal" class="addCursor" style="color: blue;" (click)="openCustomizationHandleModal(handlelistForKitchen,'kitchen','door_handle_code')">Choose Handle Code</a><br></ng-container>
                </div>
                <div class="col-md-6 mt-2" [ngClass]="{'d-none':customizationModule_MK_details.attributes_not_for_customization.includes('hinge_type')}">
                    <label>Hinge Type</label>
                    <input type="text" name="" class="form-control" formControlName="hinge_type" readonly *ngIf="!editBtnFlag">
                    <select class="form-control" formControlName="hinge_type" *ngIf="editBtnFlag">
                        <option value="">Select</option>
                        <option *ngFor="let ht of globalVarArr.hinge_type" value="{{ht}}">{{ht | uppercase}} <span *ngIf="ht=='soft'"> - CLOSE</span></option>
                    </select>
                </div>
                <div class="col-md-6 mt-2" [ngClass]="{'d-none':customizationModule_MK_details.attributes_not_for_customization.includes('channel_type')}">
                    <label>Channel Type</label>
                    <input type="text" name="" class="form-control" formControlName="channel_type" readonly *ngIf="!editBtnFlag">
                    <select class="form-control" formControlName="channel_type" *ngIf="editBtnFlag">
                        <option value="">Select</option>
                        <option *ngFor="let ct of globalVarArr.channel_type" value="{{ct}}">{{ct | uppercase}} <span *ngIf="ct=='soft'"> - CLOSE</span></option>
                    </select>
                </div>
                <div class="col-md-6 mt-2" [ngClass]="{'d-none':customizationModule_MK_details.attributes_not_for_customization.includes('hardware_brand_id')}">
                    <label>Hardware Brand</label>
                    <input type="text" name="" class="form-control" formControlName="hardware_brand" readonly *ngIf="!editBtnFlag">
                    <select class="form-control" formControlName="hardware_brand" *ngIf="editBtnFlag">
                        <option value="">Select</option>
                        <option *ngFor="let hb of globalVarArr.hardware_brand" value="{{hb.id}}">{{hb.name}}</option>
                    </select>
                </div>
                <div class="col-md-6 mt-2" [ngClass]="{'d-none':customizationModule_MK_details.attributes_not_for_customization.includes('skirting_config_type')}">
                    <label>Skirting Config Type</label>
                    <input type="text" name="" class="form-control" formControlName="skirting_config_type" readonly *ngIf="!editBtnFlag">
                    <select class="form-control" formControlName="skirting_config_type" (change)="listofSkirtingHeights($event.target.value)" *ngIf="editBtnFlag">
                        <option value="">Select</option>
                        <option *ngFor="let sct of globalVarArr.skirting_config_type" value="{{sct.skirting_type}}">{{sct.skirting_type | uppercase}}</option>
                    </select>
                </div>
                <div class="col-md-6 mt-2" [ngClass]="{'d-none':customizationModule_MK_details.attributes_not_for_customization.includes('skirting_config_height')}">
                    <label>Skirting Config Height</label>
                    <input type="text" name="" class="form-control" formControlName="skirting_config_height" readonly *ngIf="!editBtnFlag">
                    <select class="form-control" formControlName="skirting_config_height" *ngIf="editBtnFlag">
                        <option value="">Select</option>
                        <option *ngFor="let sch of globalVarArr.skirting_config_height" value="{{sch.skirting_height}}">{{sch.skirting_height}}</option>
                    </select>
                </div>
                <div class="col-md-6 mt-2" *ngIf="customizationModule_MK_details" [ngClass]="{'d-none':customizationModule_MK_details.attributes_not_for_customization.includes('number_exposed_sites')}">
                    <label>Number Exposed Sites</label>
                    <input type="number" name="" formControlName="number_exposed_sites" class="form-control" readonly *ngIf="!editBtnFlag">
                    <select class="form-control" formControlName="number_exposed_sites" *ngIf="editBtnFlag">
                      <option>Select</option>
                      <option *ngFor="let item3 of customizationModule_MK_details.allowed_number_exposed_sites" value="{{item3}}">{{item3}}</option>
                    </select>
                </div>
                <div class="col-md-12 mt-2" *ngIf="customizationModule_MK_details">
                    <fieldset formArrayName="compulsory_addons" class="mx-3">
                        <div class="form-group row fieldsetBorder"
                           *ngFor = "let item2 of customizationModule_MK_Form.get('compulsory_addons')['controls']; let i=index "
                           [formGroup]="item2">
                            <div class="col-sm-4">
                               <label [attr.for]="'compaddon-slot'+i">Slot *</label>
                               <input type="text" name="" formControlName="slot"  class="form-control"
                                 [attr.id]="'compaddon-slot'+i" readonly>
                            </div>
                            <div class="col-sm-4">
                                <label [attr.for]="'compaddon'+i">Addon *</label>
                                <textarea formControlName="name"  class="form-control"
                                   [attr.id]="'compaddon'+i" readonly=""></textarea>
                                <a data-toggle="modal" data-target="#addAddonModal" (click)="getAddonTags(); getCompulsoryAddons(customizationModule_MK_details.product_module_id,getformArray(customizationModule_MK_Form,'compulsory_addons').controls[i]['controls'].slot.value,i); openAddAddonModal('compaddon')" class="d-block addCursor link-color mt-2" *ngIf="editBtnFlag">Choose Addon</a>
                            </div>
                            <div class="col-sm-4">
                              <label [attr.for]="'compaddon-quantity'+i">Quantity*</label>
                              <input type="number" class="form-control"
                                 [attr.id]="'compaddon-quantity'+i" formControlName="quantity" readonly>
                            </div>
                            <div class="col-sm-4">
                                <label [attr.for]="'compaddon-image'+i">Image</label>
                                <img src="http://{{getformArray(customizationModule_MK_Form,'compulsory_addons').controls[i]['controls'].image.value}}" height="100px" width="100px" onerror="this.src='./assets/img/no_image.svg'" style="display: block;" *ngIf="getformArray(customizationModule_MK_Form,'compulsory_addons').controls[i]['controls'].image.value!=''">
                            </div>
                            <!--Addon for addons-->
                            <div class="col-sm-12 mt-3">
                                <fieldset formArrayName="addons_for_addons">
                                    <div class="form-group row"
                                         *ngFor = "let item_2 of getformArray(customizationModule_MK_Form,'compulsory_addons').controls[i]['controls'].addons_for_addons.controls; let i9=index "
                                         [formGroup]="item_2">
                                        <div class="col-sm-4">
                                            <label [attr.for]="'addonforaddon'+i9">Addon *</label>
                                            <textarea formControlName="name"  class="form-control"
                                               [attr.id]="'addonforaddon'+i9" disabled readonly></textarea>
                                        </div>
                                        <div class="col-sm-2">
                                            <label [attr.for]="'addonforaddon-quantity'+i9">Quantity*</label>
                                            <input type="number" class="form-control"
                                               [attr.id]="'addonforaddon-quantity'+i9" formControlName="quantity" *ngIf="editBtnFlag">
                                            <input type="number" class="form-control"
                                               [attr.id]="'addonforaddon-quantity'+i9" formControlName="quantity" readonly *ngIf="!editBtnFlag">

                                        </div>
                                        <div class="col-sm-3">
                                            <label [attr.for]="'addonforaddon-image'+i9">Image</label>
                                            <img src="http://{{ getformArray(customizationModule_MK_Form,'compulsory_addons').controls[i]['controls'].addons_for_addons.controls[i9]['controls'].addon_image.value}}" height="80px" width="80px" onerror="this.src='./assets/img/no_image.svg'" style="display: block;" *ngIf="getformArray(customizationModule_MK_Form,'compulsory_addons').controls[i]['controls'].addons_for_addons.controls[i9]['controls'].addon_image.value!=''">
                                        </div>
                                        <div class="col-sm-1 py-1" *ngIf="editBtnFlag">
                                            <i class="fa fa-minus nestedRemoveBtn" (click)="getformArray(customizationModule_MK_Form,'compulsory_addons').controls[i]['controls'].addons_for_addons.removeAt(i9)"></i>
                                        </div>
                                    </div>
                                </fieldset>
                            </div>
                            <div class="col-sm-12" *ngIf="editBtnFlag">
                                <a (click)="getAddonTags(); getListofAddonsForAddons(getformArray(customizationModule_MK_Form,'compulsory_addons').controls[i]['controls'].id.value,getformArray(customizationModule_MK_Form,'compulsory_addons').controls[i]['controls'].slot.value,i); openAddAddonModal('addonforaddon');" class="mb-2 addCursor d-block" style="color: blue;" data-toggle="modal" data-target="#addAddonModal"><i class="fa fa-plus"> </i> Add Optional Addons</a>
                            </div>
                            <!--Addon for addons-->
                        </div>
                    </fieldset>
                </div>
                <div class="col-md-12 mt-1" *ngIf="customizationModule_MK_details">
                    <fieldset formArrayName="addons">
                        <div class="form-group row"
                             *ngFor = "let item of customizationModule_MK_Form.get('addons')['controls']; let i=index "
                             [formGroup]="item">
                          <div class="col-sm-4">
                            <label [attr.for]="'addon'+i">Addon </label>
                            <textarea class="form-control" [attr.id]="'addon'+i" formControlName="name" readonly></textarea>
                          </div>
                          <div class="col-sm-4">
                            <label [attr.for]="'addon-quantity'+i">Quantity</label>
                            <input type="number" class="form-control"
                                   [attr.id]="'addon-quantity'+i" formControlName="quantity" *ngIf="!editBtnFlag" readonly>
                            <input type="number" class="form-control"
                                 [attr.id]="'addon-quantity'+i" formControlName="quantity"  *ngIf="editBtnFlag">
                          </div>
                          <div class="col-sm-3">
                            <label [attr.for]="'addon-image'+i">Image</label>
                            <img src="http://{{getformArray(customizationModule_MK_Form,'addons').controls[i]['controls'].image.value}}" height="100px" width="100px" onerror="this.src='./assets/img/no_image.svg'" style="display: block;" *ngIf="getformArray(customizationModule_MK_Form,'addons').controls[i]['controls'].image.value!=''">
                          </div>
                          <div class="col-sm-1 py-1">
                            <i class="fa fa-minus nestedRemoveBtn" (click)="customizationModule_MK_Form.get('addons').removeAt(i)" *ngIf="editBtnFlag"></i>
                          </div>
                        </div>

                    </fieldset>
                    <a (click)="getAddonTags(); getOptionalAddons('kitchen');" class="mb-2 addCursor" style="color: blue;" *ngIf="editBtnFlag" data-toggle="modal" data-target="#addoptionalAddonModal"><i class="fa fa-plus"> </i> Add Addons</a>
                </div>
                <!-- <pre>{{customizationModule_MK_Form.value | json}}</pre> -->
                <div class="col-md-12">
                    <button (click)="updateCustomization(customizationModule_MK_Form.value,'kitchen')" class="cartBtn pull-right" *ngIf="editBtnFlag">Update</button>
                </div>
            </div>
        </form>
      </div>
    </div>
  </div>
</div>


<div class="modal fade" id="selectedGlobalVarModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" data-keyboard="false" data-backdrop="static">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Selected Global Variables</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row" *ngIf="editBtnFlag">
                <div class="col-sm-12">
                    <button _ngcontent-c6="" class="rk-interalBtnColor addCursor pull-right my-2 mr-2 editRowSpan" (click)="editGlobalVarRow('',boqConfigMWVal)" *ngIf="globalVarArr && boqConfigMWVal && boqConfigMWVal.category=='wardrobe' ">Update Global Variables</button>
                </div>
            </div>
            <div class="table-responsive">
                <table class="table">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Category</th>
                            <th>Type</th>
                            <th></th>
                        </tr>
                    </thead>
                    <!-- Modlar wardrobe-->
                    <tbody *ngIf="globalVarArr && boqConfigMWVal && boqConfigMWVal.category=='wardrobe' ">
                        <tr>
                            <td>1</td>
                            <td>Core Material</td>
                            <td>
                               <span class="editRowSpan capitalize">{{boqConfigMWVal.core_material.name}}</span>
                               <select class="form-control d-none editRowInput" [(ngModel)]="core_material_globalVar_MW">
                                    <option value="">Select</option>
                                    <option *ngFor="let coremat of globalVarArr.core_material" value="{{coremat.name}}">{{coremat.name}}</option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td>2</td>
                            <td>Shutter Material</td>
                            <td>
                               <span class="editRowSpan capitalize">{{boqConfigMWVal.shutter_material.name}}</span>
                               <select class="form-control d-none editRowInput" [(ngModel)]="shutter_material_globalVar_MW" (change)="listofShutterFinishes(shutter_material_globalVar_MW)">
                                   <option value="">Select</option>
                                    <option *ngFor="let shuttermat of globalVarArr.shutter_material" value="{{shuttermat.name}}">{{shuttermat.name}}</option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td>3</td>
                            <td>Shutter Finish</td>
                            <td>
                                <span class="editRowSpan capitalize">{{boqConfigMWVal.shutter_finish.name}}</span>
                                <select class="form-control d-none editRowInput" [(ngModel)]="shutter_finish_globalVar_MW" (change)="listofShutterFinishShades(shutter_finish_globalVar_MW)">
                                    <option value="">Select</option>
                                    <option *ngFor="let shutterfin of globalVarArr.shutter_finish" value="{{shutterfin.name}}">{{shutterfin.name}}</option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td>4</td>
                            <td> Shutter Shade Code</td>
                            <td>
                               <span class="editRowSpan capitalize" *ngIf="!boqConfigMWVal.custom_shutter_shade_code">{{boqConfigMWVal.shutter_shade_code.code}}</span>
                               <span class="editRowSpan capitalize" *ngIf="boqConfigMWVal.custom_shutter_shade_code">{{boqConfigMWVal.shutter_shade_code}}</span>
                               <select class="form-control d-none editRowInput" [(ngModel)]="shutter_shade_code_globalVar_MW" (change)="setImageModal($event.target.value,'shadeCode',globalVarArr.category)">
                                    <option value="">Select</option>
                                    <option value="customshadecode">Custom shade code</option>
                                    <option *ngFor="let shuttershadecode of globalVarArr.shutter_shade_code" value="{{shuttershadecode.code}}" [selected]="shutter_shade_code_globalVar_MW==shuttershadecode.code">{{shuttershadecode.code}}</option>
                                </select>
                                <input type="text" name="" class="form-control d-none editRowInput my-1" [(ngModel)]="shutter_custshade_code_globalVar_MW" placeholder="Enter custom shade code" [disabled]="shutter_shade_code_globalVar_MW!='customshadecode'">
                                <img src="{{boqConfigMWVal.shutter_shade_code.shade_image}}" class="my-1 editRowSpan" alt=" No Image" height="60px" width="100px" *ngIf="!boqConfigMWVal.custom_shutter_shade_code && boqConfigMWVal.shutter_shade_code.shade_image" onerror="this.src='./assets/img/no_image.svg'" />
                                <img src="{{shadeImgMW}}" class="my-1 d-none editRowInput" alt=" No Image" height="60px" width="100px" *ngIf="shadeImgMW" onerror="this.src='./assets/img/no_image.svg'" />
                            </td>
                        </tr>
                        <tr>
                           <td>5</td>
                           <td>Shutter Handle Code</td>
                           <td>
                               <span class="editRowSpan capitalize">{{boqConfigMWVal.shutter_handle_code}}</span>
                                <a data-toggle="modal" data-target="#shutterhandleCodeModal" class="addCursor d-none editRowInput" style="color: blue;" (click)="openHandleModal('wardrobe')">Choose Shutter Handle code</a><br>
                                <img src="{{shutterhandleImg}}" class="my-1 d-none editRowInput"  height="60px" width="100px" *ngIf="shutterhandleImg" onerror="this.src='./assets/img/no_image.svg'" /> <span class="ml-2 d-none editRowInput">{{shutter_handle_code_globalVar_MW}}</span>
                           </td>
                        </tr>
                        <tr>
                           <td>6</td>
                           <td>Drawer Handle Code</td>
                           <td>
                               <span class="editRowSpan capitalize">{{boqConfigMWVal.door_handle_code}}</span>
                                <a data-toggle="modal" data-target="#doorhandleCodeModal" class="addCursor d-none editRowInput" style="color: blue;" (click)="openHandleModal('wardrobe')">Choose Drawer Handle code</a><br>
                                <img src="{{doorhandleImgMw}}" class="my-1 d-none editRowInput"  height="60px" width="100px" *ngIf="doorhandleImgMw" onerror="this.src='./assets/img/no_image.svg'" /> <span class="ml-2 d-none editRowInput">{{door_handle_code_globalVar_MW}}</span>
                           </td>
                        </tr>
                        <tr>
                           <td>7</td>
                           <td>Hardware Brand</td>
                           <td>
                               <span class="editRowSpan capitalize">{{boqConfigMWVal.brand.name}}</span>
                               <select class="form-control d-none editRowInput" [(ngModel)]="hardware_brand_globalVar_MW">
                                    <option value="">Select</option>
                                    <option *ngFor="let hb of globalVarArr.hardware_brand" value="{{hb.id}}">{{hb.name}}</option>
                                </select>
                           </td>
                        </tr>
                        <tr>
                           <td>8</td>
                           <td> Hinge Type</td>
                           <td>
                               <span class="editRowSpan capitalize">{{boqConfigMWVal.hinge_type}}</span>
                               <select class="form-control d-none editRowInput" [(ngModel)]="hinge_type_globalVar_MW">
                                    <option value="">Select</option>
                                    <option *ngFor="let ht of globalVarArr.hinge_type" value="{{ht}}">{{ht | uppercase}} <span *ngIf="ht=='soft'"> - CLOSE</span></option>
                                </select>
                           </td>
                        </tr>
                        <tr>
                           <td>9</td>
                           <td> Channel Type</td>
                           <td>
                               <span class="editRowSpan capitalize">{{boqConfigMWVal.channel_type}}</span>
                               <select class="form-control d-none editRowInput" [(ngModel)]="channel_type_globalVar_MW">
                                    <option value="">Select</option>
                                    <option *ngFor="let ct of globalVarArr.channel_type" value="{{ct}}">{{ct | uppercase}} <span *ngIf="ct=='soft'"> - CLOSE</span></option>
                                </select>
                           </td>
                        </tr>
                        <tr>
                           <td>10</td>
                           <td> Edge Banding Shade</td>
                           <td>
                               <span class="editRowSpan capitalize" *ngIf="!boqConfigMWVal.custom_edge_banding_shade_code">{{boqConfigMWVal.edge_banding_shade_code.code}}</span>
                               <span class="editRowSpan capitalize" *ngIf="boqConfigMWVal.custom_edge_banding_shade_code">{{boqConfigMWVal.edge_banding_shade_code}}</span>
                               <select class="form-control d-none editRowInput" [(ngModel)]="edgebanding_shade_code_globalVar_MW" (change)="setImageModal($event.target.value,'edgebandingShadeCode',globalVarArr.category)">
                                    <option value="">Select</option>
                                    <option value="customedgebanshadecode">Custom edge banding shade code</option>
                                    <option *ngFor="let ebsc of globalVarArr.edge_banding_shade_code" value="{{ebsc.code}}" [selected]="edgebanding_shade_code_globalVar_MW==ebsc.code">{{ebsc.code}}</option>
                                </select>
                                <input type="text" name="" class="form-control d-none editRowInput my-1" [(ngModel)]="edgebanding_custshade_code_globalVar_MW" placeholder="Enter custom edge banding shade code" [disabled]="edgebanding_shade_code_globalVar_MW!='customedgebanshadecode'">

                                <img src="{{boqConfigMWVal.edge_banding_shade_code.shade_image}}" class="my-1 editRowSpan" alt=" No Image" height="60px" width="100px" *ngIf="!boqConfigMWVal.custom_edge_banding_shade_code && boqConfigMWVal.edge_banding_shade_code.shade_image" onerror="this.src='./assets/img/no_image.svg'" />
                                <img src="{{edgebandingImgMW}}" class="my-1 d-none editRowInput " alt=" No Image" height="60px" width="100px" *ngIf="edgebandingImgMW" onerror="this.src='./assets/img/no_image.svg'" />
                           </td>
                        </tr>
                    </tbody>
                </table>
                <div class="row editRowInput d-none" *ngIf="globalVarArr && boqConfigMWVal && boqConfigMWVal.category=='wardrobe' ">
                    <div class="col-sm-12 text-right">
                        <button class=" rk-btnCancel my-2" (click)="cancelEditGlobalVarRow('',boqConfigMWVal.category)">Cancel</button>
                        <button class="pull-right rk-interalBtnColor mr-2 my-2" (click)="updateGlobalVar('',boqConfigMWVal.id,boqConfigMWVal.category)">Save</button>
                        <button class="pull-right rk-interalBtnColor mr-2 my-2" (click)="updateAndApplyBoqGlobalConfig('',boqConfigMWVal.id,boqConfigMWVal.category)">Save and Apply</button>
                        <button class="pull-right rk-interalBtnColor mr-2 my-2" (click)="openPresetModal(null,'wardrobe','update','#selectedGlobalVarModal')">Save As Preset</button>
                    </div>
                </div>
            </div>
          </div>
        </div>
    </div>
</div>

<div class="modal fade" id="selectedGlobalVarModalMK" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" data-keyboard="false" data-backdrop="static">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Selected Global Variables</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="cancelEditGlobalVarRow('',boqConfigMKVal.category)">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row" *ngIf="editBtnFlag">
                <div class="col-sm-12">
                    <button _ngcontent-c6="" class="rk-interalBtnColor addCursor pull-right my-2 mr-2 editRowSpan" (click)="editGlobalVarRow('',boqConfigMKVal)" *ngIf="globalVarArr && boqConfigMKVal && boqConfigMKVal.category=='kitchen' ">Update Global Variables</button>
                </div>
            </div>
            <div class="table-responsive">
                <table class="table">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Category</th>
                            <th>Type</th>
                            <th></th>
                        </tr>
                    </thead>

                    <!--Modular kitchen-->
                    <tbody *ngIf="globalVarArr && boqConfigMKVal && boqConfigMKVal.category=='kitchen' ">
                        <tr>
                            <td>1</td>
                            <td>Type Of Kitchen</td>
                            <td>
                               <span class="editRowSpan capitalize">
                                    <ng-container *ngIf="boqConfigMKVal.civil_kitchen">Civil Kitchen</ng-container>
                                    <ng-container *ngIf="!boqConfigMKVal.civil_kitchen">Modular Kitchen</ng-container>
                                </span>
                               <select class="form-control d-none editRowInput" [(ngModel)]="typeofkitchen_globalVar_MK">
                                    <option value="">Select</option>
                                    <option value="true">Civil Kitchen</option>
                                    <option value="false">Modular Kitchen</option>
                                </select>
                            </td>
                        </tr>
                        <tr [ngClass]="(typeofkitchen_globalVar_MK===true || typeofkitchen_globalVar_MK==='true')?'d-print-table-cell':'d-none'">
                            <td>2</td>
                            <td>Depth(in mm)</td>
                            <td>
                                <span class="editRowSpan capitalize" *ngIf="boqConfigMKVal.civil_kitchen_parameters">
                                   {{ boqConfigMKVal.civil_kitchen_parameters.depth}}
                                </span>
                                <input type="number" name="" class="form-control d-none editRowInput" [(ngModel)]="depthofcivilKit_globalVar_MK">
                            </td>
                        </tr>
                        <tr [ngClass]="(typeofkitchen_globalVar_MK===true || typeofkitchen_globalVar_MK==='true')?'d-print-table-cell':'d-none'">
                            <td>3</td>
                            <td>Drawer 1 Height in mm(D1)</td>
                            <td>
                               <span class="editRowSpan capitalize" *ngIf="boqConfigMKVal.civil_kitchen_parameters">
                                   {{ boqConfigMKVal.civil_kitchen_parameters.drawer_height_1}}
                                </span>
                                <input type="number" name="" class="form-control d-none editRowInput" [(ngModel)]="drawerheight1ofcivilKit_globalVar_MK">
                            </td>
                        </tr>
                        <tr [ngClass]="(typeofkitchen_globalVar_MK===true || typeofkitchen_globalVar_MK==='true')?'d-print-table-cell':'d-none'">
                            <td>4</td>
                            <td>Drawer 2 Height in mm(D2)</td>
                            <td>
                               <span class="editRowSpan capitalize" *ngIf="boqConfigMKVal.civil_kitchen_parameters">
                                   {{ boqConfigMKVal.civil_kitchen_parameters.drawer_height_2}}
                                </span>
                                <input type="number" name="" class="form-control d-none editRowInput" [(ngModel)]="drawerheight2ofcivilKit_globalVar_MK">
                            </td>
                        </tr>
                        <tr [ngClass]="(typeofkitchen_globalVar_MK===true || typeofkitchen_globalVar_MK==='true')?'d-print-table-cell':'d-none'">
                            <td>5</td>
                            <td>Drawer 3 Height in mm(D3)</td>
                            <td>
                               <span class="editRowSpan capitalize" *ngIf="boqConfigMKVal.civil_kitchen_parameters">
                                   {{ boqConfigMKVal.civil_kitchen_parameters.drawer_height_3}}
                                </span>
                                <input type="number" name="" class="form-control d-none editRowInput" [(ngModel)]="drawerheight3ofcivilKit_globalVar_MK">
                            </td>
                        </tr>
                        <tr>
                            <td *ngIf="typeofkitchen_globalVar_MK==true || typeofkitchen_globalVar_MK==='true'">6</td>
                            <td *ngIf="typeofkitchen_globalVar_MK==false || typeofkitchen_globalVar_MK==='false'">2</td>
                            <td>Core Material</td>
                            <td>
                               <span class="editRowSpan capitalize">{{boqConfigMKVal.core_material.name}}</span>
                               <select class="form-control d-none editRowInput" [(ngModel)]="core_material_globalVar_MK">
                                    <option value="">Select</option>
                                    <option *ngFor="let coremat of globalVarArr.core_material" value="{{coremat.name}}">{{coremat.name}}</option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td *ngIf="typeofkitchen_globalVar_MK==true || typeofkitchen_globalVar_MK==='true'">7</td>
                            <td *ngIf="typeofkitchen_globalVar_MK==false || typeofkitchen_globalVar_MK==='false'">3</td>
                            <td>Shutter Material</td>
                            <td>
                               <span class="editRowSpan capitalize">{{boqConfigMKVal.shutter_material.name}}</span>
                               <select class="form-control d-none editRowInput" [(ngModel)]="shutter_material_globalVar_MK" (change)="listofShutterFinishes(shutter_material_globalVar_MK)">
                                   <option value="">Select</option>
                                    <option *ngFor="let shuttermat of globalVarArr.shutter_material" value="{{shuttermat.name}}">{{shuttermat.name}}</option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td *ngIf="typeofkitchen_globalVar_MK==true || typeofkitchen_globalVar_MK==='true'">8</td>
                            <td *ngIf="typeofkitchen_globalVar_MK==false || typeofkitchen_globalVar_MK==='false'">4</td>
                            <td>Shutter Finish</td>
                            <td>
                                <span class="editRowSpan capitalize">{{boqConfigMKVal.shutter_finish.name}}</span>
                                <select class="form-control d-none editRowInput" [(ngModel)]="shutter_finish_globalVar_MK" (change)="listofShutterFinishShades(shutter_finish_globalVar_MK); getHandleList(shutter_finish_globalVar_MK);">
                                   <option value="">Select</option>
                                    <option *ngFor="let shutterfin of globalVarArr.shutter_finish" value="{{shutterfin.name}}">{{shutterfin.name}}</option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td *ngIf="typeofkitchen_globalVar_MK==true || typeofkitchen_globalVar_MK==='true'">9</td>
                            <td *ngIf="typeofkitchen_globalVar_MK==false || typeofkitchen_globalVar_MK==='false'">5</td>
                            <td> Shutter Shade Code</td>
                            <td>
                                <span class="editRowSpan capitalize" *ngIf="!boqConfigMKVal.custom_shutter_shade_code">{{boqConfigMKVal.shutter_shade_code.code}}</span>
                                <span class="editRowSpan capitalize" *ngIf="boqConfigMKVal.custom_shutter_shade_code">{{boqConfigMKVal.shutter_shade_code}}</span>
                                <select class="form-control d-none editRowInput" [(ngModel)]="shutter_shade_code_globalVar_MK" (change)="setImageModal($event.target.value,'shadeCode',globalVarArr.category)">
                                    <option value="">Select</option>
                                    <option value="customshadecode">Custom shade code</option>
                                    <option *ngFor="let shuttershadecode of globalVarArr.shutter_shade_code" value="{{shuttershadecode.code}}">{{shuttershadecode.code}}</option>
                                </select>
                                <input type="text" name="" class="form-control d-none editRowInput my-1" [(ngModel)]="shutter_custshade_code_globalVar_MK" placeholder="Enter custom shade code" [disabled]="shutter_shade_code_globalVar_MK!='customshadecode'">
                                <img src="{{boqConfigMKVal.shutter_shade_code.shade_image}}" class="my-1 editRowSpan" alt=" No Image" height="60px" width="100px" *ngIf="!boqConfigMKVal.custom_shutter_shade_code && boqConfigMKVal.shutter_shade_code.shade_image" onerror="this.src='./assets/img/no_image.svg'" />
                                <img src="{{shadeImg}}" class="my-1 editRowInput d-none" alt=" No Image" height="60px" width="100px" *ngIf="shadeImg" onerror="this.src='./assets/img/no_image.svg'" />
                            </td>
                        </tr>
                        <tr>
                            <td *ngIf="typeofkitchen_globalVar_MK==true || typeofkitchen_globalVar_MK==='true'">10</td>
                            <td *ngIf="typeofkitchen_globalVar_MK==false || typeofkitchen_globalVar_MK==='false'">6</td>
                            <td> Handle Code</td>
                            <td>
                               <span class="editRowSpan capitalize">{{boqConfigMKVal.door_handle_code}}</span>
                               <a data-toggle="modal" data-target="#doorhandleCodeModal" class="addCursor d-none editRowInput" style="color: blue;" (click)="openHandleModal('kitchen')">Choose Handle code</a><br>
                                <img src="{{doorhandleImg}}" class="my-1 d-none editRowInput"  height="60px" width="100px" *ngIf="doorhandleImg" onerror="this.src='./assets/img/no_image.svg'" /> <span class="ml-2 d-none editRowInput">{{door_handle_code_globalVar_MK}}</span>
                            </td>
                        </tr>
                        <tr>
                            <td *ngIf="typeofkitchen_globalVar_MK==true || typeofkitchen_globalVar_MK==='true'">11</td>
                           <td *ngIf="typeofkitchen_globalVar_MK==false || typeofkitchen_globalVar_MK==='false'">7</td>
                           <td>Hardware Brand</td>
                           <td>
                               <span class="editRowSpan capitalize">{{boqConfigMKVal.brand.name}}</span>
                               <select class="form-control d-none editRowInput" [(ngModel)]="hardware_brand_globalVar_MK">
                                    <option value="">Select</option>
                                    <option *ngFor="let hb of globalVarArr.hardware_brand" value="{{hb.id}}">{{hb.name}}</option>
                                </select>
                           </td>
                        </tr>
                        <tr>
                            <td *ngIf="typeofkitchen_globalVar_MK==true || typeofkitchen_globalVar_MK==='true'">12</td>
                           <td *ngIf="typeofkitchen_globalVar_MK==false || typeofkitchen_globalVar_MK==='false'">8</td>
                           <td> Hinge Type</td>
                           <td>
                               <span class="editRowSpan capitalize">{{boqConfigMKVal.hinge_type}}</span>
                               <select class="form-control d-none editRowInput" [(ngModel)]="hinge_type_globalVar_MK">
                                    <option value="">Select</option>
                                    <option *ngFor="let ht of globalVarArr.hinge_type" value="{{ht}}">{{ht | uppercase}} <span *ngIf="ht=='soft'"> - CLOSE</span></option>
                                </select>
                           </td>
                        </tr>
                        <tr>
                            <td *ngIf="typeofkitchen_globalVar_MK==true || typeofkitchen_globalVar_MK==='true'">13</td>
                           <td *ngIf="typeofkitchen_globalVar_MK==false || typeofkitchen_globalVar_MK==='false'">9</td>
                           <td> Channel Type</td>
                           <td>
                               <span class="editRowSpan capitalize">{{boqConfigMKVal.channel_type}}</span>
                               <select class="form-control d-none editRowInput" [(ngModel)]="channel_type_globalVar_MK">
                                    <option value="">Select</option>
                                    <option *ngFor="let ct of globalVarArr.channel_type" value="{{ct}}">{{ct | uppercase}} <span *ngIf="ct=='soft'"> - CLOSE</span></option>
                                </select>
                           </td>
                        </tr>
                        <tr>
                           <td *ngIf="typeofkitchen_globalVar_MK==true || typeofkitchen_globalVar_MK==='true'">14</td>
                           <td *ngIf="typeofkitchen_globalVar_MK==false || typeofkitchen_globalVar_MK==='false'">10</td>
                           <td> Skirting Config Type</td>
                           <td>
                               <span class="editRowSpan capitalize">{{boqConfigMKVal.skirting_config_type}}</span>
                                <select class="form-control d-none editRowInput" [(ngModel)]="skirting_con_type_globalVar_MK" (change)="listofSkirtingHeights(skirting_con_type_globalVar_MK)">
                                    <option value="">Select</option>
                                    <option *ngFor="let sct of globalVarArr.skirting_config_type" value="{{sct.skirting_type}}">{{sct.skirting_type | uppercase}}</option>
                                </select>
                           </td>
                        </tr>
                        <tr>
                           <td *ngIf="typeofkitchen_globalVar_MK==true || typeofkitchen_globalVar_MK==='true'">15</td>
                           <td *ngIf="typeofkitchen_globalVar_MK==false || typeofkitchen_globalVar_MK==='false'">11</td>
                           <td> Skirting Config Height</td>
                           <td>
                               <span class="editRowSpan capitalize">{{boqConfigMKVal.skirting_config_height}}</span>
                                <select class="form-control d-none editRowInput" [(ngModel)]="skirting_con_height_globalVar_MK">
                                    <option value="">Select</option>
                                    <option *ngFor="let sch of globalVarArr.skirting_config_height" value="{{sch.skirting_height}}">{{sch.skirting_height}}</option>
                                </select>
                           </td>
                        </tr>
                        <tr>
                           <td *ngIf="typeofkitchen_globalVar_MK==true || typeofkitchen_globalVar_MK==='true'">16</td>
                           <td *ngIf="typeofkitchen_globalVar_MK==false || typeofkitchen_globalVar_MK==='false'">12</td>
                           <td> Edge Banding Shade</td>
                           <td>
                               <span class="editRowSpan capitalize" *ngIf="!boqConfigMKVal.custom_edge_banding_shade_code">{{boqConfigMKVal.edge_banding_shade_code.code}}</span>
                               <span class="editRowSpan capitalize" *ngIf="boqConfigMKVal.custom_edge_banding_shade_code">{{boqConfigMKVal.edge_banding_shade_code}}</span>
                               <select class="form-control d-none editRowInput" [(ngModel)]="edgebanding_shade_code_globalVar_MK" (change)="setImageModal($event.target.value,'edgebandingShadeCode',globalVarArr.category)">
                                    <option value="">Select</option>
                                    <option value="customedgebanshadecode">Custom edge banding shade code</option>
                                    <option *ngFor="let ebsc of globalVarArr.edge_banding_shade_code" value="{{ebsc.code}}" [selected]="edgebanding_shade_code_globalVar_MK==ebsc.code">{{ebsc.code}}</option>
                                </select>
                                <input type="text" name="" class="form-control d-none editRowInput my-1" [(ngModel)]="edgebanding_custshade_code_globalVar_MK" placeholder="Enter custom edge banding shade code" [disabled]="edgebanding_shade_code_globalVar_MK!='customedgebanshadecode'">

                                <img src="{{boqConfigMKVal.edge_banding_shade_code.shade_image}}" class="my-1 editRowSpan" alt=" No Image" height="60px" width="100px" *ngIf="!boqConfigMKVal.custom_edge_banding_shade_code && boqConfigMKVal.edge_banding_shade_code.shade_image" onerror="this.src='./assets/img/no_image.svg'" />
                                <img src="{{edgebandingImg}}" class="my-1 editRowInput d-none" alt=" No Image" height="60px" width="100px" *ngIf="edgebandingImg" onerror="this.src='./assets/img/no_image.svg'" />
                           </td>
                        </tr>
                        <tr>
                            <td *ngIf="typeofkitchen_globalVar_MK==true || typeofkitchen_globalVar_MK==='true'">17</td>
                           <td *ngIf="typeofkitchen_globalVar_MK==false || typeofkitchen_globalVar_MK==='false'">13</td>
                           <td> Countertop</td>
                           <td>
                               <span class="editRowSpan capitalize">{{boqConfigMKVal.countertop | replaceChar}}</span>
                               <select class="form-control d-none editRowInput" [(ngModel)]="countertop_globalVar_MK">
                                    <option value="">Select</option>
                                    <option *ngFor="let count_top of globalVarArr.countertop" value="{{count_top}}" [selected]="countertop_globalVar_MK==count_top">{{count_top | replaceChar}}</option>
                                </select>
                           </td>
                        </tr>
                    </tbody>
                </table>
                <div class="row editRowInput d-none" *ngIf="globalVarArr && boqConfigMKVal && boqConfigMKVal.category=='kitchen' ">
                    <div class="col-sm-12 text-right">
                        <button class=" rk-btnCancel my-2" (click)="cancelEditGlobalVarRow('',boqConfigMKVal.category)">Cancel</button>
                        <button class="pull-right rk-interalBtnColor mr-2 my-2" (click)="updateGlobalVar('',boqConfigMKVal.id,boqConfigMKVal.category)">Save</button>
                        <button class="pull-right rk-interalBtnColor mr-2 my-2" (click)="updateAndApplyBoqGlobalConfig('',boqConfigMKVal.id,boqConfigMKVal.category)">Save and Apply</button>
                        <button class="pull-right rk-interalBtnColor mr-2 my-2" (click)="openPresetModal(null,'kitchen','update','#selectedGlobalVarModalMK')">Save As Preset</button>
                    </div>
                </div>
            </div>
          </div>
        </div>
    </div>
</div>

<!--Combined Modules modal-->
<div class="modal fade" id="combinedmodulesModal" tabindex="-1" role="dialog" aria-labelledby="combinedmodulesModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Combined Modules</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="combinemodalData=undefined">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form [formGroup]="combinedModulesForm">
            <div class="row">
                <div class="col-sm-6">
                    <label>Description<span class="text-danger">*</span></label>
                    <input type="text" name="" class="form-control" formControlName="description">
                </div>
                <div class="col-sm-6">
                    <label>Space<span class="text-danger">*</span></label>
                    <input type="text" name="" class="form-control" formControlName="space" readonly>
                </div>
                <div class="col-sm-12 mt-4">
                    <label>Modules<span class="text-danger">*</span></label><br/>
                    <ng-container *ngFor="let sw of combinemodalData">
                        <label class="form-check-label lableSize labelColor mb-2 mr-4" *ngIf="sw.combined==false">
                        <input type="checkbox" class="form-check-input" value="{{sw.id}}" (change)="onCheckChange($event)">
                        {{sw.code}}
                        </label>
                    </ng-container><br/>
                    <span class="text-danger">Note*- Atleaset two modules need to be selected.</span>
                </div>
                <div class="col-sm-12 mt-4">
                    <label>Combined Door<span class="text-danger">*</span></label>
                    <select class="form-control" formControlName="combined_door_id">
                        <option value="">Select Combined Door</option>
                        <option *ngFor="let cd of combined_doors" value="{{cd.id}}">{{cd.name}} - {{cd.code}}</option>
                    </select>
                </div>
                <div class="col-sm-12 mt-2">
                    <button class="rk-interalBtnColor pull-right" (click)="combineModules(combinedModulesForm.value)" [disabled]="!combinedModulesForm.valid || !(getformArray(combinedModulesForm,'modular_job_ids').length>=2)">Combine</button>
                </div>
            </div>
        </form>
      </div>
    </div>
  </div>
</div>


<div class="modal fade" id="editCombineModuleModal" tabindex="-1" role="dialog" aria-labelledby="editCombineModuleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Combined Modules</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="combinemodalData=undefined">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form [formGroup]="combinedModulesForm">
            <div class="row">
                <div class="col-sm-6">
                    <label>Description<span class="text-danger">*</span></label>
                    <input type="text" name="" class="form-control" formControlName="description">
                </div>
                <div class="col-sm-6">
                    <label>Space<span class="text-danger">*</span></label>
                    <input type="text" name="" class="form-control" formControlName="space" readonly>
                </div>
                <div class="col-sm-12 mt-4">
                    <label>Modules<span class="text-danger">*</span></label><br/>
                    <ng-container *ngFor="let sw of combinemodalData">
                        <label class="form-check-label lableSize labelColor mb-2 mr-4" *ngIf="sw.combined==false">
                        <input type="checkbox" class="form-check-input" value="{{sw.id}}" (change)="onCheckChange($event)">
                        {{sw.code}}
                        </label>
                        <ng-container *ngIf="sw.combined==true">
                            <ng-container *ngFor="let data2 of sw.included_modules">
                                <label class="form-check-label lableSize labelColor mb-2 mr-4" *ngIf="data2.combined_module_id==sw.id">
                                <input type="checkbox" class="form-check-input" value="{{data2.id}}" (change)="onCheckChange($event)" [checked]="checkValInFormArray(data2.id,combinedModulesForm,'modular_job_ids')">
                                {{data2.code}}
                                </label>
                            </ng-container>
                        </ng-container>
                    </ng-container><br/>

                    <span class="text-danger">Note*- Atleaset two modules need to be selected.</span>
                </div>
                <div class="col-sm-12 mt-4">
                    <label>Combined Door<span class="text-danger">*</span></label>
                    <select class="form-control" formControlName="combined_door_id">
                        <option value="">Select Combined Door</option>
                        <option *ngFor="let cd of combined_doors" value="{{cd.id}}">{{cd.name}} - {{cd.code}}</option>
                    </select>
                </div>
                <div class="col-sm-12 mt-2">
                    <button class="rk-interalBtnColor pull-right" (click)="editcombineModules(combinedModulesForm.value,editCombineModuleId)" [disabled]="!combinedModulesForm.valid || !(getformArray(combinedModulesForm,'modular_job_ids').length>=2)">Combine</button>
                </div>
            </div>
        </form>
      </div>
    </div>
  </div>
</div>


<!-- add product Modal -->
<div class="modal fade" id="addProductModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" data-keyboard="false" data-backdrop="static">
  <div class="ui-notification" *ngIf="notificationAlert">
    <span id="notificationMessageText">{{product_notify_message}}</span>
    <a class="close linknotification" (click)="notificationAlert=false">×</a>
  </div>
  <div class="modal-dialog my-2 mx-2" role="document">
    <div class="modal-content" id="allproductsRow">
      <div class="modal-header">
        <!--start 1-->
        <div class="container-fluid">
            <div class="row">
                <div class="col-sm-12">
                    <button aria-label="Close" class="close mb-2" data-dismiss="modal" type="button" (click)="closeModal()" style="outline: none;">
                        <img  src="../../../assets/img/cross-out.svg" style="width:15px;">
                    </button>
                </div>
            </div>
          <!--Search box row start-->
          <div class="row mt-3 searchboxRow py-2">
            <div class="col-sm-6">
              <div class="ss-searchbox d-inline-block col-8" style="">
                <i class="fa fa-search"></i>
                <input class="form-control" placeholder="Type in name, unique sku, vendor sku..." type="text" [(ngModel)]="search_string" #ctrl="ngModel">
              </div>
              <div class="col-1 d-inline-block">
                <div class="planeIcon d-inline-block addCursor" (click)="filterProducts()">
                  <img src="assets/v3/img/White_Arrow.svg" height="33px">
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <span class="pull-right addCursor advancefiltertext" (click)="opensideOverlay()">Advance Filters</span>
            </div>
          </div>
          <!--Search box row end-->
          <!--filter dropdowns start-->
          <div class="row mt-3">
            <div class="col-sm-2 px-0 mr-4">
              <div id="dd0" class="wrapper-dropdown-1" tabindex="1" (click)="displayDropDown('dd0')">
                <span class="spanText" id="dd0-text" *ngIf="selectedRangesArr.length==0">Select Range</span>
                <span class="spanText" *ngIf="selectedRangesArr.length>0"><ng-container *ngFor="let range of selectedRangesArr">{{range.humanized_name}},</ng-container></span>
              </div>
              <ul class="dd-dropdown px-2 py-2 d-none mt-0" id="dd0-dropdown">
                <!-- {{spaces_list | json}} -->
                <li *ngFor="let opt of ranges_list" class="my-2">
                  <label class="checkbox-container">{{opt.humanized_name}}
                    <input type="checkbox" value="{{opt | json}}" name="opt" class="" id="text{{opt.id}}" (change)="checkRanges($event)" [checked]="isElementPresent(opt,selectedRangesArr)">
                    <span class="checkbox-checkmark"></span>
                  </label>
                  <div class="pull-right mr-2 dd-countbox">{{opt.product_count}}</div>
                </li>
              </ul>
            </div>
            <div class="col-sm-2 px-0 mr-4">
              <div id="dd1" class="wrapper-dropdown-1" tabindex="1" (click)="displayDropDown('dd1')">
                <span class="spanText" id="dd1-text" *ngIf="selectedSpacesLooseFurArr.length==0">Select Space</span>
                <span class="spanText" *ngIf="selectedSpacesLooseFurArr.length>0"><ng-container *ngFor="let space of selectedSpacesLooseFurArr">{{space.humanized_name}},</ng-container></span>
              </div>
              <ul class="dd-dropdown px-2 py-2 d-none mt-0" id="dd1-dropdown">
                <li *ngFor="let opt of spaces_list" class="my-2">
                  <label class="checkbox-container">{{opt.humanized_name}}
                    <input type="checkbox" value="{{opt | json}}" name="opt" class="" id="text{{opt.id}}" (change)="checkSpaces($event)" [checked]="isElementPresent(opt,selectedSpacesLooseFurArr)">
                    <span class="checkbox-checkmark"></span>
                  </label>
                  <div class="pull-right mr-2 dd-countbox">{{opt.product_count}}</div>
                </li>
              </ul>
            </div>
            <div class="col-sm-2 px-0 mr-4">
              <div id="dd2" class="wrapper-dropdown-1" tabindex="1" (click)="displayDropDown('dd2')">
                <span class="spanText" id="dd2-text" *ngIf="selectedCategoriesLooseFurArr.length==0">Select Category</span>
                <span class="spanText" *ngIf="selectedCategoriesLooseFurArr.length>0"><ng-container *ngFor="let cat of selectedCategoriesLooseFurArr">{{cat.name}},</ng-container></span>
              </div>
              <ul class="dd-dropdown px-2 py-2 d-none mt-0" id="dd2-dropdown">
                <li *ngIf="categories_list.length==0">No Category</li>
                <li *ngFor="let opt of categories_list" class="my-2">
                  <label class="checkbox-container">{{opt.name}}
                    <input type="checkbox" value="{{opt | json}}" name="opt" class="" id="text{{opt.id}}" (change)="checkCategory($event)" [checked]="isElementPresent(opt,selectedCategoriesLooseFurArr)">
                    <span class="checkbox-checkmark"></span>
                  </label>
                  <div class="pull-right mr-2 dd-countbox">{{opt.product_count}}</div>
                </li>
              </ul>
            </div>
            <div class="col-sm-2 px-0 mr-3">
              <div id="dd3" class="wrapper-dropdown-1" tabindex="1" (click)="displayDropDown('dd3')">
                <span class="spanText" id="dd3-text" *ngIf="selectedSubCategoriesLooseFurArr.length==0">Select Configuration</span>
                <span class="spanText" *ngIf="selectedSubCategoriesLooseFurArr.length>0"><ng-container *ngFor="let subcat of selectedSubCategoriesLooseFurArr">{{subcat.configuration}},</ng-container></span>
              </div>
              <ul class="dd-dropdown px-2 py-2 d-none mt-0" id="dd3-dropdown">
                <li *ngIf="subcategories_list.length==0">No Configuration</li>
                <li *ngFor="let opt of subcategories_list" class="my-2">
                  <label class="checkbox-container">{{opt.configuration}}
                    <input type="checkbox" value="{{opt | json}}" name="opt" class="" id="text{{opt}}" (change)="checkSubCategory($event)" [checked]="isElementPresent(opt,selectedSubCategoriesLooseFurArr,'subcategory')">
                    <span class="checkbox-checkmark"></span>
                  </label>
                  <div class="pull-right mr-2 dd-countbox">{{opt.count}}</div>
                </li>
              </ul>
            </div>
            <div class="col-2 pt-1">
              <div _ngcontent-c8="" class="planeIcon d-inline-block addCursor" (click)="filterProducts()">
                <img _ngcontent-c8="" height="33px" src="assets/v3/img/White_Arrow.svg">
              </div>
            </div>
          </div>
          <!--filter dropdowns end-->

          <!--Selected Elements Rows start-->
          <div class="row mt-3" *ngIf="selectedRangesArr.length>0">
            <div class="col-sm-1 mt-2 px-0 selectedElementsText">Range : </div>
            <div class="col-sm-11 mt-2">
              <div class="d-inline-block px-2 py-1 selectedBlocks capitalize" *ngFor="let range of selectedRangesArr; let index = index">{{range.humanized_name}}<i class="fa fa-times ml-2 addCursor" (click)="removeElement(range,selectedRangesArr,checked_ranges,'range')"></i>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="selectedSpacesLooseFurArr.length>0">
            <div class="col-sm-1 mt-2 px-0 selectedElementsText">Space : </div>
            <div class="col-sm-11 mt-2">
              <div class="d-inline-block px-2 py-1 selectedBlocks capitalize" *ngFor="let space of selectedSpacesLooseFurArr; let index = index">{{space.humanized_name}}<i class="fa fa-times ml-2 addCursor" (click)="removeElement(space,selectedSpacesLooseFurArr,checked_spaces,'space')"></i>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="selectedCategoriesLooseFurArr.length>0">
            <div class="col-sm-1 mt-2 px-0 selectedElementsText">Category : </div>
            <div class="col-sm-11 mt-2">
              <div class="d-inline-block px-2 py-1 selectedBlocks capitalize" *ngFor="let cat of selectedCategoriesLooseFurArr; let index = index">{{cat.name}}<i class="fa fa-times ml-2 addCursor" (click)="removeElement(cat,selectedCategoriesLooseFurArr,checked_categories,'category')"></i>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="selectedSubCategoriesLooseFurArr.length>0">
            <div class="col-sm-1 mt-2 px-0 selectedElementsText">Configuration : </div>
            <div class="col-sm-11 mt-2">
              <div class="d-inline-block px-2 py-1 selectedBlocks capitalize" *ngFor="let subcat of selectedSubCategoriesLooseFurArr; let index = index">{{subcat.configuration}}<i class="fa fa-times ml-2 addCursor" (click)="removeElement(subcat,selectedSubCategoriesLooseFurArr,checked_subcategories,'subcategory')"></i>
              </div>
            </div>
          </div>
          <div class="row"><div class="my-3 borderSeparator col-sm-12"></div></div>
          <!--Selected Elements Rows end-->
        </div>
      <!--end 1-->
      </div>
      <div class="modal-body pt-0"  style="min-height: 100vh;">
        <div class="container-fluid">
            <p class="text-center" *ngIf="products_list.length==0">No Product Available</p>
          <div class="row mt-3" *ngIf="products_list.length>0">
            <div class="col-sm-4 px-2 py-2 productCard" *ngFor="let product of products_list| paginate: { itemsPerPage: per_page, currentPage: current_page, totalItems: total_page  }">
              <div class="card px-2 pt-2">
                <img class="product-card-img" src="{{product.image_urls[0]}}" *ngIf="product.image_urls[0]" onerror="this.src='./assets/img/no_image.svg'" >
                <p>
                  <span class="product-card-text pull-left mt-3" style="width: 50%">{{product.name}}</span>
                  <span class="product-card-text pull-right mt-3">Price: &#8377; {{product.sale_price}}</span>
                </p>
              </div>
              <button class="btn btn-block button" (click)="viewmoreProductDetails(product.id,product.section_id)">View More</button>
            </div>
          </div>
          <div class="row text-center" *ngIf="products_list && products_list.length >0">
            <div class="col-sm-12"><pagination-controls autoHide="true" (pageChange)="current_page = filterProducts($event)"></pagination-controls></div>
          </div>
        </div>
        <!--overlay start-->
        <div class="sidenav-overlay row mx-0 d-none" id="sidenavoverlay" style="width: 100%;">
          <div class="col-9 backdropDiv"></div>
          <div class="col-3 filterDiv">
            <div class="row"><div class="col-12"><i class="fa fa-times-circle overlay_closebtn pull-right mt-3 addCursor" (click)="closesideOverlay()"></i> </div></div>

            <!-- Materials -->
            <div class="row mt-3">
              <div class="col-12">
                <div>
                  <div id="dd4" class="wrapper-dropdown-1" tabindex="1" (click)="displayDropDown('dd4')">
                    <span class="spanText" id="dd4-text" *ngIf="checked_materials.length==0">Select Materials</span>
                    <span class="spanText" *ngIf="checked_materials.length>0"><ng-container *ngFor="let material of checked_materials">{{material}},</ng-container></span>
                  </div>
              </div>
              </div>
              <div class="col-12">
                <ul class="dd-dropdown px-2 py-2 d-none mt-0" id="dd4-dropdown" style="width: 90%;">
                  <li *ngFor="let opt of all_materials" class="my-2">
                    <label class="checkbox-container">{{opt}}
                      <input type="checkbox" value="{{opt}}" name="opt" class="" id="text{{opt}}" (change)="checkElement('materials',$event)" [checked]="isElementPresent(opt,selectedSpacesArr)">
                      <span class="checkbox-checkmark"></span>
                    </label>
                  </li>
                </ul>
              </div>
            </div> 

            <!-- Colors -->
            <div class="row mt-3">
              <div class="col-12">
                <div>
                  <div id="dd5" class="wrapper-dropdown-1" tabindex="1" (click)="displayDropDown('dd5')">
                    <span class="spanText" id="dd5-text" *ngIf="checked_colors.length==0">Select Colors</span>
                    <span class="spanText" *ngIf="checked_colors.length>0"><ng-container *ngFor="let color of checked_colors">{{color}},</ng-container></span>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <ul class="dd-dropdown px-2 py-2 d-none mt-0" id="dd5-dropdown" style="width: 90%;">
                  <li *ngFor="let opt of all_colors" class="my-2">
                    <label class="checkbox-container">{{opt}}
                      <input type="checkbox" value="{{opt}}" name="opt" class="" id="text{{opt}}" (change)="checkElement('colors',$event)" [checked]="isElementPresent(opt,selectedSpacesArr)">
                      <span class="checkbox-checkmark"></span>
                    </label>
                  </li>
                </ul>
              </div>
            </div> 

            <!-- Finish -->
            <div class="row mt-3">
              <div class="col-12">
                <div>
                  <div id="dd6" class="wrapper-dropdown-1" tabindex="1" (click)="displayDropDown('dd6')">
                    <span class="spanText" id="dd6-text" *ngIf="checked_finishes.length==0">Select Finishes</span>
                    <span class="spanText" *ngIf="checked_finishes.length>0"><ng-container *ngFor="let finish of checked_finishes">{{finish}},</ng-container></span>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <ul class="dd-dropdown px-2 py-2 d-none mt-0" id="dd6-dropdown" style="width: 90%;">
                  <li *ngFor="let opt of all_finishes" class="my-2">
                    <label class="checkbox-container">{{opt}}
                      <input type="checkbox" value="{{opt}}" name="opt" class="" id="text{{opt}}" (change)="checkElement('finishes',$event)" [checked]="isElementPresent(opt,selectedSpacesArr)">
                      <span class="checkbox-checkmark"></span>
                    </label>
                  </li>
                </ul>
              </div>
            </div> 

            <div class="row mt-3">
              <div class="col-12">
                <div class="mb-4">
                  <span class="pull-left sideoverlay-filterHeading">Price</span>
                  <span class="pull-right sideoverlay-minusicon">&minus;</span>
                </div>
                <hr>
              </div>
              <div class="col-12">
                <ion-range-slider #priceSliderElement
                          type="double"
                          [min]="all_minimum_price"
                          [max]="all_maximum_price"
                          [from]="all_minimum_price"
                          [from_min]="all_minimum_price"
                          [from_max]="(all_maximum_price)-1"
                          from_shadow="true"
                          [to]="all_maximum_price"
                          [to_min]="all_minimum_price+1"
                          [to_max]="all_maximum_price"
                          to_shadow="true"
                          grid="false"
                          prefix="Price: "
                          postfix=" INR"
                          decorate_both="false" 
                          (onUpdate)="updateSlider('price',advancedSlider, $event)"
                          (onChange)="updateSlider('price', advancedSlider, $event)">
                </ion-range-slider>
              </div>
            </div> 
            <div class="row mt-3">
              <div class="col-12">
                <div class="mb-4">
                  <span class="pull-left sideoverlay-filterHeading">Width</span>
                  <span class="pull-right sideoverlay-minusicon">&minus;</span>
                </div>
                <hr>
              </div>
              <div class="col-12">
                <ion-range-slider #widthSliderElement
                          type="double"
                          [min]="all_minimum_width"
                          [max]="all_maximum_width"
                          [from]="all_minimum_width"
                          [from_min]="all_minimum_width"
                          [from_max]="(all_maximum_width)-1"
                          from_shadow="true"
                          [to]="all_maximum_width"
                          [to_min]="all_minimum_width+1"
                          [to_max]="all_maximum_width"
                          to_shadow="true"
                          grid="false"
                          prefix="Width: "
                          postfix=" mm"
                          decorate_both="false" 
                          (onUpdate)="updateSlider('width',advancedSlider, $event)"
                          (onChange)="updateSlider('width', advancedSlider, $event)">
                </ion-range-slider>
              </div>
            </div> 
            <div class="row mt-3">
              <div class="col-12">
                <div class="mb-4">
                  <span class="pull-left sideoverlay-filterHeading">Depth</span>
                  <span class="pull-right sideoverlay-minusicon">&minus;</span>
                </div>
                <hr>
              </div>
              <div class="col-12">
                <ion-range-slider #depthSliderElement
                          type="double"
                          [min]="all_minimum_length"
                          [max]="all_maximum_length"
                          [from]="all_minimum_length"
                          [from_min]="all_minimum_length"
                          [from_max]="(all_maximum_length)-1"
                          from_shadow="true"
                          [to]="all_maximum_length"
                          [to_min]="all_minimum_length+1"
                          [to_max]="all_maximum_length"
                          to_shadow="true"
                          grid="false"
                          prefix="Depth: "
                          postfix=" mm"
                          decorate_both="false" 
                          (onUpdate)="updateSlider('length',advancedSlider, $event)"
                          (onChange)="updateSlider('length', advancedSlider, $event)">
                </ion-range-slider>
              </div>
            </div> 
            <div class="row mt-3">
              <div class="col-12">
                <div class="mb-4">
                  <span class="pull-left sideoverlay-filterHeading">Height</span>
                  <span class="pull-right sideoverlay-minusicon">&minus;</span>
                </div>
                <hr>
              </div>
              <div class="col-12">
                <ion-range-slider #heightSliderElement
                          type="double"
                          [min]="all_minimum_height"
                          [max]="all_maximum_height"
                          [from]="all_minimum_height"
                          [from_min]="all_minimum_height"
                          [from_max]="(all_maximum_height)-1"
                          from_shadow="true"
                          [to]="all_maximum_height"
                          [to_min]="all_minimum_height+1"
                          [to_max]="all_maximum_height"
                          to_shadow="true"
                          grid="false"
                          prefix="Height: "
                          postfix=" mm"
                          decorate_both="false" 
                          (onUpdate)="updateSlider('height',advancedSlider, $event)"
                          (onChange)="updateSlider('height', advancedSlider, $event)">
                </ion-range-slider>
              </div>
            </div> 
            <div class="row mt-3">
              <div class="col-12">
                <div class="mb-4">
                  <span class="pull-left sideoverlay-filterHeading">Lead Time</span>
                  <span class="pull-right sideoverlay-minusicon">&minus;</span>
                </div>
                <hr>
              </div>
              <div class="col-12">
                <ion-range-slider #leadtimeSliderElement
                          type="double"
                          min="0"
                          max="180"
                          from="0"
                          from_min="0"
                          from_max="180"
                          from_shadow="true"
                          to="180"
                          to_min="0"
                          to_max="180"
                          to_shadow="true"
                          grid="false"
                          prefix="Lead Time: "
                          postfix=" days"
                          decorate_both="false" 
                          (onUpdate)="updateSlider('lead_time',advancedSlider, $event)"
                          (onChange)="updateSlider('lead_time', advancedSlider, $event)">
                </ion-range-slider>
              </div>
            </div> 

            <div class="row mt-3">
              <div class="col-12">
                <div class="my-4 pull-right">
                  <input type="button" name="" value="Filter" (click) = "filterProducts()" class=" rk-interalBtnColor addCursor" >
                </div>
                <hr>
              </div>
            </div>

          </div>  
        </div>
        <!--overlay end-->
      </div>
    </div>
  </div>
  <!--Product details modal start-->
  <div class="modal-dialog my-1 mx-2" role="document">
    <div class="modal-content modal-change" id="viewproductRow" style="display: 'none'!important">
      <div class="modal-header" *ngIf="product_details">
        <div class="col-sm-9">
          <a (click)="backToProducts()" class="addCursor" style="color: #1caede;"><i class="fa fa-arrow-left mr-2"></i>Back to products</a>
        </div>
        <div class="col-sm-2 pull-right">
        </div>
      </div>
      <div class="modal-body" *ngIf="product_details">
        <div class="row justify-content-center">
          <div class="col-11">
            <div class="row">
              <div class="col-md-6 cl-chng">
                <div class="row">
                  <div class="col-md-8">
                    <div class="mainDiv">
                      <img class="addCursor mb-2 img-scaledown" src="{{product_details.image_urls[0]}}" width="100%" height="400px;" *ngIf="product_details.image_urls[0]" onerror="this.src='./assets/img/no_image.svg'">
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6 cl-chngs" *ngIf="product_details">
                <div class="row infos-change">
                  <div class="col-12">
                      <div class="text-chng">
                        <h4>{{ product_details.name }}</h4>
                      </div>
                    <div class="row">
                      <div class="col-md-6 price-chng">
                        &#8377; {{ product_details.sale_price }}
                      </div>
                      <div class=" col-md-6 sku-chng">
                        SKU Code : {{product_details.unique_sku}}
                      </div>
                    </div>
                    <hr>
                  </div>
                </div>
                <div class="row p-0 img-chng">
                  <div class="col-md-3 mt-4 " *ngFor="let variation of product_variations" (click)="showVariationDetails(variation)">
                    <div class="card" style="width: 5.5rem;">
                      <div class="card-body  body-chng">
                        <img src="{{variation.image_urls[0]}}" height="50px" width="50px" *ngIf="variation.image_urls[0]" onerror="this.src='./assets/img/no_image.svg'" class="img-scaledown">
                      </div>
                    </div>

                  </div>
                </div>
                <br>
                <form [formGroup]="modalQuantityandProductSelectionForm" (ngSubmit)="addProductToBoqs(product_details,modalQuantityandProductSelectionForm.value); " class="col-10 productDetailsSpan">
                  <label>Quantity : </label>
                  <input class="form-control ml-3" type="number" name="productQty" style="width: 30%; display: inline-block;" formControlName="productQty" min="1">
                  <button class="interalBtnColor cartBtn addCursor" type="submit">Select Product</button>
                </form>
              </div>
            </div>
            <div class="row mt-5">
              <div class="col-md-12 details-info">
                <p class="marg-chng">Items Details</p>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="row">
                  <div class="col-md-12 details-infos">
                    <div class="text-infos">
                      Product Information
                    </div>
                    <hr style="border-top: 2px dashed #a2a0a2;">
                    <div class="row">
                      <div class="col-md-4">
                        <ul class="font-chng">
                          <li class="mb-2">Color: {{ product_details.color}}</li>
                          <li class="mb-2">Configuration: {{ product_details.product_config}}</li>
                          <li>Measurement Unit: {{ product_details.measurement_unit}}</li>
                        </ul>
                      </div>
                      <div class="col-md-4">
                        <ul class="font-chng">
                          <li class="mb-2">Lead Time: {{ product_details.lead_time}}</li>
                          <li class="mb-2">Finish: {{ product_details.finish}}</li>
                          <li>Dimension Remark: {{ product_details.dimension_remark}}</li>
                        </ul>
                      </div>
                      <div class="col-md-4">
                        <ul class="font-chng">
                          <li class="mb-2">Dimension(mm): {{ product_details.width}}X{{ product_details.length}}X{{ product_details.height}}</li>
                          <li class="mb-2">Material: {{ product_details.material}}</li>
                          <li>Remarks: {{ product_details.remark}}</li>
                        </ul>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <ul class="font-chng" style="margin-top: 0px;">
                          <li>Warranty: {{ product_details.warranty}}</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--Product details modal end-->
</div>


<div class="modal fade" id="addsectionmodal" tabindex="-1" role="dialog" aria-labelledby="shadeCodeModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Add Sections </h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
          </button>
      </div>
      <div class="modal-body">
          <form [formGroup]="addSectionToBoqForm">
            <div class="sectionDiv">
              <ng-container *ngIf="!selectedSections.includes('modular_wardrobe')"><input type="checkbox" name="sections" value="modular_wardrobe" (change)="onCheckChange2($event,'addsection')" class="sectionType-class"> <span class="activeselectColor sectionType-class mr-3">Modular Wardrobe</span></ng-container>
              <ng-container *ngIf="!selectedSections.includes('modular_kitchen')"><input type="checkbox" name="sections" value="modular_kitchen" (change)="onCheckChange2($event,'addsection')" class="sectionType-class"> <span class="activeselectColor sectionType-class mr-3">Modular Kitchen</span></ng-container>
              <ng-container *ngIf="!selectedSections.includes('loose_furniture')"><input type="checkbox" name="sections" value="loose_furniture" (change)="onCheckChange2($event,'addsection')" class="sectionType-class"><span class="activeselectColor sectionType-class mr-3"> Loose Furniture</span></ng-container>
              <ng-container *ngIf="!selectedSections.includes('services')"><input type="checkbox" name="sections" value="services" (change)="onCheckChange2($event,'addsection')" class="sectionType-class"><span class="activeselectColor sectionType-class mr-3">  Services</span></ng-container>
              <ng-container *ngIf="!selectedSections.includes('custom_elements')"><input type="checkbox" name="sections" value="custom_elements" (change)="onCheckChange2($event,'addsection')" class="sectionType-class"><span class="activeselectColor sectionType-class mr-3">  Custom Elements</span></ng-container>
            </div>
            <button class="rk-interalBtnColor addCursor pull-right" (click)="submitAddSectionForm(addSectionToBoqForm.value)" [disabled]="!addSectionToBoqForm.valid">Add</button>
          </form>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="shadeCodeModal" tabindex="-1" role="dialog" aria-labelledby="shadeCodeModalLabel" aria-hidden="true" style="overflow-y: scroll;">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Select Shade Code</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeCodeModals()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row mb-2" *ngIf="globalVarArr">
                    <div class="col-4"><label>Enter custom shade code</label></div>
                    <div class="col-8">
                        <input type="text" class="form-control d-inline" placeholder="Enter custom shade code" style="width:54%" [(ngModel)]="customshadecode"><button class="rk-interalBtnColor ml-3 addCursor" (click)="addCustomShadeCode(globalVarArr.category)" [disabled]="customshadecode==undefined">Add</button>
                    </div>
                </div>
                <div class="">
                    <hr class="custom-hr hrTag">
                </div>
                <div class="row" *ngIf="globalVarArr">
                    <div class="col-sm-2 text-center" *ngFor=" let shadecode of globalVarArr.shutter_shade_code">
                        <img src="{{shadecode.shade_image}}" (click)="setImage(shadecode.code,'shadeCode',globalVarArr.category)" height="75px" style=" max-width: 100px;" *ngIf="shadecode.shade_image" onerror="this.src='./assets/img/no_image.svg';" alt="Missing Image" class="addCursor">
                        <p (click)="setImage(shadecode.code,'shadeCode',globalVarArr.category)" class="text-center mt-2 addCursor">{{shadecode.code}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="edgebandingShadeModal" tabindex="-1" role="dialog" aria-labelledby="edgebandingShadeModalLabel" aria-hidden="true" style="overflow-y: scroll;">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Select Edge Banding Shade Code</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeCodeModals()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row mb-2" *ngIf="globalVarArr">
                    <div class="col-4"><label>Enter custom edge banding shade code</label></div>
                    <div class="col-8">
                        <input type="text" class="form-control d-inline" placeholder="Enter custom edge banding shade code" style="width:60%" [(ngModel)]="customedgebanshadecode"><button class="rk-interalBtnColor ml-3 addCursor" (click)="addCustomEdgeBanShadeCode(globalVarArr.category)" [disabled]="customedgebanshadecode==undefined">Add</button>
                    </div>
                </div>
                <div class="">
                    <hr class="custom-hr hrTag">
                </div>
                <div class="row" *ngIf="globalVarArr">
                    <div class="col-sm-2 text-center" *ngFor=" let edgebandingcode of globalVarArr.edge_banding_shade_code" [ngClass]= "{'highlighted-box': (edgebandingcode.code==edgebanding_shade_code_globalVar_MK && globalVarArr.category=='kitchen') || (edgebandingcode.code==edgebanding_shade_code_globalVar_MW && globalVarArr.category=='wardrobe')}">
                        <img src="{{edgebandingcode.shade_image}}" (click)="setImage(edgebandingcode.code,'edgebandingShadeCode',globalVarArr.category)" height="75px" style=" max-width: 100px;" *ngIf="edgebandingcode.shade_image" onerror="this.src='./assets/img/no_image.svg';" alt="Missing Image" class="addCursor">
                        <p (click)="setImage(edgebandingcode.code,'edgebandingShadeCode',globalVarArr.category)" class="text-center mt-2 addCursor">{{edgebandingcode.code}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<!--Add extras modal-->
<div class="modal fade" id="addExtrasModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog my-2 mx-2" role="document">
        <div class="modal-content" id="allextrasRow">
            <div class="modal-header">
                <div class="container-fluid">
                    <div class="row justify-content-center">
                        <div class="col-2"></div>
                        <div class="col-10 pl-5">
                            <div class="ss-searchbox ss-searchbox_extra d-inline-block ml-2">
                                <i class="fa fa-search"></i>
                                <input class="form-control" type="text" placeholder="Type vendor SKU/ description/ specifications  to search..." #search (keyup)="0" [(ngModel)]="search_string_extra_filter">
                            </div>
                            <button class="rk-interalBtnColor addCursor" (click)="getKitchenExtras()">Search</button>
                        </div>
                    </div>
                </div>
                <button type="button" class="close addExtrastModalClose" data-dismiss="modal" aria-label="Close" (click)="closeAddExtraModal()">
                <span aria-hidden="true"><img src="../../../assets/img/cross-out.svg" style="width:15px;"></span>
                </button>
            </div>
            <div class="modal-body pt-0">
                <div class="row">
                    <div class="col-md-2">
                        <div class="mx-2">
                            <div class="mb-3">
                                <h6 class="rk-textColor py-2" style="border-bottom: 1px solid lightgray;">By Make <span class="pull-right">_</span></h6>
                                {{brand_name_extra_filter }}
                                <div class="aa-text" *ngFor="let data of makeforextras_filter">
                                    <input type="checkbox" name="brand_name_extra_filter" class="mr-1" value="{{data.name}}" (change)="onCheckChangeFilter($event,'make','extra')" [checked]="brand_name_extra_filter.includes(data.name)"> <span class="sideOption">{{data.name}} </span>
                                </div>
                            </div>
                            <div class="mb-3">
                                <h6 class="rk-textColor py-2" style="border-bottom: 1px solid lightgray;">By Addon Tag<span class="pull-right">-</span></h6>
                                <div class="aa-text" *ngFor="let tag of addontagsArr">
                                    <input type="checkbox" name="tagvals" class="mr-1" value="{{tag.name}}" (change)="onCheckChangeFilter($event,'addontag','extra')" [checked]="tags_extras_filter.includes(tag.name)"> <span class="sideOption" >{{tag.name}}</span>
                                    <br>
                                </div>
                            </div>
                            <h6 class="rk-textColor py-2" style="border-bottom: 1px solid lightgray;">By Price<span class="pull-right">-</span></h6>
                            <ion-range-slider #advancedSliderElement
                                      type="double"
                                      min="0"
                                      max="100000"
                                      [from]="fromval_slider"
                                      from_min="0"
                                      from_max="49999"
                                      from_shadow="true"
                                      [to]="toval_slider"
                                      to_min="50000"
                                      to_max="100000"
                                      to_shadow="true"
                                      grid="false"
                                      prefix="Price: "
                                      postfix=" Rs."
                                      decorate_both="false" 
                                      (onUpdate)="update(advancedSlider, $event)"
                                      (onChange)="update(advancedSlider, $event)"
                                      (onFinish)="finish(advancedSlider, $event)">
                            </ion-range-slider>
                            <input type="number" name="" (input) = "changeSliderValue('from', $event.target.value)" class="form-control d-inline" style="width: 47%" [(ngModel)]="fromval_slider">
                            <input type="number" name=""  (input) = "changeSliderValue('to',$event.target.value)" class="form-control d-inline" style="width: 49%" [(ngModel)]="toval_slider">

                            <button class="rk-interalBtnColor mt-3" (click)="getKitchenExtras();">Apply Filters</button>
                        </div>
                    </div>
                    <div class="col-sm-10 bgColor">
                        <div class="row justify-content-center">
                            <div class="col-11">
                                <div class="row" *ngIf="kitchenExtras && kitchenExtras.length>0; else no_product">
                                    <div class="col-sm-3" *ngFor="let kitchenextra of kitchenExtras; let ki=index;">
                                        <div class="card card-chng mb-5 py-2">
                                            <img class="card-img-top" src="{{kitchenextra.addon_image}}"  *ngIf="kitchenextra.addon_image" onerror="this.src='./assets/img/no_image.svg';" alt="Missing Image">
                                            <div class="card-body" style="min-height: 14rem;">
                                                <h6 class="card-title textColor1 rk-textColor capitalize">{{kitchenextra.code}}</h6>
                                                <p class="card-text textColor2 capitalize">Description : {{kitchenextra.name}}</p>
                                                <p class="card-text textColor2 capitalize">Vendor SKU : {{kitchenextra.vendor_sku}}</p>
                                                <p class="card-text textColor2 capitalize">Brand : {{kitchenextra.brand_name}}</p>
                                                <p class="card-text textColor2 capitalize">Specification : {{kitchenextra.specifications}}</p>
                                                <p class="textColor2 capitalize">Price : &#8377; {{kitchenextra.price}}</p>
                                            </div>
                                            <div class="card-footer">
                                                <form [formGroup]="addExtraFormMk"> 
                                                    <input type="number" class="d-inline form-control" style="
                                                    width: 70%;" placeholder="Enter Quantity" formControlName="qty" name="qty" id="extraqtyinput_{{ki}}" min="1">
                                                    <button class="rk-interalBtnColor addCursor d-inline" (click)="addExtra_new(kitchenextra.id,addExtraFormMk.value,ki)">Add</button>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <ng-template #no_product>No Extra available</ng-template>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 text-right">
                                <button class="rk-interalBtnColor mr-2" (click)="prevPage('extra')" *ngIf="pageno_extra>1"><i class="fa fa-angle-double-left mr-2" style="font-size: 19px;font-weight: bold;"></i>Prev.</button>
                                <button class="rk-interalBtnColor" (click)="nextPage('extra')">Next<i class="fa fa-angle-double-right ml-2" style="font-size: 19px;font-weight: bold;"></i></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--delete section-->
<div class="modal fade" id="deletesectionmodal" tabindex="-1" role="dialog" aria-labelledby="deleteSectionModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Delete Sections </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <form [formGroup]="deleteSectionToBoqForm">
                    <div class="sectionDiv">
                        <ng-container *ngIf="selectedSections.includes('modular_wardrobe')"><input type="checkbox" name="sections" value="modular_wardrobe" (change)="onCheckChange2($event,'deletesection')" class="sectionType-class"> <span class="activeselectColor sectionType-class mr-3">Modular Wardrobe</span></ng-container>
                        <ng-container *ngIf="selectedSections.includes('modular_kitchen')"><input type="checkbox" name="sections" value="modular_kitchen" (change)="onCheckChange2($event,'deletesection')" class="sectionType-class"> <span class="activeselectColor sectionType-class mr-3">Modular Kitchen</span></ng-container>
                        <ng-container *ngIf="selectedSections.includes('loose_furniture')"><input type="checkbox" name="sections" value="loose_furniture" (change)="onCheckChange2($event,'deletesection')" class="sectionType-class"><span class="activeselectColor sectionType-class mr-3"> Loose Furniture</span></ng-container>
                        <ng-container *ngIf="selectedSections.includes('services')"><input type="checkbox" name="sections" value="services" (change)="onCheckChange2($event,'deletesection')" class="sectionType-class"><span class="activeselectColor sectionType-class mr-3">  Services</span></ng-container>
                        <ng-container *ngIf="selectedSections.includes('custom_elements')"><input type="checkbox" name="sections" value="custom_elements" (change)="onCheckChange2($event,'deletesection')" class="sectionType-class"><span class="activeselectColor sectionType-class mr-3">  Custom Elements</span></ng-container>
                  </div>
                  <button class="rk-interalBtnColor addCursor pull-right" (click)="submitdeleteSectionForm(deleteSectionToBoqForm.value)" [disabled]="!deleteSectionToBoqForm.valid">Delete</button>
                </form>
            </div>
        </div>
    </div>
</div>



<!--Add addon modal-->
<div class="modal fade" id="addAddonModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" data-keyboard="false" data-backdrop="static">
    <div class="modal-dialog my-2 mx-2" role="document" style="max-width:100%">
        <div class="modal-content" id="alladdonsRow">
            <div class="modal-header">
                <div class="container-fluid">
                    <div class="row justify-content-center">
                        <div class="col-2"></div>
                        <div class="col-10 pl-5">
                            <div class="ss-searchbox ss-searchbox_extra d-inline-block ml-2">
                                <i class="fa fa-search"></i>
                                <input class="form-control" type="text" placeholder="Type vendor SKU/ description/ specifications  to search..." #search (keyup)="0" [(ngModel)]="search_string_addon_filter">
                            </div>
                            <button class="rk-interalBtnColor addCursor" (click)="getCompulsoryAddons(customizationModule_MK_details.product_module_id,slotnameForAddon,slotindex)" *ngIf="addonModalType=='compaddon'">Search</button>
                            <button class="rk-interalBtnColor addCursor" (click)="getListofAddonsForAddons(getformArray(customizationModule_MK_Form,'compulsory_addons').controls[slotindex]['controls'].id.value,getformArray(customizationModule_MK_Form,'compulsory_addons').controls[slotindex]['controls'].slot.value,slotindex);" *ngIf="addonModalType=='addonforaddon'">Search</button>

                        </div>
                    </div>
                </div>
                <button type="button" class="close addExtrastModalClose" (click)="closeAddAddonModal()">
                <span aria-hidden="true"><img src="../../../assets/img/cross-out.svg" style="width:15px;"></span>
                </button>
            </div>
            <div class="modal-body pt-0">
                <div class="row">
                    <div class="col-md-2">
                        <div class="mx-2">
                            <div class="mb-3">
                                <h6 class="rk-textColor py-2" style="border-bottom: 1px solid lightgray;">By Make <span class="pull-right">_</span></h6>
                                <div class="aa-text" *ngFor="let data of makeforextras_filter">
                                    <input type="checkbox" name="brand_name_extra_filter" class="mr-1" value="{{data.name}}" (change)="onCheckChangeFilter($event,'make','compaddon')" [checked]="brand_name_addon_filter.includes(data.name)"> <span class="sideOption">{{data.name}} </span>
                                </div>
                            </div>
                            <div class="mb-3">
                                <h6 class="rk-textColor py-2" style="border-bottom: 1px solid lightgray;">By Addon Tag<span class="pull-right">-</span></h6>
                                <div class="aa-text" *ngFor="let tag of addontagsArr">
                                    <input type="checkbox" name="tagvals" class="mr-1" value="{{tag.name}}" (change)="onCheckChangeFilter($event,'addontag','compaddon')" [checked]="tags_addon_filter.includes(tag.name)"> <span class="sideOption" >{{tag.name}}</span>
                                    <br>
                                </div>
                            </div>
                            <h6 class="rk-textColor py-2" style="border-bottom: 1px solid lightgray;">By Price<span class="pull-right">-</span></h6>
                            <ion-range-slider #advancedSliderElement
                                      type="double"
                                      min="0"
                                      max="100000"
                                      [from]="fromval_slider"
                                      from_min="0"
                                      from_max="49999"
                                      from_shadow="true"
                                      [to]="toval_slider"
                                      to_min="50000"
                                      to_max="100000"
                                      to_shadow="true"
                                      grid="false"
                                      prefix="Price: "
                                      postfix=" Rs."
                                      decorate_both="false" 
                                      (onUpdate)="update(advancedSlider, $event)"
                                      (onChange)="update(advancedSlider, $event)"
                                      (onFinish)="finish(advancedSlider, $event)">
                            </ion-range-slider>
                            <input type="number" name="" (input) = "changeSliderValue('from', $event.target.value)" class="form-control d-inline" style="width: 47%" [(ngModel)]="fromval_slider">
                            <input type="number" name=""  (input) = "changeSliderValue('to',$event.target.value)" class="form-control d-inline" style="width: 49%" [(ngModel)]="toval_slider">
                            
                            <button class="rk-interalBtnColor mt-3" (click)="getCompulsoryAddons(customizationModule_MK_details.product_module_id,slotnameForAddon,slotindex);" *ngIf="addonModalType=='compaddon'">Apply Filters</button>
                            <button class="rk-interalBtnColor mt-3" (click)="getListofAddonsForAddons(getformArray(customizationModule_MK_Form,'compulsory_addons').controls[slotindex]['controls'].id.value,getformArray(customizationModule_MK_Form,'compulsory_addons').controls[slotindex]['controls'].slot.value,slotindex);" *ngIf="addonModalType=='addonforaddon'">Apply Filters</button>
                        </div>
                    </div>
                    <div class="col-sm-10 bgColor">
                        <div class="row justify-content-center">
                            <div class="col-11">
                                <div class="row" *ngIf="compulsoryaddonsArr && compulsoryaddonsArr.length>0; else no_addon">
                                    <div class="col-sm-3" *ngFor="let addon of compulsoryaddonsArr; let ki=index;">
                                        <div class="card card-chng mb-5 py-2">
                                            <img class="card-img-top" src="{{addon.addon_image}}"  *ngIf="addon.addon_image" onerror="this.src='./assets/img/no_image.svg';" alt="Missing Image">
                                            <div class="card-body" style="min-height: 14rem;">
                                                <h6 class="card-title textColor1 rk-textColor capitalize">{{addon.code}}</h6>
                                                <p class="card-text textColor2 capitalize">Description : {{addon.name}}</p>
                                                <p class="card-text textColor2 capitalize">Vendor SKU : {{addon.vendor_sku}}</p>
                                                <p class="card-text textColor2 capitalize">Brand : {{addon.brand_name}}</p>
                                                <p class="card-text textColor2 capitalize">Specification : {{addon.specifications}}</p>
                                            </div>
                                            <div class="card-footer text-right" *ngIf="addonModalType=='compaddon'">
                                                <button class="rk-interalBtnColor addCursor d-inline" (click)="addCompAddon(addon,ki,slotindex)">Add</button>
                                            </div>
                                            <div class="card-footer" *ngIf="addonModalType=='addonforaddon'">
                                                <form [formGroup]="addAddon_for_addon_FormMk"> 
                                                    <input type="number" class="d-inline form-control" style="
                                                    width: 70%;" placeholder="Enter Quantity" formControlName="qty" name="qty" id="addonforaddonqtyinput_{{ki}}" min="1">
                                                    <button class="rk-interalBtnColor addCursor d-inline" (click)="addAddonforaddon_new(addon,addAddon_for_addon_FormMk.value,slotindex,ki)">Add</button>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <ng-template #no_addon>No Addon available</ng-template>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 text-right" *ngIf="addonModalType=='compaddon'">
                                <button class="rk-interalBtnColor mr-2" (click)="prevPage('addon','compaddon')" *ngIf="pageno_addon>1"><i class="fa fa-angle-double-left mr-2" style="font-size: 19px;font-weight: bold;"></i>Prev.</button>
                                <button class="rk-interalBtnColor" (click)="nextPage('addon','compaddon');">Next<i class="fa fa-angle-double-right ml-2" style="font-size: 19px;font-weight: bold;"></i></button>
                            </div>
                            <div class="col-12 text-right" *ngIf="addonModalType=='addonforaddon'">
                                <button class="rk-interalBtnColor mr-2" (click)="prevPage('addon','addonforaddon')" *ngIf="pageno_addon>1"><i class="fa fa-angle-double-left mr-2" style="font-size: 19px;font-weight: bold;"></i>Prev.</button>
                                <button class="rk-interalBtnColor" (click)="nextPage('addon','addonforaddon');">Next<i class="fa fa-angle-double-right ml-2" style="font-size: 19px;font-weight: bold;"></i></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<!--optional addon modal-->
<div class="modal fade" id="addoptionalAddonModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" data-keyboard="false" data-backdrop="static">
    <div class="modal-dialog my-2 mx-2" role="document" style="max-width:100%">
        <div class="modal-content" id="alloptionaladdonsRow">
            <div class="modal-header">
                <div class="container-fluid">
                    <div class="row justify-content-center">
                        <div class="col-2"></div>
                        <div class="col-10 pl-5">
                            <div class="ss-searchbox ss-searchbox_extra d-inline-block ml-2">
                                <i class="fa fa-search"></i>
                                <input class="form-control" type="text" placeholder="Type vendor SKU/ description/ specifications  to search..." #search (keyup)="0" [(ngModel)]="search_string_addon_filter">
                            </div>
                            <button class="rk-interalBtnColor addCursor" (click)="getOptionalAddons(optaddoncategory)">Search</button>

                        </div>
                    </div>
                </div>
                <button type="button" class="close addExtrastModalClose" (click)="closeoptionalAddonModal(optaddoncategory)">
                <span aria-hidden="true"><img src="../../../assets/img/cross-out.svg" style="width:15px;"></span>
                </button>
            </div>
            <div class="modal-body pt-0">
                <div class="row">
                    <div class="col-md-2">
                        <div class="mx-2">
                            <div class="mb-3">
                                <h6 class="rk-textColor py-2" style="border-bottom: 1px solid lightgray;">By Make <span class="pull-right">_</span></h6>
                                <div class="aa-text" *ngFor="let data of makeforextras_filter">
                                    <input type="checkbox" name="brand_name_extra_filter" class="mr-1" value="{{data.name}}" (change)="onCheckChangeFilter($event,'make','compaddon')" [checked]="brand_name_addon_filter.includes(data.name)"> <span class="sideOption">{{data.name}} </span>
                                </div>
                            </div>
                            <div class="mb-3">
                                <h6 class="rk-textColor py-2" style="border-bottom: 1px solid lightgray;">By Addon Tag<span class="pull-right">-</span></h6>
                                <div class="aa-text" *ngFor="let tag of addontagsArr">
                                    <input type="checkbox" name="tagvals" class="mr-1" value="{{tag.name}}" (change)="onCheckChangeFilter($event,'addontag','compaddon')" [checked]="tags_addon_filter.includes(tag.name)"> <span class="sideOption" >{{tag.name}}</span>
                                    <br>
                                </div>
                            </div>
                            <h6 class="rk-textColor py-2" style="border-bottom: 1px solid lightgray;">By Price<span class="pull-right">-</span></h6>
                            <ion-range-slider #advancedSliderElement
                                      type="double"
                                      min="0"
                                      max="100000"
                                      [from]="fromval_slider"
                                      from_min="0"
                                      from_max="49999"
                                      from_shadow="true"
                                      [to]="toval_slider"
                                      to_min="50000"
                                      to_max="100000"
                                      to_shadow="true"
                                      grid="false"
                                      prefix="Price: "
                                      postfix=" Rs."
                                      decorate_both="false" 
                                      (onUpdate)="update(advancedSlider, $event)"
                                      (onChange)="update(advancedSlider, $event)"
                                      (onFinish)="finish(advancedSlider, $event)">
                            </ion-range-slider>
                            <input type="number" name="" (input) = "changeSliderValue('from', $event.target.value)" class="form-control d-inline" style="width: 47%" [(ngModel)]="fromval_slider">
                            <input type="number" name=""  (input) = "changeSliderValue('to',$event.target.value)" class="form-control d-inline" style="width: 49%" [(ngModel)]="toval_slider">
                            
                            <button class="rk-interalBtnColor mt-3" (click)="getOptionalAddons(optaddoncategory)">Apply Filters</button>
                        </div>
                    </div>
                    <div class="col-sm-10 bgColor">
                        <div class="row justify-content-center">
                            <div class="col-11">
                                <div class="row" *ngIf="compulsoryaddonsArr && compulsoryaddonsArr.length>0; else no_addon">
                                    <div class="col-sm-3" *ngFor="let addon of compulsoryaddonsArr; let ki=index;">
                                        <div class="card card-chng mb-5 py-2">
                                            <img class="card-img-top" src="{{addon.addon_image}}"  *ngIf="addon.addon_image" onerror="this.src='./assets/img/no_image.svg';" alt="Missing Image">
                                            <div class="card-body" style="min-height: 14rem;">
                                                <h6 class="card-title textColor1 rk-textColor capitalize">{{addon.code}}</h6>
                                                <p class="card-text textColor2 capitalize">Description : {{addon.name}}</p>
                                                <p class="card-text textColor2 capitalize">Vendor SKU : {{addon.vendor_sku}}</p>
                                                <p class="card-text textColor2 capitalize">Brand : {{addon.brand_name}}</p>
                                                <p class="card-text textColor2 capitalize">Specification : {{addon.specifications}}</p>
                                            </div>
                                            <div class="card-footer">
                                                <form [formGroup]="addAddon_for_addon_FormMk"> 
                                                    <input type="number" class="d-inline form-control" style="
                                                    width: 70%;" placeholder="Enter Quantity" formControlName="qty" name="qty" id="optionaladdonqtyinput_{{ki}}" min="1">
                                                    <button class="rk-interalBtnColor addCursor d-inline" (click)="addoptionaladdon_new(addon,addAddon_for_addon_FormMk.value,ki,optaddoncategory)">Add</button>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <ng-template #no_addon>No Addon available</ng-template>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 text-right">
                                <button class="rk-interalBtnColor mr-2" (click)="prevPage('addon','optionaladdon',optaddoncategory)" *ngIf="pageno_addon>1"><i class="fa fa-angle-double-left mr-2" style="font-size: 19px;font-weight: bold;"></i>Prev.</button>
                                <button class="rk-interalBtnColor" (click)="nextPage('addon','optionaladdon',optaddoncategory);">Next<i class="fa fa-angle-double-right ml-2" style="font-size: 19px;font-weight: bold;"></i></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="shutterhandleCodeModal" tabindex="-1" role="dialog" aria-labelledby="handleCodeModalLabel" aria-hidden="true" data-keyboard="false" data-backdrop="static">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Select Handle</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeHandleModal(globalVarArr.category)">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row" *ngIf="globalVarArr">
                    <div class="col-sm-2 text-center" *ngFor=" let handlecode of globalVarArr.shutter_handle_code" [ngClass]= "{'highlighted-box': (handlecode.code==shutter_handle_code_globalVar_MW)}">
                        <img src="{{handlecode.handle_image}}" (click)="setImage(handlecode.code,'shutterhandle',globalVarArr.category); closeHandleModal(globalVarArr.category);" height="75px" style=" max-width: 100px;" *ngIf="handlecode.handle_image" onerror="this.src='./assets/img/no_image.svg';" alt="Missing Image" class="addCursor">
                        <p (click)="setImage(handlecode.code,'shutterhandle',globalVarArr.category); closeHandleModal(globalVarArr.category);" class="text-center mt-2 addCursor">{{handlecode.code}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="doorhandleCodeModal" tabindex="-1" role="dialog" aria-labelledby="doorCodeModalLabel" aria-hidden="true" data-keyboard="false" data-backdrop="static">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Select Handle</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeHandleModal(globalVarArr.category)">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row" *ngIf="globalVarArr && globalVarArr.category=='wardrobe'">
                    <div class="col-sm-2 text-center" *ngFor=" let handlecode of globalVarArr.door_handle_code" [ngClass]= "{'highlighted-box': (handlecode.code==door_handle_code_globalVar_MK && globalVarArr.category=='kitchen') || (handlecode.code==door_handle_code_globalVar_MW && globalVarArr.category=='wardrobe')}">
                        <img src="{{handlecode.handle_image}}" (click)="setImage(handlecode.code,'doorhandle',globalVarArr.category); closeHandleModal(globalVarArr.category);" height="75px" style=" max-width: 100px;" *ngIf="handlecode.handle_image" onerror="this.src='./assets/img/no_image.svg';" alt="Missing Image" class="addCursor">
                        <p (click)="setImage(handlecode.code,'doorhandle',globalVarArr.category); closeHandleModal(globalVarArr.category);" class="text-center mt-2 addCursor">{{handlecode.code}}</p>
                    </div>
                </div>
                <div class="row" *ngIf="globalVarArr && globalVarArr.category=='kitchen'">
                    <div class="col-sm-2 text-center" *ngFor=" let handlecode of handlelistForKitchen" [ngClass]= "{'highlighted-box': (handlecode.code==door_handle_code_globalVar_MK && globalVarArr.category=='kitchen') || (handlecode.code==door_handle_code_globalVar_MW && globalVarArr.category=='wardrobe')}">
                        <img src="{{handlecode.handle_image}}" (click)="setImage(handlecode.code,'doorhandle',globalVarArr.category); closeHandleModal(globalVarArr.category);" height="75px" style=" max-width: 100px;" *ngIf="handlecode.handle_image" onerror="this.src='./assets/img/no_image.svg';" alt="Missing Image" class="addCursor">
                        <p (click)="setImage(handlecode.code,'doorhandle',globalVarArr.category); closeHandleModal(globalVarArr.category);" class="text-center mt-2 addCursor">{{handlecode.code}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="customizationHandleCodeModal" tabindex="-1" role="dialog" aria-labelledby="customizationHandleCodeModalLabel" aria-hidden="true" data-keyboard="false" data-backdrop="static">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Select Handle</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeCustomizationHandleModal()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-sm-2 text-center" *ngFor=" let handlecode of arr_list_modal">
                        <img src="{{handlecode.handle_image}}" (click)="setCodeForCustomizations(handlecode.code)" height="75px" style=" max-width: 100px;" *ngIf="handlecode.handle_image" onerror="this.src='./assets/img/no_image.svg';" alt="Missing Image" class="addCursor">
                        <p (click)="setCodeForCustomizations(handlecode.code)" class="text-center mt-2 addCursor">{{handlecode.code}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="moduleCodeModal" tabindex="-1" role="dialog" aria-labelledby="moduleCodeModalLabel" aria-hidden="true" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog" role="document" style="max-width: 100%">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="moduleCodeModalLabel">Select Module</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeModuleModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-sm-3" *ngFor=" let module of arr_list_modal; let q =index">
            <div class="card card-chng mb-2 pt-2 addCursor" id="modulecard{{q}}" (click)="setModulecode(module)">
              <img alt="Missing Image" class="card-img-top" onerror="this.src='./assets/img/no_image.svg';" src="{{module.module_image}}">
                <div  class="card-body">
                    <h6 class="card-title textColor1 rk-textColor capitalize">{{module.code}}</h6>
                    <p class="card-text textColor2 capitalize">Dimensions - {{module.dimensions}}</p>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--preset Modal starts-->
<div class="modal fade" id="listPresetModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" data-keyboard="false" data-backdrop="static">
    <div class="modal-dialog my-2 mx-2" role="document" style="max-width:100%">
        <div class="modal-content">
            <div class="modal-header modalboxHeader mb-3">
                <h5 class="modal-title modalTitle" id="listPresetModalLabel">List of Presets</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body pt-0">
                <div class="row">
                    <div class="col-md-12" *ngIf="preset_list &&  preset_list.length==0 ">No Presets</div>
                    <div class="col-md-12" *ngIf="preset_list &&  preset_list.length>0">
                        <collapsible-table [type]="'accordion'" bordered class="table" style="outline: none;">
                            <thead class="thead-dark">
                                <collapsible-table-row>
                                    <th scope="col" class="firstTh">#</th>
                                    <th scope="col"> Name</th>
                                    <th scope="col">Created By</th>
                                    <th class="minWidthForTd">Date</th>
                                    <th scope="col">Remarks</th>
                                    <th scope="lastTh" class="lastTh"></th> 
                                </collapsible-table-row>
                            </thead>  
                            <tbody style="background: white">
                                <ng-container *ngFor="let data of preset_list | paginate: { itemsPerPage: per_page, currentPage: current_page, totalItems: total_page  } let i = index;" [attr.data-index]="i" >
                                    <collapsible-table-row [detail]="detail1">
                                        <td style="min-width: 1rem;">{{((current_page-1) * per_page) + (i+1)}}</td>
                                        <td class="capitalize"> {{data.preset_name}}</td>
                                        <td>{{data.preset_created_by.name}} - {{data.preset_created_by.email}}</td>
                                        <td class="capitalize">{{data.created_at | date:'dd MMM, y , h:mm a'}}</td>
                                        <td class="capitalize">{{data.preset_remark}}</td>
                                        <td class="capitalize"><button class="rk-interalBtnColor addCursor" (click)="savePresetAsGlobal(data.category,data.id)">Select</button></td>
                                    </collapsible-table-row>
                                    <collapsible-table-row-detail style="box-shadow: none;" #detail1>
                                        <div class="px-2 py-3 mx-0">
                                            <div class="row px-3" style="border-bottom: 1px solid #dcd7d7;" >
                                              <div class="col-md-12">
                                                <h5 class="heading-change">Preset Details:</h5>
                                              </div>
                                            </div>
                                            <div  class="row style-chng px-3 pt-3">
                                                <div class="col-md-3">
                                                    <label class="">Category :</label>
                                                    <p class="preset_details_para capitalize">{{data.category}}</p>
                                                </div>
                                                <div class="col-md-3">
                                                    <label class="">Core Material :</label>
                                                    <p class="preset_details_para capitalize">{{data.core_material.name}}</p>
                                                </div>
                                                <div class="col-md-3">
                                                    <label class="">Shutter Material :</label>
                                                    <p class="preset_details_para capitalize">{{data.shutter_material.name}}</p>
                                                </div>
                                                <div class="col-md-3">
                                                    <label class="">Shutter Finish :</label>
                                                    <p class="preset_details_para capitalize">{{data.shutter_finish.name}}</p>
                                                </div>
                                                <div class="col-md-3">
                                                    <label class=""><span *ngIf="data.category=='wardrobe'">Drawer</span> Handle Code :</label>
                                                    <p class="preset_details_para capitalize">{{data.door_handle_code}}</p>
                                                    <img src="{{data.door_handle_image}}" alt=" No Image" height="60px" width="100px" *ngIf="data.door_handle_image " onerror="this.src='./assets/img/no_image.svg'">
                                                </div>
                                                <div class="col-md-3" *ngIf="data.category=='wardrobe'">
                                                    <label class="">Shutter Handle Code :</label>
                                                    <p class="preset_details_para capitalize">{{data.shutter_handle_code}}</p>
                                                    <img src="{{data.shutter_handle_image}}" alt=" No Image" height="60px" width="100px" *ngIf="data.shutter_handle_image " onerror="this.src='./assets/img/no_image.svg'">
                                                </div>
                                                <div class="col-md-3">
                                                    <label class="">Hinge Type :</label>
                                                    <p class="preset_details_para capitalize">{{data.hinge_type}}</p>
                                                </div>
                                                <div class="col-md-3">
                                                    <label class="">Channel Type :</label>
                                                    <p class="preset_details_para capitalize">{{data.channel_type}}</p>
                                                </div>
                                                <div class="col-md-3">
                                                    <label class="">Hardware Brand :</label>
                                                    <p class="preset_details_para capitalize">{{data.brand.name}}</p>
                                                </div>
                                                <div class="col-md-3" *ngIf="data.category=='kitchen'">
                                                    <label class="">Skirting Config Type :</label>
                                                    <p class="preset_details_para capitalize">{{data.skirting_config_type}}</p>
                                                </div>
                                                <div class="col-md-3" *ngIf="data.category=='kitchen'">
                                                    <label class="">Skirting Config Height :</label>
                                                    <p class="preset_details_para capitalize">{{data.skirting_config_height}}</p>
                                                </div>
                                                <div class="col-md-3" *ngIf="data.category=='kitchen'">
                                                    <label class="">Countertop :</label>
                                                    <p class="preset_details_para capitalize">{{data.countertop | replaceChar}}</p>
                                                </div>
                                                <div class="col-md-3" *ngIf="data.category=='kitchen'">
                                                    <label class="">Type of Kitchen :</label>
                                                    <p class="preset_details_para capitalize"><ng-container *ngIf="data.civil_kitchen">Civil Kitchen</ng-container>
                                                    <ng-container *ngIf="!data.civil_kitchen">Modular Kitchen</ng-container></p>
                                                </div>
                                                <div class="col-md-3" *ngIf="data.category=='kitchen' && data.civil_kitchen && data.civil_kitchen_parameters">
                                                    <label class="">Depth (in mm) :</label>
                                                    <p class="preset_details_para capitalize">{{data.civil_kitchen_parameters.depth}}</p>
                                                </div>
                                                <div class="col-md-3" *ngIf="data.category=='kitchen' && data.civil_kitchen && data.civil_kitchen_parameters">
                                                    <label class="">Drawer Height 1 (in mm) :</label>
                                                    <p class="preset_details_para capitalize">{{data.civil_kitchen_parameters.drawer_height_1}}</p>
                                                </div>
                                                <div class="col-md-3" *ngIf="data.category=='kitchen' && data.civil_kitchen && data.civil_kitchen_parameters">
                                                    <label class="">Drawer Height 2 (in mm) :</label>
                                                    <p class="preset_details_para capitalize">{{data.civil_kitchen_parameters.drawer_height_2}}</p>
                                                </div>
                                                <div class="col-md-3" *ngIf="data.category=='kitchen' && data.civil_kitchen && data.civil_kitchen_parameters">
                                                    <label class="">Drawer Height 3 (in mm) :</label>
                                                    <p class="preset_details_para capitalize">{{data.civil_kitchen_parameters.drawer_height_3}}</p>
                                                </div>
                                                <div class="col-md-3">
                                                    <label class="">Shutter Shade Code :</label>
                                                    <p class="preset_details_para capitalize"><ng-container *ngIf="data.custom_shutter_shade_code">{{data.shutter_shade_code}}</ng-container><ng-container *ngIf="!data.custom_shutter_shade_code">{{data.shutter_shade_code.code}}</ng-container></p>
                                                    <img src="{{data.shutter_shade_code.shade_image}}" alt=" No Image" height="60px" width="100px" *ngIf="!data.custom_shutter_shade_code && data.shutter_shade_code.shade_image " onerror="this.src='./assets/img/no_image.svg'">
                                                </div>
                                                <div class="col-md-3">
                                                    <label class="">Edge Banding Shade Code :</label>
                                                    <p class="preset_details_para capitalize"><ng-container *ngIf="data.custom_edge_banding_shade_code">{{data.edge_banding_shade_code}}</ng-container><ng-container *ngIf="!data.custom_edge_banding_shade_code">{{data.edge_banding_shade_code.code}}</ng-container></p>
                                                    <img src="{{data.edge_banding_shade_code.shade_image}}" alt=" No Image" height="60px" width="100px" *ngIf="!data.custom_edge_banding_shade_code && data.edge_banding_shade_code.shade_image " onerror="this.src='./assets/img/no_image.svg'">

                                                </div>
                                            </div>
                                        </div>        
                                    </collapsible-table-row-detail> 
                                </ng-container>
                            </tbody>     
                        </collapsible-table>
                        <div class="text-center" *ngIf="preset_list && preset_list.length >0">
                            <pagination-controls autoHide="true" (pageChange)="current_page = getGlobalPresets(preset_list_category,$event)"></pagination-controls>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!--preset modal ends-->

<div class="modal fade" id="saveMkwLayoutModal" tabindex="-1" role="dialog" aria-labelledby="saveMkwLayoutModalLabel" aria-hidden="true" data-keyboard="false" data-backdrop="static">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header modalboxHeader mb-3">
                <h5 class="modal-title modalTitle" id="saveMkwLayoutModalLabel">Save As Layout</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="saveMkwLayoutForm.reset();">
                  <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body pt-0">
               <form [formGroup]="saveMkwLayoutForm">
                    <div class="row">
                        <div class="col-md-6">
                            <label>Category <span class="text-danger">*</span></label>
                            <input type="text" name="" class="form-control" readonly formControlName="category">
                        </div>
                        <div class="col-md-6">
                            <label>Name <span class="text-danger">*</span></label>
                            <input type="text" name="" class="form-control" formControlName="name">
                        </div>
                        <div class="col-md-12 mt-3">
                            <label>Remarks</label>
                            <textarea class="form-control" rows="2" formControlName="remark"></textarea>
                        </div>
                        <div class="col-md-12 text-right">
                            <button class="rk-interalBtnColor addCursor my-2" [disabled]="!saveMkwLayoutForm.valid" (click)="saveAsMkwLayout(saveMkwLayoutForm.value)">Save</button>
                        </div>
                    </div>
               </form>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="setGlobalConfigModal" tabindex="-1" role="dialog" aria-labelledby="setGlobalConfigModalLabel" aria-hidden="true" data-keyboard="false" data-backdrop="static">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header modalboxHeader mb-3">
                <h5 class="modal-title modalTitle" id="setGlobalConfigModalLabel">Select Global Variables</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeGlobalVarFormModal()">
                  <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body pt-0" *ngIf="globalVarArr">
                <form [formGroup]="addGlobalVariableForm">
                    <div class="row">
                        <div class="col-sm-12 col-md-6 mb-2" [ngClass]="{'d-none': (globalVarArr.category!='kitchen')}">
                            <div class="form-group">
                                <label class="text-left">Type Of Kitchen <span class="text-danger">*</span></label>
                                <select formControlName="civil_kitchen" class="form-control"  (change)="onChangeOfTOK($event.target.value,addGlobalVariableForm)">
                                    <option value="">Select</option>
                                    <option value='true'>Civil Kitchen</option>
                                    <option value='false'>Modular Kitchen</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-6 mb-2" [ngClass]="{'d-none': (addGlobalVariableForm.controls['civil_kitchen'].value!='true' || globalVarArr.category!='kitchen')}">
                            <div class="form-group">
                                <label class="text-left">Depth in mm <span class="text-danger">*</span></label>
                                <input type="number" name="" class="form-control" formControlName="depth" min="0"> 
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-6 mb-2" [ngClass]="{'d-none': (addGlobalVariableForm.controls['civil_kitchen'].value!='true' || globalVarArr.category!='kitchen')}">
                            <div class="form-group">
                                <label class="text-left">Drawer 1 Height in mm(D1) <span class="text-danger">*</span></label>
                                <input type="number" name="" class="form-control" formControlName="drawer_height_1" min="130"> 
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-6 mb-2" [ngClass]="{'d-none': (addGlobalVariableForm.controls['civil_kitchen'].value!='true' || globalVarArr.category!='kitchen')}">
                            <div class="form-group">
                                <label class="text-left">Drawer 2 Height in mm(D2) <span class="text-danger">*</span></label>
                                <input type="number" name="" class="form-control" formControlName="drawer_height_2" min="150"> 
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-6 mb-2" [ngClass]="{'d-none': (addGlobalVariableForm.controls['civil_kitchen'].value!='true' || globalVarArr.category!='kitchen')}">
                            <div class="form-group">
                                <label class="text-left">Drawer 3 Height in mm(D3) <span class="text-danger">*</span></label>
                                <input type="number" name="" class="form-control" formControlName="drawer_height_3" min="360"> 
                            </div>
                        </div>
                        <ng-container *ngIf="globalVarArr">
                            <div class="col-sm-12 col-md-6 mb-2">
                                <div class="form-group">
                                    <label class="text-left">Core Material <span class="text-danger">*</span></label>
                                    <select formControlName="core_material" class="form-control">
                                        <option value="">Select</option>
                                        <option *ngFor="let coremat of globalVarArr.core_material" value="{{coremat.name}}">{{coremat.name}}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6 mb-2">
                                <div class="form-group">
                                    <label class="text-left">Shutter Material <span class="text-danger">*</span></label>
                                    <select class="form-control" formControlName="shutter_material" (change)="listofShutterFinishes($event.target.value,addGlobalVariableForm)">
                                        <option value="">Select</option>
                                        <option *ngFor="let shuttermat of globalVarArr.shutter_material" value="{{shuttermat.name}}">{{shuttermat.name}}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6 mb-2">
                                <div class="form-group">
                                    <label class="text-left">Shutter Finish <span class="text-danger">*</span></label>
                                    <select class="form-control" formControlName="shutter_finish" (change)="listofShutterFinishShades($event.target.value,addGlobalVariableForm);">
                                        <option value="">Select</option>
                                        <option *ngFor="let shutter_fin of globalVarArr.shutter_finish" value="{{shutter_fin.name}}">{{shutter_fin.name}}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6 mb-2">
                                <div class="form-group">
                                    <label class="text-left">Shutter Shade Code <span class="text-danger">*</span></label>
                                    <a class="addCursor d-block link-color" (click)="openglobalvarSubModal('#shadeCodeModal','#setGlobalConfigModal')">Choose Shade Code</a>
                                    <span>{{addGlobalVariableForm.controls['shutter_shade_code'].value}}</span>
                                    <img src="{{addGlobalVariableForm.controls['shutter_shade_code_img'].value}}" alt=" No Image" height="60px" width="100px" *ngIf="addGlobalVariableForm.controls['shutter_shade_code_img'].value " onerror="this.src='./assets/img/no_image.svg'">
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6 mb-2">
                                <div class="form-group">
                                    <label class="text-left">Edge Banding Shade <span class="text-danger">*</span></label>
                                    <a  class="addCursor d-block link-color" (click)="openglobalvarSubModal('#edgebandingShadeModal','#setGlobalConfigModal')">Choose Edge Banding Shade Code</a>
                                    <span>{{addGlobalVariableForm.controls['edge_banding_shade_code'].value}}</span>
                                    <img src="{{addGlobalVariableForm.controls['edge_banding_shade_code_img'].value}}" alt=" No Image" height="60px" width="100px" *ngIf="addGlobalVariableForm.controls['edge_banding_shade_code_img'].value " onerror="this.src='./assets/img/no_image.svg'">
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6 mb-2" [ngClass]="{'d-none': (globalVarArr.category!='wardrobe')}">
                                <div class="form-group">
                                    <label class="text-left">Shutter Handle Code <span class="text-danger">*</span></label>
                                    <a class="addCursor d-block link-color" (click)="openglobalvarSubModal('#shutterhandleCodeModal','#setGlobalConfigModal');">Choose Shutter Handle Code</a>
                                    <span>{{addGlobalVariableForm.controls['shutter_handle_code'].value}}</span>
                                    <img src="{{addGlobalVariableForm.controls['shutter_handle_code_img'].value}}" alt=" No Image" height="60px" width="100px" *ngIf="addGlobalVariableForm.controls['shutter_handle_code_img'].value " onerror="this.src='./assets/img/no_image.svg'">
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6 mb-2">
                                <div class="form-group">
                                    <label class="text-left" [ngClass]="{'d-block': (globalVarArr.category!='wardrobe'),'d-none':(globalVarArr.category=='wardrobe')}">Handle Code <span class="text-danger">*</span></label>
                                    <label class="text-left" [ngClass]="{'d-block': (globalVarArr.category=='wardrobe'),'d-none':(globalVarArr.category!='wardrobe')}">Drawer Handle Code <span class="text-danger">*</span></label>
                                    <a class="addCursor d-block link-color" (click)="openglobalvarSubModal('#doorhandleCodeModal','#setGlobalConfigModal'); ">Choose Handle Code</a>
                                    <span>{{addGlobalVariableForm.controls['door_handle_code'].value}}</span>
                                    <img src="{{addGlobalVariableForm.controls['door_handle_code_img'].value}}" alt=" No Image" height="60px" width="100px" *ngIf="addGlobalVariableForm.controls['door_handle_code_img'].value " onerror="this.src='./assets/img/no_image.svg'">
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6 mb-2">
                                <div class="form-group">
                                    <label class="text-left">Hardware Brand <span class="text-danger">*</span></label>
                                    <select class="form-control" formControlName="brand_id">
                                        <option value="">Select</option>
                                        <option *ngFor="let hb of globalVarArr.hardware_brand" value="{{hb.id}}">{{hb.name}}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6 mb-2">
                                <div class="form-group">
                                    <label class="text-left">Hinge Type <span class="text-danger">*</span></label>
                                    <select class="form-control" formControlName="hinge_type">
                                        <option value="">Select</option>
                                        <option *ngFor="let ht of globalVarArr.hinge_type" value="{{ht}}">{{ht | uppercase}} <span *ngIf="ht=='soft'"> - CLOSE</span></option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6 mb-2">
                                <div class="form-group">
                                    <label class="text-left">Channel Type <span class="text-danger">*</span></label>
                                    <select class="form-control" formControlName="channel_type">
                                        <option value="">Select</option>
                                        <option *ngFor="let ct of globalVarArr.channel_type" value="{{ct}}">{{ct | uppercase}} <span *ngIf="ct=='soft'"> - CLOSE</span></option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6 mb-2" [ngClass]="{'d-none': (globalVarArr.category!='kitchen')}">
                                <div class="form-group">
                                    <label class="text-left">Skirting Config Type<span class="text-danger">*</span></label>
                                    <select class="form-control" formControlName="skirting_config_type" (change)="listofSkirtingHeights($event.target.value,addGlobalVariableForm)">
                                        <option value="">Select</option>
                                        <option *ngFor="let sct of globalVarArr.skirting_config_type" value="{{sct.skirting_type}}">{{sct.skirting_type | uppercase}}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6 mb-2" [ngClass]="{'d-none': (globalVarArr.category!='kitchen')}">
                                <div class="form-group">
                                    <label class="text-left"> Skirting Config Height <span class="text-danger">*</span></label>
                                    <select class="form-control" formControlName="skirting_config_height">
                                        <option value="">Select</option>
                                        <option *ngFor="let sch of globalVarArr.skirting_config_height" value="{{sch.skirting_height}}">{{sch.skirting_height}}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6 mb-2" [ngClass]="{'d-none': (globalVarArr.category!='kitchen')}">
                                <div class="form-group">
                                    <label class="text-left">Countertop <span class="text-danger">*</span></label>
                                    <select class="form-control" formControlName="countertop">
                                        <option value="">Select</option>
                                        <option *ngFor="let count_top of globalVarArr.countertop" value="{{count_top}}">{{count_top | replaceChar}}</option>
                                    </select>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                    <div>
                       <button class="pull-right rk-interalBtnColor mr-2 my-2 addCursor" [disabled]="!addGlobalVariableForm.valid" (click)="postBoqGlobalConfig(addGlobalVariableForm.value,globalVarArr.category)">Save</button>
                       <button class="pull-right rk-interalBtnColor mr-2 my-2 addCursor" [disabled]="!addGlobalVariableForm.valid"  (click)="openPresetModal(addGlobalVariableForm.value,globalVarArr.category,'add','#setGlobalConfigModal')">Save As Preset</button>
                        <button class="pull-right rk-btnCancel my-2 addCursor" data-dismiss="modal" (click)="closeGlobalVarFormModal()">Cancel</button>
                    </div>
                    <!-- <pre>{{addPresetForm.value | json}}</pre> -->
                </form>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="savePresetModal" tabindex="-1" role="dialog" aria-labelledby="savePresetModalLabel" aria-hidden="true" data-keyboard="false" data-backdrop="static">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header modalboxHeader mb-3">
                <h5 class="modal-title modalTitle" id="saveMkwLayoutModalLabel">Save As Preset</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closePresetModal()">
                  <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body pt-0">
               <form [formGroup]="savePresetForm">
                    <div class="row">
                        <div class="col-md-6">
                            <label>Category <span class="text-danger">*</span></label>
                            <input type="text" name="" class="form-control" readonly formControlName="category">
                        </div>
                        <div class="col-md-6">
                            <label>Name <span class="text-danger">*</span></label>
                            <input type="text" name="" class="form-control" formControlName="name">
                        </div>
                        <div class="col-md-12 mt-3">
                            <label>Remarks</label>
                            <textarea class="form-control" rows="2" formControlName="remark"></textarea>
                        </div>
                        <div class="col-md-12 text-right">
                            <button class="rk-interalBtnColor addCursor my-2" [disabled]="!savePresetForm.valid" (click)="saveAsPreset(savePresetForm.value)">Save</button>
                        </div>
                    </div>
               </form>
            </div>
        </div>
    </div>
</div>


<div class="modal fade" id="layoutlistmodal" tabindex="-1" role="dialog" aria-labelledby="layoutlistmodalLabel" aria-hidden="true" data-keyboard="false" data-backdrop="static">
    <div class="modal-dialog my-2 mx-2" role="document" style="max-width:100%">
        <div class="modal-content">
            <div class="modal-header modalboxHeader mb-3">
                <h5 class="modal-title modalTitle" id="layoutlistmodalLabel">List of Layouts</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeImportLayoutModal()">
                  <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body pt-0">
                <div class="row mx-0">
                    <div class="col-md-12" *ngIf="layouts_list &&  layouts_list.length==0">No Layout</div>
                    <div class="col-md-12" *ngIf="layouts_list &&  layouts_list.length>0">
                        <collapsible-table [type]="'accordion'" bordered class="table mt-3" style="outline: none;">
                            <thead class="thead-dark">
                                <collapsible-table-row>
                                   <th scope="col" class="firstTh">#</th>
                                   <th scope="col"> Name</th>
                                   <th scope="col">Created By</th>
                                   <th class="minWidthForTd">Date</th>
                                   <th scope="col" class="">Remarks</th>
                                   <th scope="lastTh" class="lastTh"></th> 
                                </collapsible-table-row>
                            </thead>  
                            <tbody style="background: white">
                                <ng-container *ngFor="let data of layouts_list | paginate: { itemsPerPage: per_page, currentPage: current_page, totalItems: total_page  } let i = index;" [attr.data-index]="i" >
                                    <collapsible-table-row [detail]="detail1" (click)="getMkwLayoutDetail(data.id)">
                                        <td style="min-width: 1rem;">{{((current_page-1) * per_page) + (i+1)}}</td>
                                        <td class="capitalize"> {{data.name}}</td>
                                        <td>{{data.created_by.name}} - {{data.created_by.email}}</td>
                                         <td class="capitalize">{{data.created_at | date:'dd MMM, y , h:mm a'}}</td>
                                        <td class="capitalize">{{data.remark}}</td>
                                        <td><button class="rk-interalBtnColor addCursor" (click)="importLayoutToSpace(data.id)">Select</button></td>
                                    </collapsible-table-row>
                                    <collapsible-table-row-detail style="box-shadow: none;" #detail1>
                                        <div class="px-2 py-3 mx-0">
                                            <div class="row px-3" *ngIf="layoutDetail">
                                                <!--Modular jobs-->
                                                <div class="col-md-12 tableDiv" *ngIf="layoutDetail.modular_jobs.length>0">
                                                  <h6 class="mt-3 px-3">Modules</h6>
                                                  <table class="table px-3">
                                                    <thead class="thead-dark">
                                                      <tr>
                                                        <th class="firstTh">#</th>
                                                        <th [ngClass]="{'d-none':(selectedsectionName=='modular_wardrobe')}">Kitchen Category</th>
                                                        <th>Type</th>
                                                        <th>Module</th>
                                                        <th class="text-center">Image</th>
                                                        <th>Quantity</th>
                                                        <th [ngClass]="{'d-none':(selectedsectionName=='modular_wardrobe')}">Width</th>
                                                        <th class="lastTh"></th>
                                                      </tr>
                                                    </thead>
                                                    <tbody>
                                                      <ng-container *ngFor="let mod of layoutDetail.modular_jobs; let k=index; ">
                                                        <tr *ngIf="(selectedsectionName=='modular_kitchen') || (selectedsectionName=='modular_wardrobe' && !mod.combined)">
                                                          <td>{{k+1}}</td>
                                                          <td [ngClass]="{'d-none':(selectedsectionName=='modular_wardrobe')}">{{mod.kitchen_category_name}}</td>
                                                          <td>{{mod.module_type}}</td>
                                                          <td>{{mod.code}}</td>
                                                          <td>
                                                              <img src="{{mod.module_image_url}}" *ngIf="mod.module_image_url" style="width: 100px;" onerror="this.src='./assets/img/no_image.svg';" alt="Missing Image">
                                                          </td>
                                                          <td class="text-center">
                                                              <span class="moduleLineItemSpan{{k}}">{{mod.quantity}}</span>
                                                          </td>
                                                          <td [ngClass]="{'d-none':(selectedsectionName == 'modular_wardrobe')}">
                                                              <span><ng-container *ngIf="mod.custom_shelf_unit_width">{{mod.custom_shelf_unit_width}} mm</ng-container><ng-container *ngIf="!mod.custom_shelf_unit_width">NA</ng-container></span>
                                                          </td>
                                                          <td>
                                                              <img src="assets/v3/img/gear.svg" (click)="getCustomizationOfMKWlayout(mod.id,data.id)" class="addCursor">
                                                          </td>
                                                        </tr>
                                                        <tr *ngIf="(selectedsectionName == 'modular_wardrobe' && mod.combined)" class="accordion-toggle addCursor" data-toggle="collapse" data-parent="#OrderPackages" [attr.data-target]="'.packageDetails'+k" (click)="showAccordion(k)">
                                                          <td>{{k+1}}</td>
                                                          <td>Combined</td>
                                                          <td class="capitalize">{{mod.name}}</td>
                                                          <td>
                                                            <img src="{{mod.module_image_url}}" *ngIf="mod.module_image_url" style="width: 100px;" onerror="this.src='./assets/img/no_image.svg';" alt="Missing Image">
                                                          </td>
                                                          <td class="text-center">
                                                            <span class="moduleLineItemSpan{{k}}">{{mod.quantity}}</span>
                                                          </td>
                                                          <td></td>
                                                        </tr>
                                                        <tr class="d-none combmoduleAccordionRow{{k}}" id="combmoduleAccordionRow{{k}}" *ngIf="mod.combined">
                                                          <td colspan="6" class="hiddenRow">
                                                            <div class="accordion-body collapse packageDetails{{k}}" id="accordion_{{k}}">
                                                              <table class="table">
                                                                <tr *ngFor="let cmod of mod.included_modules; let m=index; ">
                                                                  <td>{{m+1}}</td>
                                                                  <td>{{cmod.module_type}}</td>
                                                                  <td>{{cmod.code}}</td>
                                                                  <td>
                                                                    <img src="{{cmod.module_image_url}}" *ngIf="cmod.module_image_url" style="width: 100px;" onerror="this.src='./assets/img/no_image.svg';" alt="Missing Image">
                                                                  </td>
                                                                  <td>
                                                                    <span class="moduleLineItemSpan{{k}}{{m}}">{{cmod.quantity}}</span>
                                                                  </td>
                                                                  <td>
                                                                    <img src="assets/v3/img/gear.svg" (click)="getCustomizationOfMKWlayout(cmod.id,data.id)" class="addCursor">
                                                                  </td>
                                                                </tr>
                                                              </table>
                                                            </div>
                                                          </td>
                                                        </tr>
                                                      </ng-container>
                                                    </tbody>
                                                  </table>
                                                </div>
                                                <!--Appliance job-->
                                                <div class="col-md-12 tableDiv" *ngIf="layoutDetail.appliance_jobs.length>0">
                                                    <h6 class="mt-3 px-3">Appliances</h6>
                                                    <table class="table px-3">
                                                            <thead class="thead-dark">
                                                       <tr>
                                                        <th class="firstTh">#</th>
                                                          <th>Appliance Type</th>
                                                          <th>Appliance</th>
                                                          <th>Make</th>
                                                          <th>Vendor Sku</th>
                                                          <th>Quantity</th>
                                                          <th class="text-center lastTh">Image</th>
                                                        </tr>
                                                      </thead>
                                                      <tbody>
                                                       <tr *ngFor="let appjob of layoutDetail.appliance_jobs; let k1=index; ">
                                                         <td>{{k1+1}}</td>
                                                         <td>{{appjob.subcategory}}</td>
                                                         <td>{{appjob.name}}</td>
                                                         <td>{{appjob.make}}</td>
                                                         <td>{{appjob.vendor_sku}}</td>
                                                         <td>{{appjob.quantity}}</td>
                                                         <td>
                                                           <img src="{{appjob.image_url}}" *ngIf="appjob.image_url" style="width: 100px;" onerror="this.src='./assets/img/no_image.svg';" alt="Missing Image">
                                                         </td>
                                                       </tr>
                                                    </tbody>
                                                    </table>
                                                </div>
                                                <!--Extras job-->
                                                <div class="col-md-12 tableDiv" *ngIf="layoutDetail.extra_jobs.length>0">
                                                    <h6 class="mt-3 px-3">Extras</h6>
                                                    <table class="table px-3">
                                                            <thead class="thead-dark">
                                                       <tr>
                                                        <th class="firstTh">#</th>
                                                          <th>Name</th>
                                                          <th>Vendor Sku</th>
                                                          <th>Make</th>
                                                          <th>Specification </th>
                                                          <th>Quantity</th>
                                                          <th class="text-center lastTh">Image</th>
                                                        </tr>
                                                      </thead>
                                                      <tbody>
                                                       <tr *ngFor="let extrajob of layoutDetail.extra_jobs; let k2=index; ">
                                                         <td>{{k2+1}}</td>
                                                         <td>{{extrajob.name}}</td>
                                                         <td>{{extrajob.vendor_sku}}</td>
                                                         <td>{{extrajob.make}}</td>
                                                         <td>{{extrajob.specifications}}</td>
                                                         <td>{{extrajob.quantity}}</td>
                                                         <td>
                                                           <img src="{{extrajob.image_url}}" *ngIf="extrajob.image_url" style="width: 100px;" onerror="this.src='./assets/img/no_image.svg';" alt="Missing Image">
                                                         </td>
                                                       </tr>
                                                    </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>        
                                    </collapsible-table-row-detail> 
                                </ng-container>
                            </tbody>     
                        </collapsible-table>
                        <div class="text-center" *ngIf="layouts_list && layouts_list.length >0">
                            <pagination-controls autoHide="true" (pageChange)="current_page = getLayoutsList(importlayout_category,$event)"></pagination-controls>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Modal -->
<div class="modal fade" id="layoutCustomizationModal" tabindex="-1" role="dialog" aria-labelledby="layoutCustomizationModalLabel" aria-hidden="true"  data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title modalTitle" id="layoutCustomizationModalLabel">Customize Elements</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeLayoutCustomizationModal()">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body" *ngIf="customizationDetails">
                <div class="row">
                    <div class="col-md-12">
                        <label>Number Exposed Sites - </label>
                        <span>{{customizationDetails.number_exposed_sites}}</span>
                    </div>
                    <div class="col-md-12">
                        <fieldset *ngFor = "let item of customizationDetails.addons; let i=index ">
                            <div class="row mx-0 py-2 mb-2 addonrow" *ngIf="item.compulsory">
                                <div class="col-md-3">
                                    <label>Slot</label>
                                    <p class="rk-form-fontsize">{{item.slot}}</p>
                                </div>
                                <div class="col-md-3">
                                    <label>Addon</label>
                                    <p class="rk-form-fontsize">{{item.name}} - {{item.code}}</p>
                                </div>
                                <div class="col-md-2">
                                    <label>Quantity</label>
                                    <p class="rk-form-fontsize px-3">{{item.quantity}}</p>
                                </div>
                                <div class="col-md-4">
                                    <label>Image</label>
                                    <img src="{{item.addon_image}}" height="100px" width="100px" onerror="this.src='./assets/img/no_image.svg'" style="display: block;" *ngIf="item.addon_image">
                                </div>
                                <div class="col-md-12 mt-3" *ngFor="let item1 of customizationDetails.addons_for_addons">
                                    <ng-container *ngIf="item1.compulsory_addon_id==item.id">
                                        <div class="row mb-3 optaddonrow">
                                            <div class="col-5">
                                                <label>Optional Addon</label>
                                                <p class="rk-form-fontsize">{{item1.name}} - {{item1.code}}</p>
                                            </div>
                                            <div class="col-3">
                                                <label>Quantity</label>
                                                <p class="rk-form-fontsize px-3">{{item1.quantity}}</p>
                                            </div>
                                            <div class="col-md-4">
                                                <label>Image</label>
                                                <img src="{{item1.addon_image}}" height="100px" width="100px" onerror="this.src='./assets/img/no_image.svg'" style="display: block;" *ngIf="item1.addon_image">
                                            </div>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>
                            <div class="row mx-0 py-2 mb-2 addonrow" *ngIf="item.compulsory">
                                <div class="col-md-6">
                                  <label>Addon</label>
                                  <p class="rk-form-fontsize">{{item.name}} - {{item.code}}</p>
                                </div>
                                <div class="col-md-2">
                                  <label>Quantity</label>
                                  <p class="rk-form-fontsize px-3">{{item.quantity}}</p>
                                </div>
                                <div class="col-md-4">
                                  <label>Image</label>
                                  <img src="{{item.addon_image}}" height="100px" width="100px" onerror="this.src='./assets/img/no_image.svg'" style="display: block;" *ngIf="item.addon_image">
                                </div>
                            </div>
                        </fieldset>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="smartBoqModal" tabindex="-1" role="dialog" aria-labelledby="smartBoqModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header modalboxHeader">
                <h5 class="modal-title modalTitle" id="smartBoqModalLabel">Generate Smart BOQ</h5>
                <button type="button" class="close addCursor" data-dismiss="modal" aria-label="Close" (click)="closeSmartBoqModal()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <form [formGroup]="smart_boq_Form">
                    <div class="row">
                        <div class="col-md-12">
                            <label class="col-3">Enter Target Price <span class="text-danger">*</span></label>
                            <input type="number" name="" class="form-control d-inline col-3 rk-form-fontsize" formControlName="target_price" min="1">
                        </div>
                        <div class="col-md-12">
                            <fieldset formArrayName="category_data" class="mb-2">
                                <div *ngFor = "let item of smart_boq_Form.get('category_data')['controls']; let i=index " [formGroup]="item" class="row my-2">
                                    <div class="col-4">
                                        <label [attr.for]="'category_data_elem'+i">Select Category <span class="text-danger">*</span></label>
                                        <ng-select  [attr.id]="'category_data_elem'+i" formControlName="section_id">
                                           <ng-option value="">Select Category</ng-option>
                                           <ng-option *ngFor="let sc of categories_list_loosefur" value="{{sc.id}}" [disabled]="checkForRepetedCategory(sc.id)">{{sc.name}}</ng-option>
                                        </ng-select>
                                    </div>
                                    <div class="col-4">
                                        <label [attr.for]="'category_data-quantity'+i">Quantity <span class="text-danger">*</span></label>
                                        <input type="number" class="form-control rk-form-fontsize"
                                             [attr.id]="'category_data-quantity'+i" formControlName="quantity">
                                    </div>
                                    <div class="col-4 text-center">
                                        <i class="fa fa-minus nestedRemoveBtn addCursor" (click)="smart_boq_Form.get('category_data').removeAt(i)"></i>
                                    </div>
                                </div>
                            </fieldset>
                            <a (click)="addNestedElem_SmartBOQ()" class="mb-2 px-3 addCursor" style="color: blue;"><i class="fa fa-plus"> </i> Add Category</a>
                        </div>
                        <div class="col-md-12 text-right">
                            <button class="rk-interalBtnColor addCursor" (click)="generateSmartQuotation(smart_boq_Form.value)" [disabled]="!smart_boq_Form.valid" [ngClass]="{'cursor-notallowed':!smart_boq_Form.valid, 'addCursor':smart_boq_Form.valid}">Generate BOQ</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// /Users/shobhit/Documents/codes/arrivae-frontend/src/app/platform/quotation/view-loose-quote/view-loose-quote.component.html